(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-child-ann"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var tracks = scope.querySelectorAll('.cs-ann-track[data-cs-ann-auto]');
    for (var i = 0; i < tracks.length; i++) start(tracks[i]);
  }

  function start(track) {
    if (track.dataset.csAnnOn === '1') return;
    if (track.children.length < 2) return;
    track.dataset.csAnnOn = '1';

    var calm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    var wait = (parseFloat(track.dataset.csAnnSpeed) || 3) * 1000;
    var at = 0;
    var held = false;
    var timer = window.setInterval(function () {
      if (!track.isConnected) { window.clearInterval(timer); return; }
      if (held || document.hidden) return;
      if (calm && calm.matches) return;
      if (track.scrollWidth <= track.clientWidth + 2) return;
      var from = at;
      at = (at + 1) % track.children.length;
      var slide = track.children[at];
      if (!slide) return;
      var how = at === 0 && from !== 0 ? 'auto' : 'smooth';
      if (track.scrollTo) track.scrollTo({ left: slide.offsetLeft, behavior: how });
      else track.scrollLeft = slide.offsetLeft;
    }, wait);

    function hold() { held = true; }
    function free() { held = false; }
    track.addEventListener('pointerenter', hold);
    track.addEventListener('pointerleave', free);
    track.addEventListener('touchstart', hold, { passive: true });
    track.addEventListener('touchend', free, { passive: true });
    track.addEventListener('focusin', hold);
    track.addEventListener('focusout', free);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-child-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function parts(row) {
    return {
      d: row.querySelector('[data-cs-dfaq-details]'),
      s: row.querySelector('[data-cs-dfaq-summary]'),
      w: row.querySelector('[data-cs-dfaq-panel]')
    };
  }

  function rowsOf(list) {
    return [].slice.call(list.querySelectorAll('[data-cs-dfaq-row]'));
  }

  function once(el, fn) {
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      el.removeEventListener('transitionend', handler);
      fn();
    }
    function handler(ev) {
      if (ev.target !== el || ev.propertyName !== 'max-height') return;
      finish();
    }
    el.addEventListener('transitionend', handler);
    setTimeout(finish, 420);
  }

  function open(row, p) {
    p.d.open = true;
    row.classList.add('is-open');
    p.s.setAttribute('aria-expanded', 'true');
    if (REDUCE) { p.w.style.maxHeight = 'none'; return; }
    p.w.style.maxHeight = '0px';
    void p.w.offsetHeight;
    p.w.style.maxHeight = p.w.scrollHeight + 'px';
    once(p.w, function () {
      // let the panel grow with its content (images, resize) once it is fully open
      if (row.classList.contains('is-open')) p.w.style.maxHeight = 'none';
    });
  }

  function close(row, p) {
    row.classList.remove('is-open');
    p.s.setAttribute('aria-expanded', 'false');
    if (REDUCE) { p.w.style.maxHeight = '0px'; p.d.open = false; return; }
    p.w.style.maxHeight = p.w.scrollHeight + 'px';
    void p.w.offsetHeight;
    p.w.style.maxHeight = '0px';
    once(p.w, function () {
      // the row may have been reopened mid-animation
      if (!row.classList.contains('is-open')) p.d.open = false;
    });
  }

  function closeOthers(list, keep) {
    rowsOf(list).forEach(function (row) {
      if (row === keep) return;
      var p = parts(row);
      if (p.d && p.s && p.w && p.d.open) close(row, p);
    });
  }

  // the reference keeps its rows hidden until the band is scrolled to, then stagger them by --index
  function reveal(list, rows) {
    if (REDUCE || !('IntersectionObserver' in window) || !rows.length) return;
    var shown = false;
    var io = null;
    var safety = null;
    function show() {
      if (shown) return;
      shown = true;
      if (io) io.disconnect();
      if (safety) clearTimeout(safety);
      for (var i = 0; i < rows.length; i++) rows[i].classList.add('cs-dfaq-shown');
    }
    list.classList.add('cs-dfaq-reveal');
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { show(); return; }
      }
    }, { rootMargin: '0px 0px -60px 0px' });
    io.observe(list);
    // never leave the answers invisible if the observer never fires
    safety = setTimeout(show, 2500);
  }

  function setup(list) {
    if (!list || list.dataset.csDfaqOn === '1') return;
    list.dataset.csDfaqOn = '1';
    list.classList.add('cs-dfaq-js');
    var single = list.getAttribute('data-cs-dfaq-single') === '1';

    rowsOf(list).forEach(function (row) {
      var p = parts(row);
      if (!p.d || !p.s || !p.w) return;

      if (p.d.open) {
        row.classList.add('is-open');
        p.w.style.maxHeight = 'none';
        p.s.setAttribute('aria-expanded', 'true');
      } else {
        p.s.setAttribute('aria-expanded', 'false');
      }

      p.s.addEventListener('click', function (e) {
        // we drive the open state ourselves so the panel can animate both ways
        e.preventDefault();
        if (p.d.open && row.classList.contains('is-open')) {
          close(row, p);
        } else {
          if (single) closeOthers(list, row);
          open(row, p);
        }
      });
    });

    reveal(list, rowsOf(list));
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('[data-cs-dfaq]');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-child-flow"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORE = 'csChildFlow';
  var chosenWorld = new URLSearchParams(location.search).get('universe');
  var worldSelect = document.querySelector('[data-cs-form] [name=universe]');
  if (worldSelect && chosenWorld && Array.from(worldSelect.options).some(function(o){return o.value === chosenWorld;})) worldSelect.value = chosenWorld;
  // Les photos sont gardees a part : elles pesent, et la page d'apres n'a pas
  // besoin de les relire pour composer ses titres.
  var PHSTORE = 'csChildPhotos';
  var MAXPH = 2;
  var PHMAX = 1280;

  // Reduite dans le navigateur, puis en dataURL. Deux raisons, dans cet ordre :
  //   - c'est exactement ce que le worker des enfants recoit deja (un dataURL
  //     dans du JSON), donc rien a ecrire de son cote ;
  //   - un telephone sort des fichiers de 4 Mo. 1280 px suffisent au modele,
  //     et l'envoi passe sur un reseau de gare.
  function shrink(file, cb) {
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var k = Math.min(1, PHMAX / Math.max(img.width, img.height));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(img.width * k));
      c.height = Math.max(1, Math.round(img.height * k));
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      var out = '';
      try { out = c.toDataURL('image/jpeg', 0.82); } catch (e) {}
      cb(out);
    };
    img.onerror = function () { URL.revokeObjectURL(url); cb(''); };
    img.src = url;
  }

  function setup(root) {
    if (root.dataset.csFlowReady) return;
    root.dataset.csFlowReady = '1';

    var form = root.querySelector('[data-cs-form]');
    var steps = root.querySelectorAll('.cs-flow-step');
    var bar = root.querySelector('[data-cs-bar]');
    var back = root.querySelector('[data-cs-back]');
    var next = root.querySelector('[data-cs-next]');
    var nextLabel = root.querySelector('[data-cs-next-label]');
    var err = root.querySelector('[data-cs-err]');
    var wait = root.querySelector('[data-cs-wait]');
    var mk = root.querySelector('[data-cs-mk]');
    if (!form || !steps.length) return;

    // Les libelles viennent des attributs poses par Liquid : un bloc javascript
    // est mutualise entre toutes les sections, il ne peut pas les interpoler.
    var D = root.dataset;
    var CFG = {
      nextLabel: D.next || 'Next',
      lastLabel: D.last || 'Create our song',
      errRequired: D.errReq || 'Please fill this in before continuing.',
      errEmail: D.errEmail || 'That email address does not look right.',
      errSend: D.errSend || 'We could not send that. Check your connection and try again.'
    };
    var last = steps.length - 1;
    var i = 0;

    // Relues au chargement : un retour en arriere, un rechargement ou le
    // retour du POST natif ne doivent pas redemander un fichier deja donne.
    var shots = [];
    try {
      var kept = JSON.parse(window.sessionStorage.getItem(PHSTORE) || '[]');
      if (kept && kept.length) shots = kept.slice(0, MAXPH);
    } catch (e) {}

    function fill(el, map) {
      if (!el) return;
      var tpl = el.getAttribute('data-tpl') || el.textContent;
      var out = tpl;
      for (var k in map) out = out.split('{' + k + '}').join(map[k] || '');
      el.textContent = out;
    }

    function show(n) {
      for (var s = 0; s < steps.length; s++) steps[s].hidden = s !== n;
      // On re-declenche l'animation : sans ca, un ecran deja vu reapparait sec.
      steps[n].style.animation = 'none';
      void steps[n].offsetWidth;
      steps[n].style.animation = '';

      i = n;
      bar.style.width = ((n + 1) / steps.length * 100) + '%';
      back.hidden = n === 0;
      nextLabel.textContent = n === last ? CFG.lastLabel : CFG.nextLabel;
      err.hidden = true;

      if (n === last) {
        var name = (form.elements.their_name && form.elements.their_name.value || '').trim();
        fill(root.querySelector('[data-cs-s7sub]'), { name: name });
      }
      // Le haut de l'ecran, pas le haut du document : la barre reste visible.
      var top = root.getBoundingClientRect().top + window.pageYOffset - 12;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
      var first = steps[n].querySelector('input:not([type=radio]):not([type=checkbox]), textarea, select');
      if (first && window.matchMedia('(min-width:750px)').matches) first.focus();
    }

    function fail(field, msg) {
      err.textContent = msg;
      err.hidden = false;
      if (field && field.focus) field.focus();
      return false;
    }

    function valid(n) {
      var step = steps[n];
      var reqs = step.querySelectorAll('[data-req]');
      for (var r = 0; r < reqs.length; r++) {
        var f = reqs[r];
        if (f.type === 'checkbox' ? !f.checked : !f.value.trim()) {
          // Un message par champ quand il y en a un : « remplis ce champ » ne
          // veut rien dire devant une case a cocher ou un depot de photo.
          return fail(f, f.getAttribute('data-req-msg') || CFG.errRequired);
        }
        if (f.hasAttribute('data-email') && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.value.trim())) {
          return fail(f, CFG.errEmail);
        }
      }
      // Un groupe de radios n'a pas de champ requis : on verifie le groupe.
      var groups = {};
      var radios = step.querySelectorAll('input[type=radio]');
      for (var g = 0; g < radios.length; g++) groups[radios[g].name] = groups[radios[g].name] || radios[g];
      for (var key in groups) {
        if (!step.querySelector('input[name="' + key + '"]:checked')) {
          return fail(groups[key], CFG.errRequired);
        }
      }
      return true;
    }

    function answers() {
      var out = {};
      var f = form.elements;
      for (var n = 0; n < f.length; n++) {
        var el = f[n];
        if (!el.name || el.type === 'file') continue;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) continue;
        var v = el.type === 'checkbox' ? 'Yes' : el.value.trim();
        // Un champ vide n'a rien a faire dans le message : le telephone est
        // facultatif, et la precision d'occasion ne sert que si elle est la.
        if (v === '') continue;
        out[el.name] = v;
      }
      return out;
    }

    // Sans endpoint, les reponses partent par le formulaire de contact natif de
    // Shopify : elles arrivent dans la boite mail de la boutique, sans worker
    // ni application.
    //
    // Et c'est un VRAI envoi de formulaire, pas un fetch. Deux raisons, dans
    // cet ordre :
    //   - un fetch peut repondre 200 alors que Shopify a servi une page de
    //     captcha : rien n'est parti, et on annoncerait quand meme au client
    //     que son histoire est envoyee. Ici c'est Shopify qui tranche, et il
    //     ne renvoie sur ?contact_posted=true qu'en cas de reussite reelle.
    //   - si un captcha est demande, le visiteur le voit et peut le resoudre.
    // Ca coute un rechargement au tout dernier clic. On relit le parametre au
    // chargement pour retomber directement sur l'ecran final.
    function niceKey(k) {
      return k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' ');
    }

    // Tout est mis de cote, pas seulement le prenom : la page d'apres compose
    // ses titres avec le genre, la relation et l'occasion. Ca reste dans
    // l'onglet du visiteur, rien ne part ailleurs, et ca meurt avec l'onglet.
    // Gardees des le depot, pas seulement a l'envoi : un rechargement au
    // milieu du tunnel ne doit pas redemander un fichier deja donne.
    // Le quota peut refuser deux photos ; ce n'est pas bloquant, elles partent
    // quand meme avec l'envoi. On n'annule rien pour ca.
    function keepShots() {
      try {
        if (shots.length) window.sessionStorage.setItem(PHSTORE, JSON.stringify(shots));
      } catch (e) {}
    }

    function stash(data) {
      try { window.sessionStorage.setItem(STORE, JSON.stringify(data)); } catch (e) {}
      keepShots();
    }

    function sendNative(data) {
      stash(data);

      var lines = [];
      for (var k in data) if (k !== 'email') lines.push(niceKey(k) + ': ' + data[k]);
      var body = 'CHILD SONG REQUEST\n\n' + lines.join('\n');
      // Le formulaire de contact de Shopify ne sait pas porter de fichier. On
      // ne fait pas semblant : le message dit combien de photos ont ete
      // deposees, ou elles sont restees, et quoi remplir pour les recevoir.
      if (shots.length) {
        body += '\n\nPhotos: ' + shots.length + ' added by the visitor, but a Shopify'
          + ' contact form cannot carry files, so they stayed in their browser.'
          + ' Fill in the API URL of the flow section to receive them.';
      }

      var fields = {
        form_type: 'contact',
        utf8: '✓',
        'contact[email]': data.email || '',
        'contact[name]': (data.your_name || '') + ' & ' + (data.their_name || ''),
        'contact[body]': body
      };

      var f = document.createElement('form');
      f.method = 'post';
      f.action = '/contact#contact_form';
      f.hidden = true;
      for (var key in fields) {
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = key;
        h.value = fields[key];
        f.appendChild(h);
      }
      document.body.appendChild(f);
      f.submit();
    }

    // Un seul POST, un seul JSON : les reponses et les photos deja reduites en
    // dataURL. Pas de multipart — le worker des enfants lit deja ce format-la.
    function sendApi(url, data) {
      var out = {};
      for (var k in data) out[k] = data[k];
      if (shots[0]) out.photo = shots[0];
      if (shots[1]) out.photo2 = shots[1];
      out.photo_count = shots.length;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(out)
      });
    }

    // Le corps de la reponse, sans jamais faire echouer l'envoi pour ca. Un
    // 204, un corps vide ou du texte au lieu du JSON ne doivent pas afficher
    // « nous n'avons pas pu envoyer » a quelqu'un dont l'histoire est partie.
    function body(r) {
      try {
        if (!r || typeof r.json !== 'function') return Promise.resolve(null);
        return r.json().catch(function () { return null; });
      } catch (e) { return Promise.resolve(null); }
    }

    // L'attente prend la place du dernier champ, sur la meme page, AU CLIC :
    // c'est la suite immediate du dernier bouton, pas un accuse de reception.
    //
    // LA PAGE UNIQUE. Quand la preview est posee sous le tunnel (puis l'offre
    // et le reste), l'attente dure le temps de la barre : 2 min 30 par
    // defaut, la duree du clip d'attente. Barre pleine, tout s'ouvre dessous,
    // sans clic : la preview y poursuit sa fabrication si elle n'est pas
    // finie, et se devoile d'elle-meme quand elle est prete. Rien n'est
    // visible dessous avant la fin de la barre.
    //
    // Sans preview dessous (le tunnel seul sur sa page), la fin de la barre
    // ouvre la page de la preview, d'elle-meme elle aussi.
    //
    // La barre ne finit pas tant que la preview n'a pas ete lancee (le depot
    // des photos peut etre lent) : elle attend a 99 %. Le studio a une minute
    // au plus pour accepter l'envoi ; un echec ramene au formulaire, avec le
    // message.
    var MKEND = 'csChildMakeAt';     // l'echeance de la barre, posee au clic
    var WAITJOB = 'csChildWaitJob';  // la preview que cette attente a lancee
    var OPEN = 'csChildOpen';        // la page s'est ouverte pour elle
    var CAP = 60000;               // le temps laisse au studio pour accepter l'envoi

    function ss(k, v) {
      try {
        if (v === undefined) return window.sessionStorage.getItem(k);
        if (v === null) window.sessionStorage.removeItem(k);
        else window.sessionStorage.setItem(k, v);
      } catch (e) {}
      return null;
    }

    // La section de la preview, si elle est sur cette page.
    function previewHost() {
      var el = document.querySelector('[data-childsong-preview]');
      return el ? el.closest('.shopify-section') : null;
    }

    // La preview de la page se branche sur celle qui vient d'etre lancee. Sa
    // section a demarre au chargement, sans rien a suivre : on la remplace
    // par une copie neuve, rendue par Shopify, et on lui dit de redemarrer.
    // Elle lit alors la nouvelle preview d'elle-meme. Aucun de ses fichiers
    // n'est modifie : c'est l'evenement qu'elle ecoute deja.
    //
    // Et elle se devoile seule, comme une preview deja vue : pas de bouton
    // a toucher pour la voir.
    function couple(job) {
      // The ready preview waits for the visitor's Watch preview click.
      var host = previewHost();
      if (!host || !host.id) return Promise.resolve();
      // Dans l'adresse aussi, comme la page de l'associe la recoit : la preview
      // la lit la, meme si l'onglet refuse de garder quoi que ce soit.
      try { window.history.replaceState(window.history.state, '', '#preview=' + job.id + '.' + job.token); } catch (e) {}
      var id = host.id.replace(/^shopify-section-/, '');
      var old = host.querySelector('[data-childsong-preview]');
      var settled = false;
      var done;
      var ready = new Promise(function (r) { done = r; });
      function swap(fresh) {
        if (settled) return;
        settled = true;
        var cur = host.querySelector('[data-childsong-preview]');
        if (cur && fresh) {
          cur.parentNode.replaceChild(fresh, cur);
          host.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: id } }));
        }
        done();
      }
      // Si Shopify ne rend pas la section, une copie remise dans l'etat du
      // chargement fait la meme chose.
      function copy() {
        var el = old.cloneNode(true);
        el.removeAttribute('data-ready');
        el.setAttribute('data-view', 'loading');
        el.setAttribute('aria-busy', 'true');
        var l = el.querySelector('[data-loader]');
        if (l) l.hidden = false;
        var r = el.querySelector('[data-results]');
        if (r) r.hidden = true;
        return el;
      }
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('section_id', id);
      // Jamais plus de quatre secondes : au-dela, la copie fait l'affaire.
      setTimeout(function () { swap(copy()); }, 4000);
      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var got = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-childsong-preview]') : null;
          swap(got ? document.importNode(got, true) : copy());
        })
        .catch(function () { swap(copy()); });
      return ready;
    }

    // L'offre, dessous, lit le prenom au chargement de la page. Sur la page
    // unique il n'existe qu'apres le questionnaire : on la relance avec
    // l'evenement qu'elle ecoute deja, elle relit leurs reponses.
    function rename() {
      var all = document.querySelectorAll('[data-cs-pvo]');
      for (var i = 0; i < all.length; i++) {
        var host = all[i].closest('.shopify-section');
        if (!host) continue;
        all[i].removeAttribute('data-cs-pvo-ready');
        host.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true, detail: { sectionId: host.id.replace(/^shopify-section-/, '') }
        }));
      }
    }

    var watching = false;

    function finish(who, resume) {
      form.hidden = true;
      root.querySelector('.cs-flow-top').hidden = true;
      wait.hidden = true;
      if (!mk) return { ready: function () {}, stop: function () {} };
      mk.hidden = false;

      // Sur telephone le dernier bouton est tout en bas : l'attente, elle,
      // s'affiche en haut de l'ecran.
      if (!resume) {
        var top = root.getBoundingClientRect().top + window.pageYOffset - 12;
        if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }
      var done = !!(resume && resume.open);

      // La video n'est chargee qu'ici : inutile de la faire telecharger a
      // quelqu'un qui abandonnera au deuxieme ecran. Une attente deja finie
      // ne la relance pas.
      var v = mk.querySelector('.cs-flow-mk-v');
      if (v && !done) {
        var src = v.getAttribute('data-cs-mk-src');
        if (src && !v.src) v.src = src;
        // Un second essai (apres un refus) relance aussi le clip.
        if (v.src && v.muted && v.paused) { var pl = v.play(); if (pl && pl.catch) pl.catch(function () {}); }
      }

      // Aucun clip charge, mais leur photo est la : elle prend le cadre. C'est
      // leur attente, pas un rectangle vide, et ca leur prouve d'un coup d'oeil
      // que la photo est bien partie avec le reste.
      var slot = mk.querySelector('.cs-flow-mk-empty');
      if (slot && shots[0]) {
        slot.classList.remove('cs-flow-mk-empty');
        slot.classList.add('cs-flow-mk-mine');
        slot.textContent = '';
        var ph = document.createElement('img');
        ph.className = 'cs-flow-mk-ph';
        ph.alt = '';
        ph.src = shots[0];
        slot.appendChild(ph);
      } else if (slot) {
        // Ni clip ni photo (au retour sur la page, la photo n'est plus
        // gardee) : le cadre vide et sa consigne sont pour le marchand, pas
        // pour un client.
        slot.hidden = true;
      }
      var mine = mk.querySelector('.cs-flow-mk-ph');
      if (mine && shots[0] && mine.src !== shots[0]) mine.src = shots[0];

      // Leur chanson passe avant le clip d'attente.
      if (v && !watching) {
        watching = true;
        document.addEventListener('play', function (e) {
          var t = e.target;
          if (t !== v && t && t.closest && t.closest('[data-childsong-preview]') && !v.paused) v.pause();
        }, true);
      }

      var secs = parseFloat(root.getAttribute('data-mk-sec') || '150') || 150;
      var fillBar = mk.querySelector('[data-cs-mk-fill]');
      var pctEl = mk.querySelector('[data-cs-mk-pct]');
      var stageEl = mk.querySelector('[data-cs-mk-stage]');
      var clockEl = mk.querySelector('[data-cs-mk-clock]');
      var noteEl = mk.querySelector('[data-cs-mk-note]');
      var readyEl = mk.querySelector('[data-cs-mk-ready]');

      var stages = [];
      var raw = (root.getAttribute('data-mk-stages') || '').split('|');
      for (var n = 0; n < raw.length; n++) { if (raw[n].trim()) stages.push(raw[n].trim()); }

      // L'echeance est posee une seule fois, au clic, et gardee dans l'onglet :
      // un rechargement ne la fait pas repartir.
      var end = parseInt(ss(MKEND) || '0', 10);
      if (!end || isNaN(end)) {
        end = Date.now() + secs * 1000;
        ss(MKEND, String(end));
      }

      var job = null;
      var opened = false;
      var stopped = false;
      var tick = 0;

      function open() {
        if (opened) return;
        opened = true;
        clearInterval(tick);
        ss(OPEN, '1');
        if (noteEl) noteEl.hidden = true;
        var host = previewHost();
        if (!host) {
          // Rien dessous : la page de la preview s'ouvre d'elle-meme.
          var base = (root.getAttribute('data-next-page') || '').trim() || '/pages/childsong-preview';
          var target = new URL(base, window.location.origin);
          target.hash = 'preview=' + job.id + '.' + job.token;
          var theme = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (theme) target.searchParams.set('preview_theme_id', theme);
          window.location.assign(target.href);
          return;
        }
        document.documentElement.removeAttribute('data-cs-child-gate');
        if (readyEl) readyEl.hidden = false;
        // On descend jusqu'a la preview, doucement, sans rien demander. Pas
        // au retour sur une page deja ouverte : le navigateur remet deja la
        // page ou elle etait.
        if (!done) {
          setTimeout(function () { host.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250);
        }
      }

      function paint() {
        if (stopped) return;
        var left = Math.max(0, (end - Date.now()) / 1000);
        var p = done ? 100 : Math.max(0, Math.min(100, (1 - left / secs) * 100));
        // Pas de 100 % tant que la preview n'est pas lancee.
        if (!job) p = Math.min(p, 99);
        if (fillBar) fillBar.style.width = p + '%';
        if (pctEl) pctEl.textContent = Math.floor(p) + '%';
        if (clockEl) {
          // Arrondir les secondes AVANT de decouper : arrondir le reste donnait
          // « 04:60 » quand il restait 4 min 59,7 s.
          var whole = done ? 0 : Math.round(left);
          clockEl.textContent = ('0' + Math.floor(whole / 60)).slice(-2) + ':'
            + ('0' + (whole % 60)).slice(-2);
        }
        if (stageEl && stages.length) {
          var k = Math.min(stages.length - 1, Math.floor(p / (100 / stages.length)));
          if (stageEl.textContent !== stages[k]) stageEl.textContent = stages[k];
        }
        if (!job || (left > 0 && !done)) return;
        open();
      }

      paint();
      tick = setInterval(paint, 250);

      var snd = mk.querySelector('[data-cs-mk-sound]');
      if (snd && v && !snd.dataset.csWired) {
        snd.dataset.csWired = '1';
        snd.addEventListener('click', function (e) {
          e.stopPropagation();
          v.muted = false;
          v.play();
          snd.hidden = true;
        });
        mk.querySelector('.cs-flow-mk-stage').addEventListener('click', function () {
          if (v.paused) { v.play(); } else { v.pause(); }
        });
      }

      return {
        ready: function (j) { job = j; paint(); },
        stop: function () {
          stopped = true;
          clearInterval(tick);
          if (v && !v.paused) v.pause();
        }
      };
    }

    var submitting = false;
    function submit() {
      if (submitting) return;
      var data = answers();
      var url = (root.getAttribute('data-api') || '').trim();
      if (window.Shopify && window.Shopify.designMode) {
        err.textContent = 'Open the theme preview in a separate tab to test generation.';
        err.hidden = false;
        return;
      }
      if (!window.CraftStoryChildSong) {
        err.textContent = 'The preview studio is still loading. Please try again.';
        err.hidden = false;
        return;
      }
      submitting = true;
      next.disabled = true;
      err.hidden = true;
      stash(data);
      rename();

      // Une nouvelle attente : rien de la precedente ne compte plus, et le
      // bas de la page se referme jusqu'a la fin de celle-ci.
      ss(MKEND, null);
      ss(WAITJOB, null);
      ss(OPEN, null);
      if (previewHost()) document.documentElement.setAttribute('data-cs-child-gate', 'closed');

      var run = finish({ name: data.their_name, email: data.email });
      var limit = setTimeout(function () { fail(null); }, CAP);

      function fail(error) {
        clearTimeout(limit);
        if (!submitting) return;
        submitting = false;
        run.stop();
        ss(MKEND, null);
        next.disabled = false;
        nextLabel.textContent = CFG.lastLabel;
        if (mk) mk.hidden = true;
        form.hidden = false;
        root.querySelector('.cs-flow-top').hidden = false;
        // Le message du studio quand il en donne un ; jamais celui du
        // navigateur (« signal timed out », « Failed to fetch »...).
        var tech = !error || /^(TypeError|TimeoutError|AbortError)$/.test(error.name || '');
        err.textContent = (!tech && error.message) || CFG.errSend;
        err.hidden = false;
      }

      window.CraftStoryChildSong.start(url, data, shots).then(function (job) {
        // Trop tard : l'attente a deja rendu la main au formulaire.
        if (!submitting) return;
        clearTimeout(limit);
        ss(WAITJOB, job.id);
        couple(job).then(function () { if (submitting) run.ready(job); });
      }).catch(fail);
    }

    next.addEventListener('click', function () {
      if (!valid(i)) return;
      if (i === last) submit(); else show(i + 1);
    });
    back.addEventListener('click', function () { if (i > 0) show(i - 1); });

    // Entree fait avancer, sauf dans une zone de texte ou elle sert a aller a la ligne.
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA') return;
      e.preventDefault();
      next.click();
    });

    // Un choix de carte sur la landing page arrive en ?occasion=… : on le coche.
    try {
      var want = new URLSearchParams(window.location.search).get('occasion');
      if (want) {
        var opts = form.querySelectorAll('input[name=occasion]');
        for (var o = 0; o < opts.length; o++) {
          if (opts[o].value.toLowerCase() === want.toLowerCase()) { opts[o].checked = true; break; }
        }
      }
    } catch (e) {}

    // Le champ libre suit les boutons de SON fieldset : rien a declarer, il
    // suffit qu'il soit au bon endroit dans le balisage.
    var more = form.querySelector('[data-cs-more]');
    if (more) {
      var moreInput = more.querySelector('input');
      var moreFor = (more.getAttribute('data-cs-more') || '').toLowerCase();
      var moreGroup = more.closest('fieldset').querySelectorAll('input[type=radio]');
      var syncMore = function () {
        var on = false;
        for (var m = 0; m < moreGroup.length; m++) {
          if (moreGroup[m].checked && moreGroup[m].value.toLowerCase() === moreFor) on = true;
        }
        more.hidden = !on;
        if (on) {
          moreInput.setAttribute('data-req', '');
        } else {
          // On vide en refermant, sinon une precision abandonnee part quand meme.
          moreInput.removeAttribute('data-req');
          moreInput.value = '';
        }
      };
      for (var m2 = 0; m2 < moreGroup.length; m2++) moreGroup[m2].addEventListener('change', syncMore);
      syncMore();
    }

    var photoEl = form.querySelector('[data-cs-photo]');
    var prevBox = form.querySelector('[data-cs-photo-prev]');
    var labelEl = form.querySelector('[data-cs-photo-label]');
    var baseLabel = labelEl ? labelEl.textContent : '';

    function paintShots() {
      if (prevBox) {
        prevBox.innerHTML = '';
        for (var n = 0; n < shots.length; n++) {
          var im = document.createElement('img');
          im.src = shots[n];
          im.alt = '';
          prevBox.appendChild(im);
        }
        prevBox.setAttribute('data-n', String(shots.length));
        prevBox.hidden = !shots.length;
      }
      if (labelEl) {
        labelEl.textContent = shots.length > 1 ? (D.phTwo || baseLabel)
          : shots.length ? (D.phOne || baseLabel) : baseLabel;
      }
      // Le champ fichier perd son obligation des qu'une photo est gardee. Il
      // faut ce detour : apres un rechargement il est toujours vide, alors que
      // la photo, elle, est encore la. Sans ca l'ecran redemanderait un
      // fichier deja fourni.
      if (photoEl) {
        if (shots.length) photoEl.removeAttribute('data-req');
        else photoEl.setAttribute('data-req', '');
      }
    }

    if (photoEl) {
      photoEl.addEventListener('change', function () {
        var picked = photoEl.files ? Array.prototype.slice.call(photoEl.files) : [];
        if (!picked.length) return;
        var over = picked.length > MAXPH;
        picked = picked.slice(0, MAXPH);

        // On repart de la selection en cours a chaque fois : un champ fichier
        // remplace son contenu, les vignettes doivent dire la meme chose.
        var got = [];
        var left = picked.length;
        picked.forEach(function (f, n) {
          shrink(f, function (url) {
            if (url) got[n] = url;
            if (--left) return;
            var keep = [];
            for (var g = 0; g < got.length; g++) if (got[g]) keep.push(got[g]);
            shots = keep;
            keepShots();
            paintShots();
            if (over && D.phMax) { err.textContent = D.phMax; err.hidden = false; }
            else { err.hidden = true; }
          });
        });
      });
      paintShots();
    }

    // « Back to the questionnaire », dans la preview : sur cette page meme,
    // c'est repartir de zero, pas recharger l'attente deja faite.
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-childsong-preview] a[href]') : null;
      if (!a) return;
      var u;
      try { u = new URL(a.getAttribute('href'), window.location.href); } catch (x) { return; }
      if (u.origin !== window.location.origin || u.pathname !== window.location.pathname) return;
      e.preventDefault();
      ss(MKEND, null);
      ss(WAITJOB, null);
      ss(OPEN, null);
      ss('csChildSongPreview', null);
      ss('csChildSongRevealed', null);
      window.location.assign(window.location.pathname + window.location.search);
    });

    // Retour sur la page (rechargement, bouton retour) : l'attente reprend
    // ou elle en etait, et une page deja ouverte le reste. Seulement pour la
    // preview que CE tunnel a lancee dans cet onglet.
    var saved = null;
    try { saved = JSON.parse(ss('csChildSongPreview') || 'null'); } catch (e) {}
    document.documentElement.removeAttribute('data-cs-child-resume');
    if (saved && saved.id && saved.token && ss(WAITJOB) === saved.id && ss(OPEN) === '1' && !previewHost()) {
      // Le tunnel seul, et sa preview deja ouverte ailleurs : retour ici = un
      // nouveau questionnaire, pas un rebond vers la page de la preview.
      ss(MKEND, null);
      ss(WAITJOB, null);
      ss(OPEN, null);
      saved = null;
    }
    if (saved && saved.id && saved.token && ss(WAITJOB) === saved.id) {
      var st = {};
      try { st = JSON.parse(ss(STORE) || '{}') || {}; } catch (e) {}
      submitting = true;
      finish({ name: st.their_name || '', email: st.email || '' }, { open: ss(OPEN) === '1' }).ready(saved);
      return;
    }

    show(0);
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var all = host.querySelectorAll('[data-cs-flow]');
    for (var i = 0; i < all.length; i++) setup(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-child-head"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.csChildHeadBound) return;
  window.csChildHeadBound = true;

  var LOCK = 'cs-head-locked';
  var lastTrigger = null;

  function root(el) { return el ? el.closest('[data-cs-head]') : null; }
  function drawer(r) { return r ? r.querySelector('[data-cs-head-drawer]') : null; }
  function panel(r) { return r ? r.querySelector('[data-cs-head-panel]') : null; }
  function toggleBtn(r) { return r ? r.querySelector('[data-cs-head-toggle]') : null; }

  function anyOpen() { return document.querySelector('[data-cs-head].cs-dhd-open'); }

  function lock(on) {
    try {
      if (on) document.documentElement.classList.add(LOCK);
      else if (!anyOpen()) document.documentElement.classList.remove(LOCK);
    } catch (e) {}
  }

  function focusable(p) {
    if (!p) return [];
    var sel = 'a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(p.querySelectorAll(sel), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function open(r, trigger) {
    if (!r || r.classList.contains('cs-dhd-open')) return;
    lastTrigger = trigger || toggleBtn(r);
    r.classList.add('cs-dhd-open');
    var d = drawer(r);
    if (d) d.removeAttribute('aria-hidden');
    var t = toggleBtn(r);
    if (t) t.setAttribute('aria-expanded', 'true');
    lock(true);
    var p = panel(r);
    if (p) { try { p.focus(); } catch (e) {} }
  }

  function close(r) {
    if (!r || !r.classList.contains('cs-dhd-open')) return;
    r.classList.remove('cs-dhd-open');
    var d = drawer(r);
    if (d) d.setAttribute('aria-hidden', 'true');
    var t = toggleBtn(r);
    if (t) t.setAttribute('aria-expanded', 'false');
    lock(false);
    var back = lastTrigger && document.contains(lastTrigger) ? lastTrigger : t;
    lastTrigger = null;
    if (back) { try { back.focus(); } catch (e) {} }
  }

  function toggleSearch(r, btn) {
    if (!r) return;
    var on = r.classList.toggle('cs-dhd-searchon');
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    var sp = r.querySelector('[data-cs-head-searchpanel]');
    if (sp) {
      if (on) sp.removeAttribute('aria-hidden');
      else sp.setAttribute('aria-hidden', 'true');
    }
    var input = sp && sp.querySelector('input[type="search"]');
    if (on && input) { try { input.focus(); } catch (e) {} }
    else if (!on && btn) { try { btn.focus(); } catch (e) {} }
  }

  // Delegated, so it survives a theme-editor re-render of the section.
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-cs-head-toggle]') : null;
    if (t) {
      e.preventDefault();
      var r = root(t);
      if (r && r.classList.contains('cs-dhd-open')) close(r); else open(r, t);
      return;
    }
    var c = e.target.closest ? e.target.closest('[data-cs-head-close]') : null;
    if (c) { e.preventDefault(); close(root(c)); return; }
    var s = e.target.closest ? e.target.closest('[data-cs-head-search]') : null;
    if (s) { e.preventDefault(); toggleSearch(root(s), s); return; }
  });

  document.addEventListener('keydown', function (e) {
    var r = anyOpen();
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (r) { e.preventDefault(); close(r); return; }
      var sr = document.querySelector('[data-cs-head].cs-dhd-searchon');
      if (sr) { sr.classList.remove('cs-dhd-searchon'); }
      return;
    }
    if (e.key !== 'Tab' || !r) return;
    var items = focusable(panel(r));
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (!panel(r).contains(active)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var stuck = (window.pageYOffset || document.documentElement.scrollTop || 0) > 4;
      Array.prototype.forEach.call(document.querySelectorAll('[data-cs-head].cs-dhd-sticky'), function (r) {
        r.classList.toggle('cs-dhd-stuck', stuck);
      });
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  document.addEventListener('shopify:section:load', function (e) {
    onScroll();
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-cs-head]') : null;
    if (r) lock(false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-child-hero"] && !Shopify.designMode) return;
  try {
    
/* Hero clip controller. Every node is resolved inside its own section root, so
   two hero instances on one page never touch each other's video. */
(function () {
  function init(root) {
    if (!root || root.dataset.csDhInit) { return; }
    root.dataset.csDhInit = '1';

    var stage = root.querySelector('[data-cs-dh-stage]');
    if (!stage) { return; }
    var vid = stage.querySelector('video');
    if (!vid) { return; }

    var cover = stage.querySelector('[data-cs-dh-trigger]');
    var banner = stage.querySelector('[data-cs-dh-unmute]');
    var controls = stage.querySelector('[data-cs-dh-controls]');
    var playBtn = stage.querySelector('[data-cs-dh-playbtn]');
    var playIcon = stage.querySelector('[data-cs-dh-playicon]');
    var pauseIcon = stage.querySelector('[data-cs-dh-pauseicon]');
    var muteBtn = stage.querySelector('[data-cs-dh-mutebtn]');
    var mutedIcon = stage.querySelector('[data-cs-dh-mutedicon]');
    var unmutedIcon = stage.querySelector('[data-cs-dh-unmutedicon]');
    var progress = stage.querySelector('[data-cs-dh-progress]');
    var progressFill = stage.querySelector('[data-cs-dh-progressfill]');
    var auto = stage.hasAttribute('data-cs-dh-auto');

    function inside(node, target) {
      return !!node && (node === target || node.contains(target));
    }

    /* one retry: a play() rejected by the autoplay policy usually succeeds on the
       second attempt once the tap has been registered as a user gesture */
    function play() {
      var p = vid.play();
      if (p && p.catch) {
        p.catch(function () {
          setTimeout(function () {
            var again = vid.play();
            if (again && again.catch) { again.catch(function () {}); }
          }, 60);
        });
      }
    }

    function syncPlay() {
      if (playIcon) { playIcon.style.display = vid.paused ? 'block' : 'none'; }
      if (pauseIcon) { pauseIcon.style.display = vid.paused ? 'none' : 'block'; }
      if (playBtn) { playBtn.setAttribute('aria-label', vid.paused ? 'Play video' : 'Pause video'); }
    }

    function syncMute() {
      if (mutedIcon) { mutedIcon.style.display = vid.muted ? 'block' : 'none'; }
      if (unmutedIcon) { unmutedIcon.style.display = vid.muted ? 'none' : 'block'; }
      if (muteBtn) { muteBtn.setAttribute('aria-label', vid.muted ? 'Unmute video' : 'Mute video'); }
      /* the pill comes back the moment the viewer mutes again */
      if (banner) { banner.classList.toggle('cs-dh-hidden', !vid.muted); }
    }

    function unmuteTap(e) {
      e.preventDefault();
      e.stopPropagation();
      vid.muted = false;
      syncMute();
      play();
    }

    if (banner) {
      banner.addEventListener('pointerdown', unmuteTap);
      banner.addEventListener('click', unmuteTap);
    }

    /* poster overlay, only rendered when silent autoplay is switched off */
    if (cover) {
      cover.addEventListener('click', function () {
        stage.classList.add('cs-dh-playing');
        try { vid.setAttribute('controls', ''); } catch (err) {}
        play();
        try { vid.focus(); } catch (err) {}
      });
    }

    if (!auto) {
      syncPlay();
      return;
    }

    try {
      vid.setAttribute('disableremoteplayback', '');
      vid.setAttribute('controlslist', 'noremoteplayback');
      vid.setAttribute('x-webkit-airplay', 'deny');
    } catch (err) {}

    function togglePlay() {
      if (vid.paused) {
        play();
      } else {
        vid.volume = 0; /* drop the audio buffer instantly */
        vid.pause();
        vid.volume = 1; /* restore it for the next play */
      }
    }

    /* pointerdown, not click: the clip responds on press rather than on release */
    var lastPointer = 0;
    stage.addEventListener('pointerdown', function (e) {
      var t = e.target;
      lastPointer = Date.now();

      if (inside(banner, t)) { e.preventDefault(); return; }

      if (inside(muteBtn, t)) {
        vid.muted = !vid.muted;
        syncMute();
        e.preventDefault();
        return;
      }

      if (inside(progress, t)) {
        var rect = progress.getBoundingClientRect();
        if (vid.duration && rect.width) {
          var ratio = (e.clientX - rect.left) / rect.width;
          if (ratio < 0) { ratio = 0; }
          if (ratio > 1) { ratio = 1; }
          vid.currentTime = ratio * vid.duration;
        }
        e.preventDefault();
        return;
      }

      /* play button, video surface or anywhere else on the stage: toggle */
      togglePlay();
      e.preventDefault();
    });

    /* the bar above is driven by pointerdown, which leaves the two buttons inert
       for a keyboard user; a click that no pointerdown preceded is that user */
    function keyboardOnly(fn) {
      return function (e) {
        if (Date.now() - lastPointer < 500) { return; }
        fn();
        e.preventDefault();
      };
    }
    if (playBtn) { playBtn.addEventListener('click', keyboardOnly(togglePlay)); }
    if (muteBtn) {
      muteBtn.addEventListener('click', keyboardOnly(function () {
        vid.muted = !vid.muted;
        syncMute();
      }));
    }

    vid.addEventListener('play', syncPlay);
    vid.addEventListener('pause', syncPlay);
    vid.addEventListener('timeupdate', function () {
      if (progressFill && vid.duration) {
        progressFill.style.width = (vid.currentTime / vid.duration) * 100 + '%';
      }
    });

    /* show the bar for three seconds on load, so a touch viewer who never
       hovers still learns the controls are there */
    if (controls) {
      controls.classList.add('cs-dh-visible');
      setTimeout(function () { controls.classList.remove('cs-dh-visible'); }, 3000);
    }

    syncPlay();
    syncMute();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cs-dh-root]');
    Array.prototype.forEach.call(roots, init);
    if (scope && scope.hasAttribute && scope.hasAttribute('data-cs-dh-root')) { init(scope); }
  }

  initAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-child-pv-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.csPvoReady) return;
    // The questionnaire refreshes this section to insert the recipient's name.
    // Remove the previous handlers before binding the refreshed section.
    if (root.csPvoCleanup) root.csPvoCleanup();
    root.dataset.csPvoReady = '1';

    // Le prenom vient des reponses mises de cote par le tunnel dans l'onglet,
    // et a defaut de ?name= pour qu'un lien partage reste lisible. Sans lui, on
    // retire le gabarit plutot que de laisser un trou dans la phrase.
    var name = '';
    try {
      var a = JSON.parse(window.sessionStorage.getItem('csChildFlow') || '{}') || {};
      name = (a.their_name || '').trim();
    } catch (e) {}
    if (!name) {
      try { name = (new URLSearchParams(window.location.search).get('name') || '').trim(); } catch (e) {}
    }
    var tpl = root.querySelectorAll('[data-cs-tpl]');
    for (var i = 0; i < tpl.length; i++) {
      var t = tpl[i].getAttribute('data-cs-orig') || tpl[i].textContent;
      tpl[i].setAttribute('data-cs-orig', t);
      tpl[i].textContent = name
        ? t.split('{name}').join(name)
        : t.replace(/\{name\}'?s?\s*/g, '').replace(/\s+/g, ' ').trim();
      if (!tpl[i].textContent) tpl[i].hidden = true;
    }

    // Preserve the configured fallback link; configured variants use the cart.
    var base = (root.getAttribute('data-base') || '').trim();
    var gos = root.querySelectorAll('[data-cs-go]');
    var addon = root.querySelector('[data-cs-addon]');

    function link() {
      if (!base || base === '#') return;
      var speed = root.querySelector('[data-cs-speed]:checked');
      var q = [];
      if (speed) q.push('speed=' + encodeURIComponent(speed.value));
      if (addon && addon.checked) q.push('addon=' + encodeURIComponent(addon.value || '1'));
      if (name) q.push('name=' + encodeURIComponent(name));
      var url = base;
      if (q.length) url += (base.indexOf('?') > -1 ? '&' : '?') + q.join('&');
      for (var g = 0; g < gos.length; g++) gos[g].setAttribute('href', url);
    }

    var inputs = root.querySelectorAll('[data-cs-speed], [data-cs-addon]');
    for (var n = 0; n < inputs.length; n++) inputs[n].addEventListener('change', link);
    link();



    var promo = root.querySelector('[data-cs-offer-promo]');
    var offerInterval = null, offerDeadline = 0, offerKey = '', offerPreview = '';
    var offerCopy = promo ? JSON.parse(promo.querySelector('[data-cs-offer-copy]').textContent) : {};
    function storedDeadline(key) {
      try { var local = Number(localStorage.getItem(key)); if (local) return local; } catch (_) {}
      try { return Number(sessionStorage.getItem(key)) || 0; } catch (_) {}
      return 0;
    }
    function saveDeadline(key, value) {
      try { localStorage.setItem(key, String(value)); } catch (_) {}
      try { sessionStorage.setItem(key, String(value)); } catch (_) {}
    }
    function offerTick() {
      if (!promo || !offerDeadline) return;
      var seconds = Math.max(0, Math.ceil((offerDeadline - Date.now()) / 1000));
      var clock = promo.querySelector('[data-cs-offer-clock]');
      clock.textContent = Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
      var ended = seconds === 0;
      clock.hidden = ended;
      promo.querySelector('[data-cs-offer-timer]').classList.toggle('is-ended', ended);
      promo.querySelector('[data-cs-offer-heading]').textContent = ended ? offerCopy.expired_heading : offerCopy.timer_heading;
      promo.querySelector('[data-cs-offer-note]').textContent = ended ? offerCopy.expired_note : offerCopy.timer_note;
      if (ended) { clearInterval(offerInterval); offerInterval = null; }
    }
    function startOffer(id) {
      if (!promo || !/^[a-f0-9]{64}$/.test(id || '')) return;
      var minutes = Math.max(5, Math.min(60, Number(root.dataset.offerMinutes) || 30));
      var draft = window.Shopify && Shopify.theme && Shopify.theme.role !== 'main';
      var nextKey = (draft ? 'csSongOfferTestV1:' : 'csSongOfferV1:') + id;
      if (offerPreview !== id) {
        clearInterval(offerInterval); offerInterval = null;
        offerKey = nextKey; offerPreview = id;
        offerDeadline = storedDeadline(offerKey) || Date.now() + minutes * 60000;
        saveDeadline(offerKey, offerDeadline);
      }
      promo.hidden = false;
      offerTick();
      if (!offerInterval && offerDeadline > Date.now()) offerInterval = setInterval(offerTick, 1000);
    }
    function offerRevealed(e) { if (e.detail && e.detail.status === 'ready') startOffer(e.detail.id); }
    function offerStorage(e) {
      if (e.key !== offerKey || !Number(e.newValue)) return;
      offerDeadline = Math.min(offerDeadline, Number(e.newValue)); offerTick();
    }
    function resumeOffer() { if (offerPreview) startOffer(offerPreview); }
    function pauseOffer() { clearInterval(offerInterval); offerInterval = null; }
    document.addEventListener('craftstory:preview-revealed', offerRevealed);
    window.addEventListener('storage', offerStorage);
    window.addEventListener('pageshow', resumeOffer);
    window.addEventListener('pagehide', pauseOffer);
    var opened = document.querySelector('[data-childsong-preview][data-view="result"][data-preview-state="ready"]');
    if (opened) startOffer(opened.dataset.previewId);
    if (promo && window.Shopify && Shopify.designMode) promo.hidden = false;

    var errEl=root.querySelector('[data-cs-cart-err]');
    function kept(key){try{return JSON.parse(window.sessionStorage.getItem(key)||'null')||{};}catch(_){return {};}}
    function properties(){
      var a=kept('csChildFlow'),preview=kept('csChildSongPreview'),out={};
      [['For','their_name'],['From','your_name'],['Child’s age','child_age'],['Favorite world','universe'],['Occasion','occasion'],['Song language','language'],['Genre','genre'],['Voice','voice']].forEach(function(pair){if(a[pair[1]])out[pair[0]]=String(a[pair[1]]).slice(0,250);});
      if(/^[a-f0-9]{64}$/.test(preview.id||'')){
        out['_Preview ID']=preview.id;
        if(/^[a-f0-9]{64}$/.test(preview.token||''))out['_Preview token']=preview.token;
        if(/^[a-f0-9]{64}$/.test(preview.token||''))out['_Preview link']=window.location.origin+'/pages/childsong-preview#preview='+preview.id+'.'+preview.token;
      }
      var funnel=window.CraftStoryChildFunnel&&window.CraftStoryChildFunnel.sessionId();if(funnel)out['_Funnel session']=funnel;
      return out;
    }
    function checkout(e){
      var speed=root.querySelector('[data-cs-speed]:checked'),vid=speed?(speed.getAttribute('data-variant')||'').replace(/\D+/g,''):'';
      if(!vid)return;
      e.preventDefault();if(root.csPvoBusy)return;root.csPvoBusy=true;if(errEl)errEl.hidden=true;
      for(var g=0;g<gos.length;g++){gos[g].setAttribute('aria-busy','true');gos[g].setAttribute('aria-disabled','true');}
      var props=properties(),items=[{id:Number(vid),quantity:1,properties:props}];
      var aid=addon&&addon.checked?(addon.getAttribute('data-variant')||'').replace(/\D+/g,''):'';
      if(aid)items.push({id:Number(aid),quantity:1,properties:props['_Preview ID']?{'_Preview ID':props['_Preview ID']}:{}});
      var cartRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      fetch(cartRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:items})}).then(function(r){
        if(!r.ok)throw new Error('HTTP '+r.status);if(window.CraftStoryChildFunnel)window.CraftStoryChildFunnel.track('checkout_clicked',props['_Preview ID']);window.location.href=cartRoot+'checkout';
      }).catch(function(){root.csPvoBusy=false;for(var h=0;h<gos.length;h++){gos[h].removeAttribute('aria-busy');gos[h].removeAttribute('aria-disabled');}if(errEl)errEl.hidden=false;});
    }
    for(var c=0;c<gos.length;c++)gos[c].addEventListener('click',checkout);

    // La barre du bas n'apparait qu'une fois le bouton principal passe : sinon
    // elle double un bouton deja visible a l'ecran.
    var bar = root.querySelector('[data-cs-bar]');
    var main = root.querySelector('.cs-pvo-cta');
    var observer;
    if (bar && main && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (es) {
        bar.hidden = es[0].isIntersecting || es[0].boundingClientRect.top > 0;
      }, { threshold: 0 });
      observer.observe(main);
    }
    root.csPvoCleanup = function () {
      pauseOffer();
      document.removeEventListener('craftstory:preview-revealed', offerRevealed);
      window.removeEventListener('storage', offerStorage);
      window.removeEventListener('pageshow', resumeOffer);
      window.removeEventListener('pagehide', pauseOffer);
      for (var n = 0; n < inputs.length; n++) inputs[n].removeEventListener('change', link);
      for (var c = 0; c < gos.length; c++) gos[c].removeEventListener('click', checkout);
      if (observer) observer.disconnect();
    };
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var all = host.querySelectorAll('[data-cs-pvo]');
    for (var i = 0; i < all.length; i++) setup(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-child-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Un seul clip a le son sur toute la page.
  var loud = null;

  function quiet() {
    if (!loud) return;
    loud.video.muted = true;
    loud.card.classList.remove('cs-reel-loud');
    loud = null;
  }

  function setup(rail) {
    if (rail.dataset.csReelReady) return;
    rail.dataset.csReelReady = '1';

    var cards = rail.querySelectorAll('[data-cs-reel-card]');
    if (!cards.length) return;

    // Cinquante-six MP4 charges d'un coup mettraient la page a genoux. La
    // source n'est posee que quand le clip approche de l'ecran, et retiree
    // quand il s'en eloigne pour rendre la memoire.
    var near = null;
    if ('IntersectionObserver' in window) {
      near = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var card = entries[i].target;
          var v = card.querySelector('.cs-reel-v');
          if (!v) continue;
          if (entries[i].isIntersecting) {
            if (!v.src) {
              var src = v.getAttribute('data-cs-reel-src');
              if (src) v.src = src;
            }
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
            if (loud && loud.video === v) quiet();
          }
        }
      }, { root: rail, rootMargin: '200px 0px' });
      for (var i = 0; i < cards.length; i++) near.observe(cards[i]);
    } else {
      for (var j = 0; j < cards.length; j++) {
        var v = cards[j].querySelector('.cs-reel-v');
        if (v) v.src = v.getAttribute('data-cs-reel-src') || '';
      }
    }

    // Un clic coupe ou remet le son. Le glissement ne compte pas comme un clic.
    var moved = 0;
    for (var k = 0; k < cards.length; k++) {
      (function (card) {
        var hit = card.querySelector('[data-cs-reel-hit]');
        var video = card.querySelector('.cs-reel-v');
        if (!hit || !video) return;
        hit.addEventListener('click', function (e) {
          e.preventDefault();
          if (moved > 6) return;
          if (loud && loud.video === video) { quiet(); return; }
          quiet();
          if (!video.src) {
            var src = video.getAttribute('data-cs-reel-src');
            if (src) video.src = src;
          }
          video.muted = false;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
          card.classList.add('cs-reel-loud');
          loud = { video: video, card: card };
        });
      })(cards[k]);
    }

    // Les bulles disent ou on en est. Passe une douzaine de clips elles
    // s'enroulent sur trois rangees de points minuscules : au-dela, un
    // compteur « 3 / 56 » dit la meme chose et se lit.
    var dots = rail.parentNode.querySelector('[data-cs-reel-dots]');
    var counter = null;
    if (dots && cards.length > 12) {
      dots.hidden = false;
      dots.innerHTML = '';
      dots.classList.add('cs-reel-dots--count');
      counter = document.createElement('span');
      dots.appendChild(counter);
    } else if (dots && cards.length > 1) {
      dots.hidden = false;
      dots.innerHTML = '';
      for (var d = 0; d < cards.length; d++) {
        (function (n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Video ' + (n + 1));
          b.addEventListener('click', function () {
            var c = cards[n];
            rail.scrollTo({ left: c.offsetLeft - (rail.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
          });
          dots.appendChild(b);
        })(d);
      }
    }

    function mark() {
      if (!dots || !dots.children.length) return;
      var middle = rail.scrollLeft + rail.clientWidth / 2;
      var best = 0, closest = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var gap = Math.abs(cards[i].offsetLeft + cards[i].offsetWidth / 2 - middle);
        if (gap < closest) { closest = gap; best = i; }
      }
      if (counter) {
        counter.textContent = (best + 1) + ' / ' + cards.length;
        return;
      }
      for (var j = 0; j < dots.children.length; j++) {
        dots.children[j].setAttribute('aria-current', j === best ? 'true' : 'false');
      }
    }

    // Au doigt overflow-x suffit. A la souris, rien ne bouge sans ceci.
    var down = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; captured = false; moved = 0;
      startX = e.clientX; startLeft = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      // On ne capture le pointeur qu'une fois le glissement engage. Capturer
      // des le pointerdown detourne le pointerup vers le rail : le clic n'est
      // jamais emis, et tout bouton pose sur une carte devient mort.
      if (!captured && moved > 6) {
        captured = true;
        try { rail.setPointerCapture(e.pointerId); } catch (err) {}
        rail.classList.add('cs-reel-drag');
      }
      if (captured) rail.scrollLeft = startLeft - dx;
    });
    function release() {
      if (!down) return;
      down = false; captured = false;
      rail.classList.remove('cs-reel-drag');
      window.setTimeout(function () { moved = 0; }, 0);
    }
    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('pointerleave', release);

    var timer;
    rail.addEventListener('scroll', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(mark, 60);
    }, { passive: true });
    mark();
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var rails = host.querySelectorAll('[data-cs-reel]');
    for (var i = 0; i < rails.length; i++) setup(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', quiet);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-child-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(track) {
    // En liste, il n'y a ni glissement ni bulles a gerer : le rail n'existe pas.
    var host = track.closest('.cs-child-rev');
    if (host && host.getAttribute('data-layout') === 'list') return;
    // Ce drapeau ne doit JAMAIS reprendre le nom d'attribut des bulles :
    // track.dataset.csRevDots poserait data-cs-rev-dots sur le rail, le
    // querySelector ci-dessous trouverait le rail avant les bulles, et
    // dots.innerHTML = '' effacerait les quatre avis a chaque chargement.
    if (track.dataset.csRevReady) return;
    track.dataset.csRevReady = '1';

    var dots = track.parentNode.querySelector('[data-cs-rev-dots]');
    var cards = track.querySelectorAll('.cs-rev-card');
    if (!dots || cards.length < 2) return;

    dots.hidden = false;
    dots.innerHTML = '';

    // scrollIntoView ferait aussi defiler la page verticalement. On calcule la
    // position dans le rail pour ne bouger que lui.
    function go(n) {
      var card = cards[n];
      track.scrollTo({
        left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2,
        behavior: 'smooth'
      });
    }

    for (var i = 0; i < cards.length; i++) {
      (function (n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Review ' + (n + 1));
        b.addEventListener('click', function () { go(n); });
        dots.appendChild(b);
      })(i);
    }

    function mark() {
      var middle = track.scrollLeft + track.clientWidth / 2;
      var best = 0, closest = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var gap = Math.abs(cards[i].offsetLeft + cards[i].offsetWidth / 2 - middle);
        if (gap < closest) { closest = gap; best = i; }
      }
      for (var j = 0; j < dots.children.length; j++) {
        dots.children[j].setAttribute('aria-current', j === best ? 'true' : 'false');
      }
    }

    // Au doigt, overflow-x fait deja le travail. A la souris — donc dans
    // l'apercu de l'editeur — rien ne bouge sans ce glisser-deposer.
    var down = false, captured = false, startX = 0, startLeft = 0, moved = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; captured = false; moved = 0;
      startX = e.clientX; startLeft = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      // On ne capture le pointeur qu'une fois le glissement engage. Capturer
      // des le pointerdown detourne le pointerup vers le rail : le clic n'est
      // jamais emis, et tout bouton pose sur une carte devient mort.
      if (!captured && moved > 6) {
        captured = true;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.classList.add('cs-rev-drag');
      }
      if (captured) track.scrollLeft = startLeft - dx;
    });
    function release() {
      if (!down) return;
      down = false; captured = false;
      track.classList.remove('cs-rev-drag');
    }
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('pointerleave', release);
    // Un glissement ne doit pas se terminer en clic sur ce qu'il y a dessous.
    track.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    var timer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(mark, 60);
    }, { passive: true });
    mark();
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var rails = host.querySelectorAll('[data-cs-rev]');
    for (var i = 0; i < rails.length; i++) setup(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-couples-delivery"]) return;
  try {
    
(function(){'use strict';var root=document.getElementById('craftstory-delivery');if(!root||root.dataset.initialized)return;root.dataset.initialized='true';var copy=JSON.parse(root.querySelector('[data-delivery-copy]').textContent);var api=root.dataset.api||location.origin;var match=location.hash.match(/^#order=([a-f0-9]{64})\.([a-f0-9]{64})$/);var status=root.querySelector('#status'),error=root.querySelector('#error'),refresh=root.querySelector('#refresh'),timer,failures=0;function get(id){return root.querySelector('#'+id);}if(!match){status.textContent=copy.open_link;return;}async function poll(){clearTimeout(timer);try{var r=await fetch(api+'/v2/orders/'+match[1],{headers:{Authorization:'Bearer '+match[2]},signal:AbortSignal.timeout(30000)});var d=await r.json();if(!r.ok)throw new Error(d.error||copy.open_failed);failures=0;error.textContent='';refresh.hidden=true;get('song-title').textContent=d.title;get('order-number').textContent=copy.order_label+d.orderName;if(d.video){get('ready').hidden=false;get('progress-card').hidden=true;status.textContent=copy.ready;[['video',d.video],['audio',d.song]].forEach(function(item){var el=get(item[0]);if(!el.getAttribute('src')||el.error){var at=el.currentTime||0;el.src=item[1];el.currentTime=at;}});get('video').poster=d.poster;get('video-download').href=d.video+'&download=1';get('song-download').href=d.song+'&download=1';timer=setTimeout(poll,10*60000);}else if(d.status==='cancelled'){status.textContent=copy.cancelled;get('progress-card').hidden=true;get('ready').hidden=true;get('video').pause();get('audio').pause();}else{get('progress-card').hidden=false;get('progress').value=d.totalScenes?Math.max(5,Math.round(d.completedScenes/d.totalScenes*85)):5;get('progress-copy').textContent=d.totalScenes?copy.progress.replace('__DONE__',d.completedScenes).replace('__TOTAL__',d.totalScenes):copy.preparing;status.textContent=d.delayed?copy.delayed:d.status==='rendering'?copy.rendering:copy.creating;if(d.error){error.textContent=d.error;refresh.hidden=false;}timer=setTimeout(poll,10000);}}catch(e){failures++;error.textContent=e.message;refresh.hidden=false;if(failures<6)timer=setTimeout(poll,Math.min(60000,5000*failures));}}['video','audio'].forEach(function(id){get(id).addEventListener('error',poll);});refresh.addEventListener('click',function(){failures=0;poll();});document.addEventListener('visibilitychange',function(){if(!document.hidden)poll();});poll();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-ann"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var tracks = scope.querySelectorAll('.cs-ann-track[data-cs-ann-auto]');
    for (var i = 0; i < tracks.length; i++) start(tracks[i]);
  }

  function start(track) {
    if (track.dataset.csAnnOn === '1') return;
    if (track.children.length < 2) return;
    track.dataset.csAnnOn = '1';

    var calm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    var wait = (parseFloat(track.dataset.csAnnSpeed) || 3) * 1000;
    var at = 0;
    var held = false;
    var timer = window.setInterval(function () {
      if (!track.isConnected) { window.clearInterval(timer); return; }
      if (held || document.hidden) return;
      if (calm && calm.matches) return;
      if (track.scrollWidth <= track.clientWidth + 2) return;
      var from = at;
      at = (at + 1) % track.children.length;
      var slide = track.children[at];
      if (!slide) return;
      var how = at === 0 && from !== 0 ? 'auto' : 'smooth';
      if (track.scrollTo) track.scrollTo({ left: slide.offsetLeft, behavior: how });
      else track.scrollLeft = slide.offsetLeft;
    }, wait);

    function hold() { held = true; }
    function free() { held = false; }
    track.addEventListener('pointerenter', hold);
    track.addEventListener('pointerleave', free);
    track.addEventListener('touchstart', hold, { passive: true });
    track.addEventListener('touchend', free, { passive: true });
    track.addEventListener('focusin', hold);
    track.addEventListener('focusout', free);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  function csDctInit(root) {
    if (!root || root.getAttribute('data-cs-dct-ready') === '1') return;
    var btn = root.querySelector('[data-cs-dct-btn][data-enable-sticky="true"]');
    var host = root.querySelector('[data-cs-dct-sticky]');
    if (!btn || !host) return;
    root.setAttribute('data-cs-dct-ready', '1');

    var label = btn.getAttribute('data-sticky-label') || (btn.textContent || '').trim();
    var link = btn.getAttribute('data-sticky-link') || btn.getAttribute('href') || '';

    var wrap = document.createElement('div');
    wrap.className = 'cs-dct-stickywrap';

    var sticky = document.createElement('a');
    sticky.className = 'cs-dct-stickybtn';
    sticky.textContent = label;
    if (link && link !== '#') {
      sticky.href = link;
    } else {
      sticky.href = '#';
      sticky.setAttribute('role', 'link');
      sticky.setAttribute('aria-disabled', 'true');
      sticky.addEventListener('click', function (e) { e.preventDefault(); });
    }

    wrap.appendChild(sticky);
    host.appendChild(wrap);

    var ticking = false;

    function toggle() {
      ticking = false;
      var scrollY = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      try {
        var rect = btn.getBoundingClientRect();
        var scrolledEnough = scrollY > 200;
        var buttonHidden = rect.top >= viewportH || rect.bottom <= 0;
        if (scrolledEnough && buttonHidden) {
          if (!wrap.classList.contains('cs-dct-on')) wrap.classList.add('cs-dct-on');
        } else if (wrap.classList.contains('cs-dct-on')) {
          wrap.classList.remove('cs-dct-on');
        }
      } catch (e) {}
    }

    function requestTick() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(toggle);
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });
    toggle();
  }

  function csDctInitAll() {
    var roots = document.querySelectorAll('[data-cs-dct]');
    for (var i = 0; i < roots.length; i++) csDctInit(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', csDctInitAll);
  } else {
    csDctInitAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target && e.target.querySelector ? e.target : document;
    var roots = scope.querySelectorAll ? scope.querySelectorAll('[data-cs-dct]') : [];
    for (var i = 0; i < roots.length; i++) csDctInit(roots[i]);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function parts(row) {
    return {
      d: row.querySelector('[data-cs-dfaq-details]'),
      s: row.querySelector('[data-cs-dfaq-summary]'),
      w: row.querySelector('[data-cs-dfaq-panel]')
    };
  }

  function rowsOf(list) {
    return [].slice.call(list.querySelectorAll('[data-cs-dfaq-row]'));
  }

  function once(el, fn) {
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      el.removeEventListener('transitionend', handler);
      fn();
    }
    function handler(ev) {
      if (ev.target !== el || ev.propertyName !== 'max-height') return;
      finish();
    }
    el.addEventListener('transitionend', handler);
    setTimeout(finish, 420);
  }

  function open(row, p) {
    p.d.open = true;
    row.classList.add('is-open');
    p.s.setAttribute('aria-expanded', 'true');
    if (REDUCE) { p.w.style.maxHeight = 'none'; return; }
    p.w.style.maxHeight = '0px';
    void p.w.offsetHeight;
    p.w.style.maxHeight = p.w.scrollHeight + 'px';
    once(p.w, function () {
      // let the panel grow with its content (images, resize) once it is fully open
      if (row.classList.contains('is-open')) p.w.style.maxHeight = 'none';
    });
  }

  function close(row, p) {
    row.classList.remove('is-open');
    p.s.setAttribute('aria-expanded', 'false');
    if (REDUCE) { p.w.style.maxHeight = '0px'; p.d.open = false; return; }
    p.w.style.maxHeight = p.w.scrollHeight + 'px';
    void p.w.offsetHeight;
    p.w.style.maxHeight = '0px';
    once(p.w, function () {
      // the row may have been reopened mid-animation
      if (!row.classList.contains('is-open')) p.d.open = false;
    });
  }

  function closeOthers(list, keep) {
    rowsOf(list).forEach(function (row) {
      if (row === keep) return;
      var p = parts(row);
      if (p.d && p.s && p.w && p.d.open) close(row, p);
    });
  }

  // the reference keeps its rows hidden until the band is scrolled to, then stagger them by --index
  function reveal(list, rows) {
    if (REDUCE || !('IntersectionObserver' in window) || !rows.length) return;
    var shown = false;
    var io = null;
    var safety = null;
    function show() {
      if (shown) return;
      shown = true;
      if (io) io.disconnect();
      if (safety) clearTimeout(safety);
      for (var i = 0; i < rows.length; i++) rows[i].classList.add('cs-dfaq-shown');
    }
    list.classList.add('cs-dfaq-reveal');
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { show(); return; }
      }
    }, { rootMargin: '0px 0px -60px 0px' });
    io.observe(list);
    // never leave the answers invisible if the observer never fires
    safety = setTimeout(show, 2500);
  }

  function setup(list) {
    if (!list || list.dataset.csDfaqOn === '1') return;
    list.dataset.csDfaqOn = '1';
    list.classList.add('cs-dfaq-js');
    var single = list.getAttribute('data-cs-dfaq-single') === '1';

    rowsOf(list).forEach(function (row) {
      var p = parts(row);
      if (!p.d || !p.s || !p.w) return;

      if (p.d.open) {
        row.classList.add('is-open');
        p.w.style.maxHeight = 'none';
        p.s.setAttribute('aria-expanded', 'true');
      } else {
        p.s.setAttribute('aria-expanded', 'false');
      }

      p.s.addEventListener('click', function (e) {
        // we drive the open state ourselves so the panel can animate both ways
        e.preventDefault();
        if (p.d.open && row.classList.contains('is-open')) {
          close(row, p);
        } else {
          if (single) closeOthers(list, row);
          open(row, p);
        }
      });
    });

    reveal(list, rowsOf(list));
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('[data-cs-dfaq]');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-flow-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORE = 'csDuoFlow';
  // Les photos sont gardees a part : elles pesent, et la page d'apres n'a pas
  // besoin de les relire pour composer ses titres.
  var PHSTORE = 'csDuoPhotos';
  var MAXPH = 2;
  var PHMAX = 1280;

  // Reduite dans le navigateur, puis en dataURL. Deux raisons, dans cet ordre :
  //   - c'est exactement ce que le worker des enfants recoit deja (un dataURL
  //     dans du JSON), donc rien a ecrire de son cote ;
  //   - un telephone sort des fichiers de 4 Mo. 1280 px suffisent au modele,
  //     et l'envoi passe sur un reseau de gare.
  function shrink(file, cb) {
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var k = Math.min(1, PHMAX / Math.max(img.width, img.height));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(img.width * k));
      c.height = Math.max(1, Math.round(img.height * k));
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      var out = '';
      try { out = c.toDataURL('image/jpeg', 0.82); } catch (e) {}
      cb(out);
    };
    img.onerror = function () { URL.revokeObjectURL(url); cb(''); };
    img.src = url;
  }

  function setup(root) {
    if (root.dataset.csFlowReady) return;
    root.dataset.csFlowReady = '1';

    var form = root.querySelector('[data-cs-form]');
    var steps = root.querySelectorAll('.cs-flow-step');
    var bar = root.querySelector('[data-cs-bar]');
    var stepCount = root.querySelector('[data-cs-step-count]');
    var back = root.querySelector('[data-cs-back]');
    var next = root.querySelector('[data-cs-next]');
    var nextLabel = root.querySelector('[data-cs-next-label]');
    var err = root.querySelector('[data-cs-err]');
    var wait = root.querySelector('[data-cs-wait]');
    var mk = root.querySelector('[data-cs-mk]');
    if (!form || !steps.length) return;

    // Les libelles viennent des attributs poses par Liquid : un bloc javascript
    // est mutualise entre toutes les sections, il ne peut pas les interpoler.
    var D = root.dataset;
    var CFG = {
      nextLabel: D.next || 'Next',
      lastLabel: D.last || 'Create our song',
      errRequired: D.errReq || 'Please fill this in before continuing.',
      errEmail: D.errEmail || 'That email address does not look right.',
      errSend: D.errSend || 'We could not send that. Check your connection and try again.'
    };
    var last = steps.length - 1;
    var i = 0;

    // Relues au chargement : un retour en arriere, un rechargement ou le
    // retour du POST natif ne doivent pas redemander un fichier deja donne.
    var shots = [];
    try {
      var kept = JSON.parse(window.sessionStorage.getItem(PHSTORE) || '[]');
      if (kept && kept.length) shots = kept.slice(0, MAXPH);
    } catch (e) {}

    var draftKey = 'csCouplesFormDraft:v2';
    var draftLife = 7 * 24 * 60 * 60 * 1000;
    var draftTimer = null;
    var restoringDraft = true;
    var draft = null;
    var draftFields = ['relationship', 'their_name', 'your_name', 'occasion', 'occasion_other', 'genre', 'voice', 'qualities', 'story', 'message', 'language', 'email', 'consent'];

    function readDraft() {
      if (window.Shopify && window.Shopify.designMode) return null;
      try {
        var value = JSON.parse(window.localStorage.getItem(draftKey) || 'null');
        if (!value) return null;
        if (value.version !== 2 || typeof value.savedAt !== 'number' || value.savedAt > Date.now() || Date.now() - value.savedAt > draftLife || !value.answers || typeof value.answers !== 'object') {
          window.localStorage.removeItem(draftKey);
          return null;
        }
        return value;
      } catch (e) { return null; }
    }

    function saveDraft() {
      if (restoringDraft || submitting || (window.Shopify && window.Shopify.designMode)) return;
      if (draftTimer) { clearTimeout(draftTimer); draftTimer = null; }
      var values = {};
      var all = answers();
      for (var d = 0; d < draftFields.length; d++) {
        var key = draftFields[d];
        if (typeof all[key] === 'string') values[key] = all[key];
      }
      try {
        window.localStorage.setItem(draftKey, JSON.stringify({ version: 2, savedAt: Date.now(), step: i, answers: values }));
      } catch (e) {}
    }

    function clearDraft() {
      if (draftTimer) { clearTimeout(draftTimer); draftTimer = null; }
      try { window.localStorage.removeItem(draftKey); } catch (e) {}
    }

    function restoreDraft() {
      draft = readDraft();
      if (!draft) return;
      for (var d = 0; d < form.elements.length; d++) {
        var field = form.elements[d];
        if (draftFields.indexOf(field.name) < 0) continue;
        var value = draft.answers[field.name];
        if (field.type === 'checkbox') field.checked = value === 'Yes' && shots.length > 0;
        else if (field.type === 'radio') field.checked = field.value === value;
        else if (typeof value === 'string') field.value = field.maxLength > 0 ? value.slice(0, field.maxLength) : value;
      }
      var extra = form.querySelector('[data-cs-optional-message]');
      if (extra && form.elements.message.value.trim()) extra.open = true;
    }

    restoreDraft();
    form.addEventListener('input', function () {
      if (draftTimer) clearTimeout(draftTimer);
      draftTimer = setTimeout(saveDraft, 250);
    });
    form.addEventListener('change', saveDraft);
    window.addEventListener('pagehide', saveDraft);
    document.addEventListener('visibilitychange', function () { if (document.hidden) saveDraft(); });

    function fill(el, map) {
      if (!el) return;
      var tpl = el.getAttribute('data-tpl') || el.textContent;
      var out = tpl;
      for (var k in map) out = out.split('{' + k + '}').join(map[k] || '');
      el.textContent = out;
    }

    var historyReady=false;
    function formHistory(n,replace){
      if(window.Shopify&&window.Shopify.designMode)return;
      var state=Object.assign({},history.state,{csCouplesStep:n});
      try{history[replace?'replaceState':'pushState'](state,'',location.href);}catch(_){}
    }
    function show(n,fromHistory) {
      n=Math.max(0,Math.min(last,n));
      if(historyReady&&!fromHistory&&n!==i)formHistory(n,false);
      for (var s = 0; s < steps.length; s++) steps[s].hidden = s !== n;
      // On re-declenche l'animation : sans ca, un ecran deja vu reapparait sec.
      steps[n].style.animation = 'none';
      void steps[n].offsetWidth;
      steps[n].style.animation = '';

      i = n;
      bar.style.width = ((n + 1) / steps.length * 100) + '%';
      if (stepCount) stepCount.textContent = (D.stepLabel || '').replace('[current]', n + 1).replace('[total]', steps.length);
      if (!restoringDraft) saveDraft();
      root.querySelectorAll('[data-cs-back]').forEach(function(button){button.hidden=n===0;});
      nextLabel.textContent = n === last ? CFG.lastLabel : CFG.nextLabel;
      err.hidden = true;

      if (n === last) {
        var name = (form.elements.their_name && form.elements.their_name.value || '').trim();
        fill(root.querySelector('[data-cs-s7sub]'), { name: name });
      }
      // Le haut de l'ecran, pas le haut du document : la barre reste visible.
      var top = root.getBoundingClientRect().top + window.pageYOffset - 12;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
      var first = steps[n].querySelector('input:not([type=radio]):not([type=checkbox]), textarea, select');
      if (first && window.matchMedia('(min-width:750px)').matches) first.focus();
    }

    function fail(field, msg) {
      err.textContent = msg;
      err.hidden = false;
      if (field && field.focus) field.focus();
      return false;
    }

    function valid(n) {
      var step = steps[n];
      var reqs = step.querySelectorAll('[data-req]');
      for (var r = 0; r < reqs.length; r++) {
        var f = reqs[r];
        if (f.type === 'checkbox' ? !f.checked : !f.value.trim()) {
          // Un message par champ quand il y en a un : « remplis ce champ » ne
          // veut rien dire devant une case a cocher ou un depot de photo.
          return fail(f, f.getAttribute('data-req-msg') || CFG.errRequired);
        }
        if (f.hasAttribute('data-email') && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.value.trim())) {
          return fail(f, CFG.errEmail);
        }
      }
      // Un groupe de radios n'a pas de champ requis : on verifie le groupe.
      var groups = {};
      var radios = step.querySelectorAll('input[type=radio]');
      for (var g = 0; g < radios.length; g++) groups[radios[g].name] = groups[radios[g].name] || radios[g];
      for (var key in groups) {
        if (!step.querySelector('input[name="' + key + '"]:checked')) {
          return fail(groups[key], CFG.errRequired);
        }
      }
      return true;
    }

    function answers() {
      var out = {};
      var f = form.elements;
      for (var n = 0; n < f.length; n++) {
        var el = f[n];
        if (!el.name || el.type === 'file') continue;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) continue;
        var v = el.type === 'checkbox' ? 'Yes' : el.value.trim();
        // Un champ vide n'a rien a faire dans le message : le telephone est
        // facultatif, et la precision d'occasion ne sert que si elle est la.
        if (v === '') continue;
        out[el.name] = v;
      }
      return out;
    }

    // Sans endpoint, les reponses partent par le formulaire de contact natif de
    // Shopify : elles arrivent dans la boite mail de la boutique, sans worker
    // ni application.
    //
    // Et c'est un VRAI envoi de formulaire, pas un fetch. Deux raisons, dans
    // cet ordre :
    //   - un fetch peut repondre 200 alors que Shopify a servi une page de
    //     captcha : rien n'est parti, et on annoncerait quand meme au client
    //     que son histoire est envoyee. Ici c'est Shopify qui tranche, et il
    //     ne renvoie sur ?contact_posted=true qu'en cas de reussite reelle.
    //   - si un captcha est demande, le visiteur le voit et peut le resoudre.
    // Ca coute un rechargement au tout dernier clic. On relit le parametre au
    // chargement pour retomber directement sur l'ecran final.
    function niceKey(k) {
      return k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' ');
    }

    // Tout est mis de cote, pas seulement le prenom : la page d'apres compose
    // ses titres avec le genre, la relation et l'occasion. Ca reste dans
    // l'onglet du visiteur, rien ne part ailleurs, et ca meurt avec l'onglet.
    // Gardees des le depot, pas seulement a l'envoi : un rechargement au
    // milieu du tunnel ne doit pas redemander un fichier deja donne.
    // Le quota peut refuser deux photos ; ce n'est pas bloquant, elles partent
    // quand meme avec l'envoi. On n'annule rien pour ca.
    function keepShots() {
      try {
        if (shots.length) window.sessionStorage.setItem(PHSTORE, JSON.stringify(shots));
      } catch (e) {}
    }

    function stash(data) {
      try { window.sessionStorage.setItem(STORE, JSON.stringify(data)); } catch (e) {}
      keepShots();
    }

    function sendNative(data) {
      stash(data);

      var lines = [];
      for (var k in data) if (k !== 'email') lines.push(niceKey(k) + ': ' + data[k]);
      var body = 'COUPLES SONG REQUEST\n\n' + lines.join('\n');
      // Le formulaire de contact de Shopify ne sait pas porter de fichier. On
      // ne fait pas semblant : le message dit combien de photos ont ete
      // deposees, ou elles sont restees, et quoi remplir pour les recevoir.
      if (shots.length) {
        body += '\n\nPhotos: ' + shots.length + ' added by the visitor, but a Shopify'
          + ' contact form cannot carry files, so they stayed in their browser.'
          + ' Fill in the API URL of the flow section to receive them.';
      }

      var fields = {
        form_type: 'contact',
        utf8: '✓',
        'contact[email]': data.email || '',
        'contact[name]': (data.your_name || '') + ' & ' + (data.their_name || ''),
        'contact[body]': body
      };

      var f = document.createElement('form');
      f.method = 'post';
      f.action = '/contact#contact_form';
      f.hidden = true;
      for (var key in fields) {
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = key;
        h.value = fields[key];
        f.appendChild(h);
      }
      document.body.appendChild(f);
      f.submit();
    }

    // Un seul POST, un seul JSON : les reponses et les photos deja reduites en
    // dataURL. Pas de multipart — le worker des enfants lit deja ce format-la.
    function sendApi(url, data) {
      var out = {};
      for (var k in data) out[k] = data[k];
      if (shots[0]) out.photo = shots[0];
      if (shots[1]) out.photo2 = shots[1];
      out.photo_count = shots.length;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(out)
      });
    }

    // Le corps de la reponse, sans jamais faire echouer l'envoi pour ca. Un
    // 204, un corps vide ou du texte au lieu du JSON ne doivent pas afficher
    // « nous n'avons pas pu envoyer » a quelqu'un dont l'histoire est partie.
    function body(r) {
      try {
        if (!r || typeof r.json !== 'function') return Promise.resolve(null);
        return r.json().catch(function () { return null; });
      } catch (e) { return Promise.resolve(null); }
    }

    // L'attente prend la place du dernier champ, sur la meme page, AU CLIC :
    // c'est la suite immediate du dernier bouton, pas un accuse de reception.
    //
    // LA PAGE UNIQUE. Quand la preview est posee sous le tunnel (puis l'offre
    // et le reste), l'attente dure le temps de la barre : 2 min 30 par
    // defaut, la duree du clip d'attente. Barre pleine, tout s'ouvre dessous,
    // sans clic : la preview y poursuit sa fabrication si elle n'est pas
    // finie, et se devoile d'elle-meme quand elle est prete. Rien n'est
    // visible dessous avant la fin de la barre.
    //
    // Sans preview dessous (le tunnel seul sur sa page), la fin de la barre
    // ouvre la page de la preview, d'elle-meme elle aussi.
    //
    // La barre ne finit pas tant que la preview n'a pas ete lancee (le depot
    // des photos peut etre lent) : elle attend a 99 %. Le studio a une minute
    // au plus pour accepter l'envoi ; un echec ramene au formulaire, avec le
    // message.
    var MKEND = 'csDuoMakeAt';     // l'echeance de la barre, posee au clic
    var WAITJOB = 'csDuoWaitJob';  // la preview que cette attente a lancee
    var OPEN = 'csDuoOpen';        // la page s'est ouverte pour elle
    var CAP = 60000;               // le temps laisse au studio pour accepter l'envoi

    function ss(k, v) {
      try {
        if (v === undefined) return window.sessionStorage.getItem(k);
        if (v === null) window.sessionStorage.removeItem(k);
        else window.sessionStorage.setItem(k, v);
      } catch (e) {}
      return null;
    }

    // La section de la preview, si elle est sur cette page.
    function previewHost() {
      var el = document.querySelector('[data-couples-preview]');
      return el ? el.closest('.shopify-section') : null;
    }

    // La preview de la page se branche sur celle qui vient d'etre lancee. Sa
    // section a demarre au chargement, sans rien a suivre : on la remplace
    // par une copie neuve, rendue par Shopify, et on lui dit de redemarrer.
    // Elle lit alors la nouvelle preview d'elle-meme. Aucun de ses fichiers
    // n'est modifie : c'est l'evenement qu'elle ecoute deja.
    //
    // Et elle se devoile seule, comme une preview deja vue : pas de bouton
    // a toucher pour la voir.
    function couple(job) {
      // The ready preview waits for the visitor's Watch preview click.
      var host = previewHost();
      if (!host || !host.id) return Promise.resolve();
      // Dans l'adresse aussi, comme la page de l'associe la recoit : la preview
      // la lit la, meme si l'onglet refuse de garder quoi que ce soit.
      try { window.history.replaceState(window.history.state, '', '#preview=' + job.id + '.' + job.token); } catch (e) {}
      var id = host.id.replace(/^shopify-section-/, '');
      var old = host.querySelector('[data-couples-preview]');
      var settled = false;
      var done;
      var ready = new Promise(function (r) { done = r; });
      function swap(fresh) {
        if (settled) return;
        settled = true;
        var cur = host.querySelector('[data-couples-preview]');
        if (cur && fresh) {
          cur.parentNode.replaceChild(fresh, cur);
          host.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: id } }));
        }
        done();
      }
      // Si Shopify ne rend pas la section, une copie remise dans l'etat du
      // chargement fait la meme chose.
      function copy() {
        var el = old.cloneNode(true);
        el.removeAttribute('data-ready');
        el.setAttribute('data-view', 'loading');
        el.setAttribute('aria-busy', 'true');
        var l = el.querySelector('[data-loader]');
        if (l) l.hidden = false;
        var r = el.querySelector('[data-results]');
        if (r) r.hidden = true;
        return el;
      }
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('section_id', id);
      // Jamais plus de quatre secondes : au-dela, la copie fait l'affaire.
      setTimeout(function () { swap(copy()); }, 4000);
      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var got = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-couples-preview]') : null;
          swap(got ? document.importNode(got, true) : copy());
        })
        .catch(function () { swap(copy()); });
      return ready;
    }

    // L'offre, dessous, lit le prenom au chargement de la page. Sur la page
    // unique il n'existe qu'apres le questionnaire : on la relance avec
    // l'evenement qu'elle ecoute deja, elle relit leurs reponses.
    function rename() {
      var all = document.querySelectorAll('[data-cs-pvo]');
      for (var i = 0; i < all.length; i++) {
        var host = all[i].closest('.shopify-section');
        if (!host) continue;
        all[i].removeAttribute('data-cs-pvo-ready');
        host.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true, detail: { sectionId: host.id.replace(/^shopify-section-/, '') }
        }));
      }
    }

    var watching = false;

    function finish(who, resume) {
      form.hidden = true;
      root.querySelector('.cs-flow-top').hidden = true;
      wait.hidden = true;
      if (!mk) return { ready: function () {}, stop: function () {} };
      mk.hidden = false;

      // Sur telephone le dernier bouton est tout en bas : l'attente, elle,
      // s'affiche en haut de l'ecran.
      if (!resume) {
        var top = root.getBoundingClientRect().top + window.pageYOffset - 12;
        if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }
      var done = !!(resume && resume.open);
      var liveStatus=null;

      // La video n'est chargee qu'ici : inutile de la faire telecharger a
      // quelqu'un qui abandonnera au deuxieme ecran. Une attente deja finie
      // ne la relance pas.
      var v = mk.querySelector('.cs-flow-mk-v');
      if (v && !done) {
        var src = v.getAttribute('data-cs-mk-src');
        if (src && !v.src) v.src = src;
        // Un second essai (apres un refus) relance aussi le clip.
        if (v.src && v.muted && v.paused) { var pl = v.play(); if (pl && pl.catch) pl.catch(function () {}); }
      }

      // Aucun clip charge, mais leur photo est la : elle prend le cadre. C'est
      // leur attente, pas un rectangle vide, et ca leur prouve d'un coup d'oeil
      // que la photo est bien partie avec le reste.
      var slot = mk.querySelector('.cs-flow-mk-empty');
      if (slot && shots[0]) {
        slot.classList.remove('cs-flow-mk-empty');
        slot.classList.add('cs-flow-mk-mine');
        slot.textContent = '';
        var ph = document.createElement('img');
        ph.className = 'cs-flow-mk-ph';
        ph.alt = '';
        ph.src = shots[0];
        slot.appendChild(ph);
      } else if (slot) {
        // Ni clip ni photo (au retour sur la page, la photo n'est plus
        // gardee) : le cadre vide et sa consigne sont pour le marchand, pas
        // pour un client.
        slot.hidden = true;
      }
      var mine = mk.querySelector('.cs-flow-mk-ph');
      if (mine && shots[0] && mine.src !== shots[0]) mine.src = shots[0];

      // Leur chanson passe avant le clip d'attente.
      if (v && !watching) {
        watching = true;
        document.addEventListener('play', function (e) {
          var t = e.target;
          if (t !== v && t && t.closest && t.closest('[data-couples-preview]') && !v.paused) v.pause();
        }, true);
      }

      var secs = parseFloat(root.getAttribute('data-mk-sec') || '150') || 150;
      var fillBar = mk.querySelector('[data-cs-mk-fill]');
      var pctEl = mk.querySelector('[data-cs-mk-pct]');
      var stageEl = mk.querySelector('[data-cs-mk-stage]');
      var clockEl = mk.querySelector('[data-cs-mk-clock]');
      var noteEl = mk.querySelector('[data-cs-mk-note]');
      var readyEl = mk.querySelector('[data-cs-mk-ready]');

      var stages = [];
      var raw = (root.getAttribute('data-mk-stages') || '').split('|');
      for (var n = 0; n < raw.length; n++) { if (raw[n].trim()) stages.push(raw[n].trim()); }

      // L'echeance est posee une seule fois, au clic, et gardee dans l'onglet :
      // un rechargement ne la fait pas repartir.
      var end = parseInt(ss(MKEND) || '0', 10);
      if (!end || isNaN(end)) {
        end = Date.now() + secs * 1000;
        ss(MKEND, String(end));
      }

      var job = null;
      var opened = false;
      var stopped = false;
      var tick = 0;

      function open() {
        if (opened) return;
        opened = true;
        ss(OPEN, '1');
        if (noteEl) noteEl.hidden = !!(liveStatus&&liveStatus.status==='ready');
        var host = previewHost();
        if (!host) {
          // Rien dessous : la page de la preview s'ouvre d'elle-meme.
          var base = (root.getAttribute('data-next-page') || '').trim() || '/pages/couples-preview';
          var target = new URL(base, window.location.origin);
          target.hash = 'preview=' + job.id + '.' + job.token;
          var theme = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (theme) target.searchParams.set('preview_theme_id', theme);
          window.location.assign(target.href);
          return;
        }
        document.documentElement.removeAttribute('data-cs-duo-gate');
        if (readyEl) readyEl.hidden = !(liveStatus&&liveStatus.status==='ready');
        // On descend jusqu'a la preview, doucement, sans rien demander. Pas
        // au retour sur une page deja ouverte : le navigateur remet deja la
        // page ou elle etait.
        if (!done) {
          setTimeout(function () { host.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250);
        }
      }

      function paint() {
        if(stopped||!root.isConnected)return;
        var complete=!!(liveStatus&&liveStatus.status==='ready');
        var failed=!!(liveStatus&&['failed','partial'].includes(liveStatus.status));
        var p=complete?100:Math.min(96,liveStatus&&liveStatus.progress||0);
        var started=liveStatus&&liveStatus.createdAt||end-secs*1000;
        var elapsed=Math.max(0,Math.floor((Date.now()-started)/1000));
        if(fillBar)fillBar.style.width=p+'%';
        if(pctEl)pctEl.textContent=Math.floor(p)+'%';
        if(clockEl)clockEl.textContent='Elapsed '+Math.floor(elapsed/60)+':'+String(elapsed%60).padStart(2,'0');
        if(stageEl)stageEl.textContent=complete?'Your preview is ready':failed?'Your answers are saved — see the update below':!job?'Saving your story…':!liveStatus?'Connecting to the studio…':!liveStatus.planReady?'Writing your personal song…':!liveStatus.avatarReady?'Creating your cartoon characters…':!liveStatus.musicReady?'Composing your song…':'Creating your scenes ('+liveStatus.scenesReady+' of 4 ready)…';
        if(readyEl)readyEl.hidden=!complete;
        if(noteEl){noteEl.hidden=complete;noteEl.textContent=failed?'Your answers are saved. See the preview below for help.':elapsed>=300?'Your preview is not ready yet. Some scenes are taking longer. We are still checking automatically — you do not need to fill in the form again.':'Your preview is not ready yet. It is being created from your story and photos. Your progress is saved.';}
        if(job&&(complete||failed||done||elapsed>=300))open();
        if(complete||failed){clearInterval(tick);document.removeEventListener('craftstory:preview-status',updateStatus);}
      }
      function updateStatus(event){if(job&&event.detail&&event.detail.id===job.id){liveStatus=event.detail;paint();}}
      document.addEventListener('craftstory:preview-status',updateStatus);
      paint();tick=setInterval(paint,1000);

      var snd = mk.querySelector('[data-cs-mk-sound]');
      if (snd && v && !snd.dataset.csWired) {
        snd.dataset.csWired = '1';
        snd.addEventListener('click', function (e) {
          e.stopPropagation();
          v.muted = false;
          v.play();
          snd.hidden = true;
        });
        mk.querySelector('.cs-flow-mk-stage').addEventListener('click', function () {
          if (v.paused) { v.play(); } else { v.pause(); }
        });
      }

      return {
        ready: function (j) { job = j;var last=window.CraftStoryCouples.lastStatus;if(last&&last.id===j.id)liveStatus=last;paint(); },
        stop: function () {
          stopped = true;
          document.removeEventListener('craftstory:preview-status',updateStatus);
          clearInterval(tick);
          if (v && !v.paused) v.pause();
        }
      };
    }

    var submitting = false;
    function submit() {
      if (submitting) return;
      var data = answers();
      var url = (root.getAttribute('data-api') || '').trim();
      if (window.Shopify && window.Shopify.designMode) {
        err.textContent = 'Open the theme preview in a separate tab to test generation.';
        err.hidden = false;
        return;
      }
      if (!window.CraftStoryCouples) {
        err.textContent = 'The preview studio is still loading. Please try again.';
        err.hidden = false;
        return;
      }
      saveDraft();
      submitting = true;
      next.disabled = true;
      err.hidden = true;
      stash(data);
      rename();

      // Une nouvelle attente : rien de la precedente ne compte plus, et le
      // bas de la page se referme jusqu'a la fin de celle-ci.
      ss(MKEND, null);
      ss(WAITJOB, null);
      ss(OPEN, null);
      if (previewHost()) document.documentElement.setAttribute('data-cs-duo-gate', 'closed');

      var run = finish({ name: data.their_name, email: data.email });
      var limit = setTimeout(function () { fail(null); }, CAP);

      function fail(error) {
        clearTimeout(limit);
        if (!submitting) return;
        submitting = false;
        run.stop();
        ss(MKEND, null);
        next.disabled = false;
        nextLabel.textContent = CFG.lastLabel;
        if (mk) mk.hidden = true;
        form.hidden = false;
        root.querySelector('.cs-flow-top').hidden = false;
        // Le message du studio quand il en donne un ; jamais celui du
        // navigateur (« signal timed out », « Failed to fetch »...).
        var tech = !error || /^(TypeError|TimeoutError|AbortError)$/.test(error.name || '');
        err.textContent = (!tech && error.message) || CFG.errSend;
        err.hidden = false;
      }

      window.CraftStoryCouples.start(url, data, shots).then(function (job) {
        // Trop tard : l'attente a deja rendu la main au formulaire.
        if (!submitting) return;
        clearTimeout(limit);
        ss(WAITJOB, job.id);
        couple(job).then(function () { if (submitting) run.ready(job); });
      }).catch(fail);
    }

    next.addEventListener('click', function () {
      if (!valid(i)) return;
      if (i === last) submit(); else show(i + 1);
    });
    root.querySelectorAll('[data-cs-back]').forEach(function(button){button.addEventListener('click',function(event){event.preventDefault();if(!submitting&&i>0)show(i-1);});});
    window.addEventListener('popstate',function(event){if(submitting||form.hidden)return;saveDraft();var n=event.state&&event.state.csCouplesStep;if(Number.isInteger(n))show(n,true);});

    // Entree fait avancer, sauf dans une zone de texte ou elle sert a aller a la ligne.
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA' || e.target.closest('button') || ['radio','checkbox'].includes(e.target.type)) return;
      e.preventDefault();
      next.click();
    });

    // Un choix de carte sur la landing page arrive en ?occasion=… : on le coche.
    try {
      var want = new URLSearchParams(window.location.search).get('occasion');
      if (want) {
        var opts = form.querySelectorAll('input[name=occasion]');
        for (var o = 0; o < opts.length; o++) {
          if (opts[o].value.toLowerCase() === want.toLowerCase()) { opts[o].checked = true; break; }
        }
      }
    } catch (e) {}

    // Le champ libre suit les boutons de SON fieldset : rien a declarer, il
    // suffit qu'il soit au bon endroit dans le balisage.
    var more = form.querySelector('[data-cs-more]');
    if (more) {
      var moreInput = more.querySelector('input');
      var moreFor = (more.getAttribute('data-cs-more') || '').toLowerCase();
      var moreGroup = more.closest('fieldset').querySelectorAll('input[type=radio]');
      var syncMore = function () {
        var on = false;
        for (var m = 0; m < moreGroup.length; m++) {
          if (moreGroup[m].checked && moreGroup[m].value.toLowerCase() === moreFor) on = true;
        }
        more.hidden = !on;
        if (on) {
          moreInput.setAttribute('data-req', '');
        } else {
          // On vide en refermant, sinon une precision abandonnee part quand meme.
          moreInput.removeAttribute('data-req');
          moreInput.value = '';
        }
      };
      for (var m2 = 0; m2 < moreGroup.length; m2++) moreGroup[m2].addEventListener('change', syncMore);
      syncMore();
    }

    var photoEl = form.querySelector('[data-cs-photo]');
    var prevBox = form.querySelector('[data-cs-photo-prev]');
    var labelEl = form.querySelector('[data-cs-photo-label]');
    var baseLabel = labelEl ? labelEl.textContent : '';

    function paintShots() {
      if (prevBox) {
        prevBox.innerHTML = '';
        for (var n = 0; n < shots.length; n++) {
          var im = document.createElement('img');
          im.src = shots[n];
          im.alt = '';
          prevBox.appendChild(im);
        }
        prevBox.setAttribute('data-n', String(shots.length));
        prevBox.hidden = !shots.length;
      }
      if (labelEl) {
        labelEl.textContent = shots.length > 1 ? (D.phTwo || baseLabel)
          : shots.length ? (D.phOne || baseLabel) : baseLabel;
      }
      // Le champ fichier perd son obligation des qu'une photo est gardee. Il
      // faut ce detour : apres un rechargement il est toujours vide, alors que
      // la photo, elle, est encore la. Sans ca l'ecran redemanderait un
      // fichier deja fourni.
      if (photoEl) {
        if (shots.length) photoEl.removeAttribute('data-req');
        else photoEl.setAttribute('data-req', '');
      }
    }

    if (photoEl) {
      photoEl.addEventListener('change', function () {
        var picked = photoEl.files ? Array.prototype.slice.call(photoEl.files) : [];
        if (!picked.length) return;
        var over = picked.length > MAXPH;
        picked = picked.slice(0, MAXPH);

        // On repart de la selection en cours a chaque fois : un champ fichier
        // remplace son contenu, les vignettes doivent dire la meme chose.
        var got = [];
        var left = picked.length;
        picked.forEach(function (f, n) {
          shrink(f, function (url) {
            if (url) got[n] = url;
            if (--left) return;
            var keep = [];
            for (var g = 0; g < got.length; g++) if (got[g]) keep.push(got[g]);
            shots = keep;
            keepShots();
            paintShots();
            if (over && D.phMax) { err.textContent = D.phMax; err.hidden = false; }
            else { err.hidden = true; }
          });
        });
      });
      paintShots();
    }

    // « Back to the questionnaire », dans la preview : sur cette page meme,
    // c'est repartir de zero, pas recharger l'attente deja faite.
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-couples-preview] a[href]') : null;
      if (!a) return;
      var u;
      try { u = new URL(a.getAttribute('href'), window.location.href); } catch (x) { return; }
      if (u.origin !== window.location.origin || u.pathname !== window.location.pathname) return;
      e.preventDefault();
      submitting = true;
      ss(MKEND, null);
      ss(WAITJOB, null);
      ss(OPEN, null);
      ss('csCouplesPreview', null);
      ss('csCouplesRevealed', null);
      window.location.assign(window.location.pathname + window.location.search);
    });

    // Retour sur la page (rechargement, bouton retour) : l'attente reprend
    // ou elle en etait, et une page deja ouverte le reste. Seulement pour la
    // preview que CE tunnel a lancee dans cet onglet.
    var saved = null;
    try { saved = JSON.parse(ss('csCouplesPreview') || 'null'); } catch (e) {}
    document.documentElement.removeAttribute('data-cs-duo-resume');
    if (saved && saved.id && saved.token && ss(WAITJOB) === saved.id && ss(OPEN) === '1' && !previewHost()) {
      // Le tunnel seul, et sa preview deja ouverte ailleurs : retour ici = un
      // nouveau questionnaire, pas un rebond vers la page de la preview.
      ss(MKEND, null);
      ss(WAITJOB, null);
      ss(OPEN, null);
      saved = null;
    }
    if (saved && saved.id && saved.token && ss(WAITJOB) === saved.id) {
      var st = {};
      try { st = JSON.parse(ss(STORE) || '{}') || {}; } catch (e) {}
      submitting = true;
      finish({ name: st.their_name || '', email: st.email || '' }, { open: ss(OPEN) === '1' }).ready(saved);
      return;
    }

    var resumeAt = draft && Number.isInteger(draft.step) ? Math.max(0, Math.min(last, draft.step)) : 0;
    if (resumeAt > 4 && !shots.length) resumeAt = 4;
    for (var checkpoint = 0; checkpoint < resumeAt; checkpoint++) {
      if (!valid(checkpoint)) { resumeAt = checkpoint; break; }
    }
    show(resumeAt);
    restoringDraft = false;
    formHistory(resumeAt,true);historyReady=true;
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var all = host.querySelectorAll('[data-cs-flow]');
    for (var i = 0; i < all.length; i++) setup(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-flow"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORE = 'csDuoFlow';
  // Les photos sont gardees a part : elles pesent, et la page d'apres n'a pas
  // besoin de les relire pour composer ses titres.
  var PHSTORE = 'csDuoPhotos';
  var MAXPH = 2;
  var PHMAX = 1280;

  // Reduite dans le navigateur, puis en dataURL. Deux raisons, dans cet ordre :
  //   - c'est exactement ce que le worker des enfants recoit deja (un dataURL
  //     dans du JSON), donc rien a ecrire de son cote ;
  //   - un telephone sort des fichiers de 4 Mo. 1280 px suffisent au modele,
  //     et l'envoi passe sur un reseau de gare.
  function shrink(file, cb) {
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var k = Math.min(1, PHMAX / Math.max(img.width, img.height));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(img.width * k));
      c.height = Math.max(1, Math.round(img.height * k));
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      var out = '';
      try { out = c.toDataURL('image/jpeg', 0.82); } catch (e) {}
      cb(out);
    };
    img.onerror = function () { URL.revokeObjectURL(url); cb(''); };
    img.src = url;
  }

  function setup(root) {
    if (root.dataset.csFlowReady) return;
    root.dataset.csFlowReady = '1';

    var form = root.querySelector('[data-cs-form]');
    var steps = root.querySelectorAll('.cs-flow-step');
    var bar = root.querySelector('[data-cs-bar]');
    var back = root.querySelector('[data-cs-back]');
    var next = root.querySelector('[data-cs-next]');
    var nextLabel = root.querySelector('[data-cs-next-label]');
    var err = root.querySelector('[data-cs-err]');
    var wait = root.querySelector('[data-cs-wait]');
    var mk = root.querySelector('[data-cs-mk]');
    if (!form || !steps.length) return;

    // Les libelles viennent des attributs poses par Liquid : un bloc javascript
    // est mutualise entre toutes les sections, il ne peut pas les interpoler.
    var D = root.dataset;
    var CFG = {
      nextLabel: D.next || 'Next',
      lastLabel: D.last || 'Create our song',
      errRequired: D.errReq || 'Please fill this in before continuing.',
      errEmail: D.errEmail || 'That email address does not look right.',
      errSend: D.errSend || 'We could not send that. Check your connection and try again.'
    };
    var last = steps.length - 1;
    var i = 0;

    // Relues au chargement : un retour en arriere, un rechargement ou le
    // retour du POST natif ne doivent pas redemander un fichier deja donne.
    var shots = [];
    try {
      var kept = JSON.parse(window.sessionStorage.getItem(PHSTORE) || '[]');
      if (kept && kept.length) shots = kept.slice(0, MAXPH);
    } catch (e) {}

    function fill(el, map) {
      if (!el) return;
      var tpl = el.getAttribute('data-tpl') || el.textContent;
      var out = tpl;
      for (var k in map) out = out.split('{' + k + '}').join(map[k] || '');
      el.textContent = out;
    }

    function show(n) {
      for (var s = 0; s < steps.length; s++) steps[s].hidden = s !== n;
      // On re-declenche l'animation : sans ca, un ecran deja vu reapparait sec.
      steps[n].style.animation = 'none';
      void steps[n].offsetWidth;
      steps[n].style.animation = '';

      i = n;
      bar.style.width = ((n + 1) / steps.length * 100) + '%';
      back.hidden = n === 0;
      nextLabel.textContent = n === last ? CFG.lastLabel : CFG.nextLabel;
      err.hidden = true;

      if (n === last) {
        var name = (form.elements.their_name && form.elements.their_name.value || '').trim();
        fill(root.querySelector('[data-cs-s7sub]'), { name: name });
      }
      // Le haut de l'ecran, pas le haut du document : la barre reste visible.
      var top = root.getBoundingClientRect().top + window.pageYOffset - 12;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
      var first = steps[n].querySelector('input:not([type=radio]):not([type=checkbox]), textarea, select');
      if (first && window.matchMedia('(min-width:750px)').matches) first.focus();
    }

    function fail(field, msg) {
      err.textContent = msg;
      err.hidden = false;
      if (field && field.focus) field.focus();
      return false;
    }

    function valid(n) {
      var step = steps[n];
      var reqs = step.querySelectorAll('[data-req]');
      for (var r = 0; r < reqs.length; r++) {
        var f = reqs[r];
        if (f.type === 'checkbox' ? !f.checked : !f.value.trim()) {
          // Un message par champ quand il y en a un : « remplis ce champ » ne
          // veut rien dire devant une case a cocher ou un depot de photo.
          return fail(f, f.getAttribute('data-req-msg') || CFG.errRequired);
        }
        if (f.hasAttribute('data-email') && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.value.trim())) {
          return fail(f, CFG.errEmail);
        }
      }
      // Un groupe de radios n'a pas de champ requis : on verifie le groupe.
      var groups = {};
      var radios = step.querySelectorAll('input[type=radio]');
      for (var g = 0; g < radios.length; g++) groups[radios[g].name] = groups[radios[g].name] || radios[g];
      for (var key in groups) {
        if (!step.querySelector('input[name="' + key + '"]:checked')) {
          return fail(groups[key], CFG.errRequired);
        }
      }
      return true;
    }

    function answers() {
      var out = {};
      var f = form.elements;
      for (var n = 0; n < f.length; n++) {
        var el = f[n];
        if (!el.name || el.type === 'file') continue;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) continue;
        var v = el.type === 'checkbox' ? 'Yes' : el.value.trim();
        // Un champ vide n'a rien a faire dans le message : le telephone est
        // facultatif, et la precision d'occasion ne sert que si elle est la.
        if (v === '') continue;
        out[el.name] = v;
      }
      return out;
    }

    // Sans endpoint, les reponses partent par le formulaire de contact natif de
    // Shopify : elles arrivent dans la boite mail de la boutique, sans worker
    // ni application.
    //
    // Et c'est un VRAI envoi de formulaire, pas un fetch. Deux raisons, dans
    // cet ordre :
    //   - un fetch peut repondre 200 alors que Shopify a servi une page de
    //     captcha : rien n'est parti, et on annoncerait quand meme au client
    //     que son histoire est envoyee. Ici c'est Shopify qui tranche, et il
    //     ne renvoie sur ?contact_posted=true qu'en cas de reussite reelle.
    //   - si un captcha est demande, le visiteur le voit et peut le resoudre.
    // Ca coute un rechargement au tout dernier clic. On relit le parametre au
    // chargement pour retomber directement sur l'ecran final.
    function niceKey(k) {
      return k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' ');
    }

    // Tout est mis de cote, pas seulement le prenom : la page d'apres compose
    // ses titres avec le genre, la relation et l'occasion. Ca reste dans
    // l'onglet du visiteur, rien ne part ailleurs, et ca meurt avec l'onglet.
    // Gardees des le depot, pas seulement a l'envoi : un rechargement au
    // milieu du tunnel ne doit pas redemander un fichier deja donne.
    // Le quota peut refuser deux photos ; ce n'est pas bloquant, elles partent
    // quand meme avec l'envoi. On n'annule rien pour ca.
    function keepShots() {
      try {
        if (shots.length) window.sessionStorage.setItem(PHSTORE, JSON.stringify(shots));
      } catch (e) {}
    }

    function stash(data) {
      try { window.sessionStorage.setItem(STORE, JSON.stringify(data)); } catch (e) {}
      keepShots();
    }

    function sendNative(data) {
      stash(data);

      var lines = [];
      for (var k in data) if (k !== 'email') lines.push(niceKey(k) + ': ' + data[k]);
      var body = 'COUPLES SONG REQUEST\n\n' + lines.join('\n');
      // Le formulaire de contact de Shopify ne sait pas porter de fichier. On
      // ne fait pas semblant : le message dit combien de photos ont ete
      // deposees, ou elles sont restees, et quoi remplir pour les recevoir.
      if (shots.length) {
        body += '\n\nPhotos: ' + shots.length + ' added by the visitor, but a Shopify'
          + ' contact form cannot carry files, so they stayed in their browser.'
          + ' Fill in the API URL of the flow section to receive them.';
      }

      var fields = {
        form_type: 'contact',
        utf8: '✓',
        'contact[email]': data.email || '',
        'contact[name]': (data.your_name || '') + ' & ' + (data.their_name || ''),
        'contact[body]': body
      };

      var f = document.createElement('form');
      f.method = 'post';
      f.action = '/contact#contact_form';
      f.hidden = true;
      for (var key in fields) {
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = key;
        h.value = fields[key];
        f.appendChild(h);
      }
      document.body.appendChild(f);
      f.submit();
    }

    // Un seul POST, un seul JSON : les reponses et les photos deja reduites en
    // dataURL. Pas de multipart — le worker des enfants lit deja ce format-la.
    function sendApi(url, data) {
      var out = {};
      for (var k in data) out[k] = data[k];
      if (shots[0]) out.photo = shots[0];
      if (shots[1]) out.photo2 = shots[1];
      out.photo_count = shots.length;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(out)
      });
    }

    // Le corps de la reponse, sans jamais faire echouer l'envoi pour ca. Un
    // 204, un corps vide ou du texte au lieu du JSON ne doivent pas afficher
    // « nous n'avons pas pu envoyer » a quelqu'un dont l'histoire est partie.
    function body(r) {
      try {
        if (!r || typeof r.json !== 'function') return Promise.resolve(null);
        return r.json().catch(function () { return null; });
      } catch (e) { return Promise.resolve(null); }
    }

    // L'attente prend la place du dernier champ, sur la meme page, AU CLIC :
    // c'est la suite immediate du dernier bouton, pas un accuse de reception.
    //
    // LA PAGE UNIQUE. Quand la preview est posee sous le tunnel (puis l'offre
    // et le reste), l'attente dure le temps de la barre : 2 min 30 par
    // defaut, la duree du clip d'attente. Barre pleine, tout s'ouvre dessous,
    // sans clic : la preview y poursuit sa fabrication si elle n'est pas
    // finie, et se devoile d'elle-meme quand elle est prete. Rien n'est
    // visible dessous avant la fin de la barre.
    //
    // Sans preview dessous (le tunnel seul sur sa page), la fin de la barre
    // ouvre la page de la preview, d'elle-meme elle aussi.
    //
    // La barre ne finit pas tant que la preview n'a pas ete lancee (le depot
    // des photos peut etre lent) : elle attend a 99 %. Le studio a une minute
    // au plus pour accepter l'envoi ; un echec ramene au formulaire, avec le
    // message.
    var MKEND = 'csDuoMakeAt';     // l'echeance de la barre, posee au clic
    var WAITJOB = 'csDuoWaitJob';  // la preview que cette attente a lancee
    var OPEN = 'csDuoOpen';        // la page s'est ouverte pour elle
    var CAP = 60000;               // le temps laisse au studio pour accepter l'envoi

    function ss(k, v) {
      try {
        if (v === undefined) return window.sessionStorage.getItem(k);
        if (v === null) window.sessionStorage.removeItem(k);
        else window.sessionStorage.setItem(k, v);
      } catch (e) {}
      return null;
    }

    // La section de la preview, si elle est sur cette page.
    function previewHost() {
      var el = document.querySelector('[data-couples-preview]');
      return el ? el.closest('.shopify-section') : null;
    }

    // La preview de la page se branche sur celle qui vient d'etre lancee. Sa
    // section a demarre au chargement, sans rien a suivre : on la remplace
    // par une copie neuve, rendue par Shopify, et on lui dit de redemarrer.
    // Elle lit alors la nouvelle preview d'elle-meme. Aucun de ses fichiers
    // n'est modifie : c'est l'evenement qu'elle ecoute deja.
    //
    // Et elle se devoile seule, comme une preview deja vue : pas de bouton
    // a toucher pour la voir.
    function couple(job) {
      // The ready preview waits for the visitor's Watch preview click.
      var host = previewHost();
      if (!host || !host.id) return Promise.resolve();
      // Dans l'adresse aussi, comme la page de l'associe la recoit : la preview
      // la lit la, meme si l'onglet refuse de garder quoi que ce soit.
      try { window.history.replaceState(window.history.state, '', '#preview=' + job.id + '.' + job.token); } catch (e) {}
      var id = host.id.replace(/^shopify-section-/, '');
      var old = host.querySelector('[data-couples-preview]');
      var settled = false;
      var done;
      var ready = new Promise(function (r) { done = r; });
      function swap(fresh) {
        if (settled) return;
        settled = true;
        var cur = host.querySelector('[data-couples-preview]');
        if (cur && fresh) {
          cur.parentNode.replaceChild(fresh, cur);
          host.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: id } }));
        }
        done();
      }
      // Si Shopify ne rend pas la section, une copie remise dans l'etat du
      // chargement fait la meme chose.
      function copy() {
        var el = old.cloneNode(true);
        el.removeAttribute('data-ready');
        el.setAttribute('data-view', 'loading');
        el.setAttribute('aria-busy', 'true');
        var l = el.querySelector('[data-loader]');
        if (l) l.hidden = false;
        var r = el.querySelector('[data-results]');
        if (r) r.hidden = true;
        return el;
      }
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('section_id', id);
      // Jamais plus de quatre secondes : au-dela, la copie fait l'affaire.
      setTimeout(function () { swap(copy()); }, 4000);
      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var got = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-couples-preview]') : null;
          swap(got ? document.importNode(got, true) : copy());
        })
        .catch(function () { swap(copy()); });
      return ready;
    }

    // L'offre, dessous, lit le prenom au chargement de la page. Sur la page
    // unique il n'existe qu'apres le questionnaire : on la relance avec
    // l'evenement qu'elle ecoute deja, elle relit leurs reponses.
    function rename() {
      var all = document.querySelectorAll('[data-cs-pvo]');
      for (var i = 0; i < all.length; i++) {
        var host = all[i].closest('.shopify-section');
        if (!host) continue;
        all[i].removeAttribute('data-cs-pvo-ready');
        host.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true, detail: { sectionId: host.id.replace(/^shopify-section-/, '') }
        }));
      }
    }

    var watching = false;

    function finish(who, resume) {
      form.hidden = true;
      root.querySelector('.cs-flow-top').hidden = true;
      wait.hidden = true;
      if (!mk) return { ready: function () {}, stop: function () {} };
      mk.hidden = false;

      // Sur telephone le dernier bouton est tout en bas : l'attente, elle,
      // s'affiche en haut de l'ecran.
      if (!resume) {
        var top = root.getBoundingClientRect().top + window.pageYOffset - 12;
        if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }
      var done = !!(resume && resume.open);

      // La video n'est chargee qu'ici : inutile de la faire telecharger a
      // quelqu'un qui abandonnera au deuxieme ecran. Une attente deja finie
      // ne la relance pas.
      var v = mk.querySelector('.cs-flow-mk-v');
      if (v && !done) {
        var src = v.getAttribute('data-cs-mk-src');
        if (src && !v.src) v.src = src;
        // Un second essai (apres un refus) relance aussi le clip.
        if (v.src && v.muted && v.paused) { var pl = v.play(); if (pl && pl.catch) pl.catch(function () {}); }
      }

      // Aucun clip charge, mais leur photo est la : elle prend le cadre. C'est
      // leur attente, pas un rectangle vide, et ca leur prouve d'un coup d'oeil
      // que la photo est bien partie avec le reste.
      var slot = mk.querySelector('.cs-flow-mk-empty');
      if (slot && shots[0]) {
        slot.classList.remove('cs-flow-mk-empty');
        slot.classList.add('cs-flow-mk-mine');
        slot.textContent = '';
        var ph = document.createElement('img');
        ph.className = 'cs-flow-mk-ph';
        ph.alt = '';
        ph.src = shots[0];
        slot.appendChild(ph);
      } else if (slot) {
        // Ni clip ni photo (au retour sur la page, la photo n'est plus
        // gardee) : le cadre vide et sa consigne sont pour le marchand, pas
        // pour un client.
        slot.hidden = true;
      }
      var mine = mk.querySelector('.cs-flow-mk-ph');
      if (mine && shots[0] && mine.src !== shots[0]) mine.src = shots[0];

      // Leur chanson passe avant le clip d'attente.
      if (v && !watching) {
        watching = true;
        document.addEventListener('play', function (e) {
          var t = e.target;
          if (t !== v && t && t.closest && t.closest('[data-couples-preview]') && !v.paused) v.pause();
        }, true);
      }

      var secs = parseFloat(root.getAttribute('data-mk-sec') || '150') || 150;
      var fillBar = mk.querySelector('[data-cs-mk-fill]');
      var pctEl = mk.querySelector('[data-cs-mk-pct]');
      var stageEl = mk.querySelector('[data-cs-mk-stage]');
      var clockEl = mk.querySelector('[data-cs-mk-clock]');
      var noteEl = mk.querySelector('[data-cs-mk-note]');
      var readyEl = mk.querySelector('[data-cs-mk-ready]');

      var stages = [];
      var raw = (root.getAttribute('data-mk-stages') || '').split('|');
      for (var n = 0; n < raw.length; n++) { if (raw[n].trim()) stages.push(raw[n].trim()); }

      // L'echeance est posee une seule fois, au clic, et gardee dans l'onglet :
      // un rechargement ne la fait pas repartir.
      var end = parseInt(ss(MKEND) || '0', 10);
      if (!end || isNaN(end)) {
        end = Date.now() + secs * 1000;
        ss(MKEND, String(end));
      }

      var job = null;
      var opened = false;
      var stopped = false;
      var tick = 0;

      function open() {
        if (opened) return;
        opened = true;
        clearInterval(tick);
        ss(OPEN, '1');
        if (noteEl) noteEl.hidden = true;
        var host = previewHost();
        if (!host) {
          // Rien dessous : la page de la preview s'ouvre d'elle-meme.
          var base = (root.getAttribute('data-next-page') || '').trim() || '/pages/couples-preview';
          var target = new URL(base, window.location.origin);
          target.hash = 'preview=' + job.id + '.' + job.token;
          var theme = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (theme) target.searchParams.set('preview_theme_id', theme);
          window.location.assign(target.href);
          return;
        }
        document.documentElement.removeAttribute('data-cs-duo-gate');
        if (readyEl) readyEl.hidden = false;
        // On descend jusqu'a la preview, doucement, sans rien demander. Pas
        // au retour sur une page deja ouverte : le navigateur remet deja la
        // page ou elle etait.
        if (!done) {
          setTimeout(function () { host.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250);
        }
      }

      function paint() {
        if (stopped) return;
        var left = Math.max(0, (end - Date.now()) / 1000);
        var p = done ? 100 : Math.max(0, Math.min(100, (1 - left / secs) * 100));
        // Pas de 100 % tant que la preview n'est pas lancee.
        if (!job) p = Math.min(p, 99);
        if (fillBar) fillBar.style.width = p + '%';
        if (pctEl) pctEl.textContent = Math.floor(p) + '%';
        if (clockEl) {
          // Arrondir les secondes AVANT de decouper : arrondir le reste donnait
          // « 04:60 » quand il restait 4 min 59,7 s.
          var whole = done ? 0 : Math.round(left);
          clockEl.textContent = ('0' + Math.floor(whole / 60)).slice(-2) + ':'
            + ('0' + (whole % 60)).slice(-2);
        }
        if (stageEl && stages.length) {
          var k = Math.min(stages.length - 1, Math.floor(p / (100 / stages.length)));
          if (stageEl.textContent !== stages[k]) stageEl.textContent = stages[k];
        }
        if (!job || (left > 0 && !done)) return;
        open();
      }

      paint();
      tick = setInterval(paint, 250);

      var snd = mk.querySelector('[data-cs-mk-sound]');
      if (snd && v && !snd.dataset.csWired) {
        snd.dataset.csWired = '1';
        snd.addEventListener('click', function (e) {
          e.stopPropagation();
          v.muted = false;
          v.play();
          snd.hidden = true;
        });
        mk.querySelector('.cs-flow-mk-stage').addEventListener('click', function () {
          if (v.paused) { v.play(); } else { v.pause(); }
        });
      }

      return {
        ready: function (j) { job = j; paint(); },
        stop: function () {
          stopped = true;
          clearInterval(tick);
          if (v && !v.paused) v.pause();
        }
      };
    }

    var submitting = false;
    function submit() {
      if (submitting) return;
      var data = answers();
      var url = (root.getAttribute('data-api') || '').trim();
      if (window.Shopify && window.Shopify.designMode) {
        err.textContent = 'Open the theme preview in a separate tab to test generation.';
        err.hidden = false;
        return;
      }
      if (!window.CraftStoryCouples) {
        err.textContent = 'The preview studio is still loading. Please try again.';
        err.hidden = false;
        return;
      }
      submitting = true;
      next.disabled = true;
      err.hidden = true;
      stash(data);
      rename();

      // Une nouvelle attente : rien de la precedente ne compte plus, et le
      // bas de la page se referme jusqu'a la fin de celle-ci.
      ss(MKEND, null);
      ss(WAITJOB, null);
      ss(OPEN, null);
      if (previewHost()) document.documentElement.setAttribute('data-cs-duo-gate', 'closed');

      var run = finish({ name: data.their_name, email: data.email });
      var limit = setTimeout(function () { fail(null); }, CAP);

      function fail(error) {
        clearTimeout(limit);
        if (!submitting) return;
        submitting = false;
        run.stop();
        ss(MKEND, null);
        next.disabled = false;
        nextLabel.textContent = CFG.lastLabel;
        if (mk) mk.hidden = true;
        form.hidden = false;
        root.querySelector('.cs-flow-top').hidden = false;
        // Le message du studio quand il en donne un ; jamais celui du
        // navigateur (« signal timed out », « Failed to fetch »...).
        var tech = !error || /^(TypeError|TimeoutError|AbortError)$/.test(error.name || '');
        err.textContent = (!tech && error.message) || CFG.errSend;
        err.hidden = false;
      }

      window.CraftStoryCouples.start(url, data, shots).then(function (job) {
        // Trop tard : l'attente a deja rendu la main au formulaire.
        if (!submitting) return;
        clearTimeout(limit);
        ss(WAITJOB, job.id);
        couple(job).then(function () { if (submitting) run.ready(job); });
      }).catch(fail);
    }

    next.addEventListener('click', function () {
      if (!valid(i)) return;
      if (i === last) submit(); else show(i + 1);
    });
    back.addEventListener('click', function () { if (i > 0) show(i - 1); });

    // Entree fait avancer, sauf dans une zone de texte ou elle sert a aller a la ligne.
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA') return;
      e.preventDefault();
      next.click();
    });

    // Un choix de carte sur la landing page arrive en ?occasion=… : on le coche.
    try {
      var want = new URLSearchParams(window.location.search).get('occasion');
      if (want) {
        var opts = form.querySelectorAll('input[name=occasion]');
        for (var o = 0; o < opts.length; o++) {
          if (opts[o].value.toLowerCase() === want.toLowerCase()) { opts[o].checked = true; break; }
        }
      }
    } catch (e) {}

    // Le champ libre suit les boutons de SON fieldset : rien a declarer, il
    // suffit qu'il soit au bon endroit dans le balisage.
    var more = form.querySelector('[data-cs-more]');
    if (more) {
      var moreInput = more.querySelector('input');
      var moreFor = (more.getAttribute('data-cs-more') || '').toLowerCase();
      var moreGroup = more.closest('fieldset').querySelectorAll('input[type=radio]');
      var syncMore = function () {
        var on = false;
        for (var m = 0; m < moreGroup.length; m++) {
          if (moreGroup[m].checked && moreGroup[m].value.toLowerCase() === moreFor) on = true;
        }
        more.hidden = !on;
        if (on) {
          moreInput.setAttribute('data-req', '');
        } else {
          // On vide en refermant, sinon une precision abandonnee part quand meme.
          moreInput.removeAttribute('data-req');
          moreInput.value = '';
        }
      };
      for (var m2 = 0; m2 < moreGroup.length; m2++) moreGroup[m2].addEventListener('change', syncMore);
      syncMore();
    }

    var photoEl = form.querySelector('[data-cs-photo]');
    var prevBox = form.querySelector('[data-cs-photo-prev]');
    var labelEl = form.querySelector('[data-cs-photo-label]');
    var baseLabel = labelEl ? labelEl.textContent : '';

    function paintShots() {
      if (prevBox) {
        prevBox.innerHTML = '';
        for (var n = 0; n < shots.length; n++) {
          var im = document.createElement('img');
          im.src = shots[n];
          im.alt = '';
          prevBox.appendChild(im);
        }
        prevBox.setAttribute('data-n', String(shots.length));
        prevBox.hidden = !shots.length;
      }
      if (labelEl) {
        labelEl.textContent = shots.length > 1 ? (D.phTwo || baseLabel)
          : shots.length ? (D.phOne || baseLabel) : baseLabel;
      }
      // Le champ fichier perd son obligation des qu'une photo est gardee. Il
      // faut ce detour : apres un rechargement il est toujours vide, alors que
      // la photo, elle, est encore la. Sans ca l'ecran redemanderait un
      // fichier deja fourni.
      if (photoEl) {
        if (shots.length) photoEl.removeAttribute('data-req');
        else photoEl.setAttribute('data-req', '');
      }
    }

    if (photoEl) {
      photoEl.addEventListener('change', function () {
        var picked = photoEl.files ? Array.prototype.slice.call(photoEl.files) : [];
        if (!picked.length) return;
        var over = picked.length > MAXPH;
        picked = picked.slice(0, MAXPH);

        // On repart de la selection en cours a chaque fois : un champ fichier
        // remplace son contenu, les vignettes doivent dire la meme chose.
        var got = [];
        var left = picked.length;
        picked.forEach(function (f, n) {
          shrink(f, function (url) {
            if (url) got[n] = url;
            if (--left) return;
            var keep = [];
            for (var g = 0; g < got.length; g++) if (got[g]) keep.push(got[g]);
            shots = keep;
            keepShots();
            paintShots();
            if (over && D.phMax) { err.textContent = D.phMax; err.hidden = false; }
            else { err.hidden = true; }
          });
        });
      });
      paintShots();
    }

    // « Back to the questionnaire », dans la preview : sur cette page meme,
    // c'est repartir de zero, pas recharger l'attente deja faite.
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-couples-preview] a[href]') : null;
      if (!a) return;
      var u;
      try { u = new URL(a.getAttribute('href'), window.location.href); } catch (x) { return; }
      if (u.origin !== window.location.origin || u.pathname !== window.location.pathname) return;
      e.preventDefault();
      ss(MKEND, null);
      ss(WAITJOB, null);
      ss(OPEN, null);
      ss('csCouplesPreview', null);
      ss('csCouplesRevealed', null);
      window.location.assign(window.location.pathname + window.location.search);
    });

    // Retour sur la page (rechargement, bouton retour) : l'attente reprend
    // ou elle en etait, et une page deja ouverte le reste. Seulement pour la
    // preview que CE tunnel a lancee dans cet onglet.
    var saved = null;
    try { saved = JSON.parse(ss('csCouplesPreview') || 'null'); } catch (e) {}
    document.documentElement.removeAttribute('data-cs-duo-resume');
    if (saved && saved.id && saved.token && ss(WAITJOB) === saved.id && ss(OPEN) === '1' && !previewHost()) {
      // Le tunnel seul, et sa preview deja ouverte ailleurs : retour ici = un
      // nouveau questionnaire, pas un rebond vers la page de la preview.
      ss(MKEND, null);
      ss(WAITJOB, null);
      ss(OPEN, null);
      saved = null;
    }
    if (saved && saved.id && saved.token && ss(WAITJOB) === saved.id) {
      var st = {};
      try { st = JSON.parse(ss(STORE) || '{}') || {}; } catch (e) {}
      submitting = true;
      finish({ name: st.their_name || '', email: st.email || '' }, { open: ss(OPEN) === '1' }).ready(saved);
      return;
    }

    show(0);
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var all = host.querySelectorAll('[data-cs-flow]');
    for (var i = 0; i < all.length; i++) setup(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-head"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.csDuoHeadBound) return;
  window.csDuoHeadBound = true;

  var LOCK = 'cs-head-locked';
  var lastTrigger = null;

  function root(el) { return el ? el.closest('[data-cs-head]') : null; }
  function drawer(r) { return r ? r.querySelector('[data-cs-head-drawer]') : null; }
  function panel(r) { return r ? r.querySelector('[data-cs-head-panel]') : null; }
  function toggleBtn(r) { return r ? r.querySelector('[data-cs-head-toggle]') : null; }

  function anyOpen() { return document.querySelector('[data-cs-head].cs-dhd-open'); }

  function lock(on) {
    try {
      if (on) document.documentElement.classList.add(LOCK);
      else if (!anyOpen()) document.documentElement.classList.remove(LOCK);
    } catch (e) {}
  }

  function focusable(p) {
    if (!p) return [];
    var sel = 'a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(p.querySelectorAll(sel), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function open(r, trigger) {
    if (!r || r.classList.contains('cs-dhd-open')) return;
    lastTrigger = trigger || toggleBtn(r);
    r.classList.add('cs-dhd-open');
    var d = drawer(r);
    if (d) d.removeAttribute('aria-hidden');
    var t = toggleBtn(r);
    if (t) t.setAttribute('aria-expanded', 'true');
    lock(true);
    var p = panel(r);
    if (p) { try { p.focus(); } catch (e) {} }
  }

  function close(r) {
    if (!r || !r.classList.contains('cs-dhd-open')) return;
    r.classList.remove('cs-dhd-open');
    var d = drawer(r);
    if (d) d.setAttribute('aria-hidden', 'true');
    var t = toggleBtn(r);
    if (t) t.setAttribute('aria-expanded', 'false');
    lock(false);
    var back = lastTrigger && document.contains(lastTrigger) ? lastTrigger : t;
    lastTrigger = null;
    if (back) { try { back.focus(); } catch (e) {} }
  }

  function toggleSearch(r, btn) {
    if (!r) return;
    var on = r.classList.toggle('cs-dhd-searchon');
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    var sp = r.querySelector('[data-cs-head-searchpanel]');
    if (sp) {
      if (on) sp.removeAttribute('aria-hidden');
      else sp.setAttribute('aria-hidden', 'true');
    }
    var input = sp && sp.querySelector('input[type="search"]');
    if (on && input) { try { input.focus(); } catch (e) {} }
    else if (!on && btn) { try { btn.focus(); } catch (e) {} }
  }

  // Delegated, so it survives a theme-editor re-render of the section.
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-cs-head-toggle]') : null;
    if (t) {
      e.preventDefault();
      var r = root(t);
      if (r && r.classList.contains('cs-dhd-open')) close(r); else open(r, t);
      return;
    }
    var c = e.target.closest ? e.target.closest('[data-cs-head-close]') : null;
    if (c) { e.preventDefault(); close(root(c)); return; }
    var s = e.target.closest ? e.target.closest('[data-cs-head-search]') : null;
    if (s) { e.preventDefault(); toggleSearch(root(s), s); return; }
  });

  document.addEventListener('keydown', function (e) {
    var r = anyOpen();
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (r) { e.preventDefault(); close(r); return; }
      var sr = document.querySelector('[data-cs-head].cs-dhd-searchon');
      if (sr) { sr.classList.remove('cs-dhd-searchon'); }
      return;
    }
    if (e.key !== 'Tab' || !r) return;
    var items = focusable(panel(r));
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (!panel(r).contains(active)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var stuck = (window.pageYOffset || document.documentElement.scrollTop || 0) > 4;
      Array.prototype.forEach.call(document.querySelectorAll('[data-cs-head].cs-dhd-sticky'), function (r) {
        r.classList.toggle('cs-dhd-stuck', stuck);
      });
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  document.addEventListener('shopify:section:load', function (e) {
    onScroll();
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-cs-head]') : null;
    if (r) lock(false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-hero"] && !Shopify.designMode) return;
  try {
    
/* Hero clip controller. Every node is resolved inside its own section root, so
   two hero instances on one page never touch each other's video. */
(function () {
  function init(root) {
    if (!root || root.dataset.csDhInit) { return; }
    root.dataset.csDhInit = '1';

    var stage = root.querySelector('[data-cs-dh-stage]');
    if (!stage) { return; }
    var vid = stage.querySelector('video');
    if (!vid) { return; }

    var cover = stage.querySelector('[data-cs-dh-trigger]');
    var banner = stage.querySelector('[data-cs-dh-unmute]');
    var controls = stage.querySelector('[data-cs-dh-controls]');
    var playBtn = stage.querySelector('[data-cs-dh-playbtn]');
    var playIcon = stage.querySelector('[data-cs-dh-playicon]');
    var pauseIcon = stage.querySelector('[data-cs-dh-pauseicon]');
    var muteBtn = stage.querySelector('[data-cs-dh-mutebtn]');
    var mutedIcon = stage.querySelector('[data-cs-dh-mutedicon]');
    var unmutedIcon = stage.querySelector('[data-cs-dh-unmutedicon]');
    var progress = stage.querySelector('[data-cs-dh-progress]');
    var progressFill = stage.querySelector('[data-cs-dh-progressfill]');
    var auto = stage.hasAttribute('data-cs-dh-auto');

    function inside(node, target) {
      return !!node && (node === target || node.contains(target));
    }

    /* one retry: a play() rejected by the autoplay policy usually succeeds on the
       second attempt once the tap has been registered as a user gesture */
    function play() {
      var p = vid.play();
      if (p && p.catch) {
        p.catch(function () {
          setTimeout(function () {
            var again = vid.play();
            if (again && again.catch) { again.catch(function () {}); }
          }, 60);
        });
      }
    }

    function syncPlay() {
      if (playIcon) { playIcon.style.display = vid.paused ? 'block' : 'none'; }
      if (pauseIcon) { pauseIcon.style.display = vid.paused ? 'none' : 'block'; }
      if (playBtn) { playBtn.setAttribute('aria-label', vid.paused ? 'Play video' : 'Pause video'); }
    }

    function syncMute() {
      if (mutedIcon) { mutedIcon.style.display = vid.muted ? 'block' : 'none'; }
      if (unmutedIcon) { unmutedIcon.style.display = vid.muted ? 'none' : 'block'; }
      if (muteBtn) { muteBtn.setAttribute('aria-label', vid.muted ? 'Unmute video' : 'Mute video'); }
      /* the pill comes back the moment the viewer mutes again */
      if (banner) { banner.classList.toggle('cs-dh-hidden', !vid.muted); }
    }

    function unmuteTap(e) {
      e.preventDefault();
      e.stopPropagation();
      vid.muted = false;
      syncMute();
      play();
    }

    if (banner) {
      banner.addEventListener('pointerdown', unmuteTap);
      banner.addEventListener('click', unmuteTap);
    }

    /* poster overlay, only rendered when silent autoplay is switched off */
    if (cover) {
      cover.addEventListener('click', function () {
        stage.classList.add('cs-dh-playing');
        try { vid.setAttribute('controls', ''); } catch (err) {}
        play();
        try { vid.focus(); } catch (err) {}
      });
    }

    if (!auto) {
      syncPlay();
      return;
    }

    try {
      vid.setAttribute('disableremoteplayback', '');
      vid.setAttribute('controlslist', 'noremoteplayback');
      vid.setAttribute('x-webkit-airplay', 'deny');
    } catch (err) {}

    function togglePlay() {
      if (vid.paused) {
        play();
      } else {
        vid.volume = 0; /* drop the audio buffer instantly */
        vid.pause();
        vid.volume = 1; /* restore it for the next play */
      }
    }

    /* pointerdown, not click: the clip responds on press rather than on release */
    var lastPointer = 0;
    stage.addEventListener('pointerdown', function (e) {
      var t = e.target;
      lastPointer = Date.now();

      if (inside(banner, t)) { e.preventDefault(); return; }

      if (inside(muteBtn, t)) {
        vid.muted = !vid.muted;
        syncMute();
        e.preventDefault();
        return;
      }

      if (inside(progress, t)) {
        var rect = progress.getBoundingClientRect();
        if (vid.duration && rect.width) {
          var ratio = (e.clientX - rect.left) / rect.width;
          if (ratio < 0) { ratio = 0; }
          if (ratio > 1) { ratio = 1; }
          vid.currentTime = ratio * vid.duration;
        }
        e.preventDefault();
        return;
      }

      /* play button, video surface or anywhere else on the stage: toggle */
      togglePlay();
      e.preventDefault();
    });

    /* the bar above is driven by pointerdown, which leaves the two buttons inert
       for a keyboard user; a click that no pointerdown preceded is that user */
    function keyboardOnly(fn) {
      return function (e) {
        if (Date.now() - lastPointer < 500) { return; }
        fn();
        e.preventDefault();
      };
    }
    if (playBtn) { playBtn.addEventListener('click', keyboardOnly(togglePlay)); }
    if (muteBtn) {
      muteBtn.addEventListener('click', keyboardOnly(function () {
        vid.muted = !vid.muted;
        syncMute();
      }));
    }

    vid.addEventListener('play', syncPlay);
    vid.addEventListener('pause', syncPlay);
    vid.addEventListener('timeupdate', function () {
      if (progressFill && vid.duration) {
        progressFill.style.width = (vid.currentTime / vid.duration) * 100 + '%';
      }
    });

    /* show the bar for three seconds on load, so a touch viewer who never
       hovers still learns the controls are there */
    if (controls) {
      controls.classList.add('cs-dh-visible');
      setTimeout(function () { controls.classList.remove('cs-dh-visible'); }, 3000);
    }

    syncPlay();
    syncMute();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cs-dh-root]');
    Array.prototype.forEach.call(roots, init);
    if (scope && scope.hasAttribute && scope.hasAttribute('data-cs-dh-root')) { init(scope); }
  }

  initAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function bin(root) {
    try {
      return root.getAttribute('data-cs-pop-store') === 'session' ? window.sessionStorage : window.localStorage;
    } catch (e) { return null; }
  }

  function dismissed(root) {
    var store = bin(root);
    if (!store) return false;
    var days = parseInt(root.getAttribute('data-cs-pop-days'), 10);
    if (isNaN(days)) days = 0;
    try {
      var raw = store.getItem(root.getAttribute('data-cs-pop-key'));
      if (!raw) return false;
      if (days <= 0) return true;
      var at = parseInt(raw, 10);
      if (isNaN(at)) return true;
      return (Date.now() - at) < days * 86400000;
    } catch (e) { return false; }
  }

  function remember(root) {
    var store = bin(root);
    if (!store) return;
    try { store.setItem(root.getAttribute('data-cs-pop-key'), String(Date.now())); } catch (e) {}
  }

  function setup(root) {
    if (!root || root.dataset.csPopOn === '1') return;
    if (!root.hasAttribute('data-cs-pop-live')) return;
    if (window.Shopify && window.Shopify.designMode) return;
    root.dataset.csPopOn = '1';

    var dialog = root.querySelector('[data-cs-pop-dialog]');
    if (!dialog) return;
    if (dismissed(root)) return;

    var open = false;
    var last = null;
    var timer = null;
    var done = false;

    function focusables() {
      var out = [];
      var all = dialog.querySelectorAll(FOCUSABLE);
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.offsetWidth || el.offsetHeight || el.getClientRects().length) out.push(el);
      }
      return out;
    }

    function onKey(e) {
      if (!open) return;
      var key = e.key || e.keyCode;
      if (key === 'Escape' || key === 'Esc' || key === 27) {
        e.preventDefault();
        close();
        return;
      }
      if (key !== 'Tab' && key !== 9) return;
      var list = focusables();
      if (!list.length) { e.preventDefault(); dialog.focus(); return; }
      var first = list[0];
      var lastEl = list[list.length - 1];
      var active = document.activeElement;
      if (!dialog.contains(active)) { e.preventDefault(); (e.shiftKey ? lastEl : first).focus(); return; }
      if (e.shiftKey && (active === first || active === dialog)) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && active === lastEl) { e.preventDefault(); first.focus(); }
    }

    function show() {
      if (open || done) return;
      if (dismissed(root)) { teardownTriggers(); return; }
      open = true;
      teardownTriggers();
      try { last = document.activeElement; } catch (e) { last = null; }
      root.hidden = false;
      document.documentElement.classList.add('cs-pop-lock');
      window.requestAnimationFrame(function () { root.classList.add('cs-pop-open'); });
      document.addEventListener('keydown', onKey, true);
      // Focus the dialog itself, so a screen reader announces the popup's own
      // label first instead of the close button, and Tab then walks the content.
      dialog.focus();
    }

    function close() {
      done = true;
      remember(root);
      document.removeEventListener('keydown', onKey, true);
      document.documentElement.classList.remove('cs-pop-lock');
      root.classList.remove('cs-pop-open');
      open = false;
      window.setTimeout(function () { root.hidden = true; }, 240);
      if (last && last.focus) { try { last.focus(); } catch (e) {} }
    }

    var closers = root.querySelectorAll('[data-cs-pop-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', function (e) { e.preventDefault(); close(); });

    var overlay = root.querySelector('[data-cs-pop-overlay]');
    if (overlay) overlay.addEventListener('click', function () { close(); });

    // Taking the offer counts as closing it: close() already records the dismissal and
    // releases the scroll lock. Navigation is not prevented, so a real link still opens;
    // a link that goes nowhere yet leaves a closed popup rather than a stuck one.
    var accept = root.querySelector('[data-cs-pop-accept]');
    if (accept) accept.addEventListener('click', function () { close(); });

    function onScroll() {
      var want = parseInt(root.getAttribute('data-cs-pop-scroll'), 10) || 40;
      var doc = document.documentElement;
      var reach = doc.scrollHeight - window.innerHeight;
      // A page with nothing to scroll never reaches the configured depth. Without this
      // the first (priming) call would compute 100% and open the popup immediately.
      if (reach <= 0) return;
      var pct = (window.pageYOffset || doc.scrollTop) / reach * 100;
      if (pct >= want) show();
    }

    function onOut(e) {
      if (e.relatedTarget) return;
      if (e.clientY > 0) return;
      show();
    }

    function teardownTriggers() {
      if (timer) { window.clearTimeout(timer); timer = null; }
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onOut);
    }

    var delay = (parseFloat(root.getAttribute('data-cs-pop-delay')) || 6) * 1000;
    var mode = root.getAttribute('data-cs-pop-trigger') || 'time';
    var coarse = !(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

    if (mode === 'scroll') {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else if (mode === 'exit' && !coarse) {
      document.addEventListener('mouseout', onOut);
    } else {
      timer = window.setTimeout(show, delay);
    }
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var roots = host.querySelectorAll('[data-cs-pop]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
    if (host !== document && host.matches && host.matches('[data-cs-pop]')) setup(host);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-cs-pop]')) {
      document.documentElement.classList.remove('cs-pop-lock');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-pv-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.csPvoReady) return;
    // The questionnaire refreshes this section to insert the recipient's name.
    // Remove the previous handlers before binding the refreshed section.
    if (root.csPvoCleanup) root.csPvoCleanup();
    root.dataset.csPvoReady = '1';

    // Le prenom vient des reponses mises de cote par le tunnel dans l'onglet,
    // et a defaut de ?name= pour qu'un lien partage reste lisible. Sans lui, on
    // retire le gabarit plutot que de laisser un trou dans la phrase.
    var name = '';
    try {
      var a = JSON.parse(window.sessionStorage.getItem('csDuoFlow') || '{}') || {};
      name = (a.their_name || '').trim();
    } catch (e) {}
    if (!name) {
      try { name = (new URLSearchParams(window.location.search).get('name') || '').trim(); } catch (e) {}
    }
    var tpl = root.querySelectorAll('[data-cs-tpl]');
    for (var i = 0; i < tpl.length; i++) {
      var t = tpl[i].getAttribute('data-cs-orig') || tpl[i].textContent;
      tpl[i].setAttribute('data-cs-orig', t);
      tpl[i].textContent = name
        ? t.split('{name}').join(name)
        : t.replace(/\{name\}'?s?\s*/g, '').replace(/\s+/g, ' ').trim();
      if (!tpl[i].textContent) tpl[i].hidden = true;
    }

    // Preserve the configured fallback link; configured variants use the cart.
    var base = (root.getAttribute('data-base') || '').trim();
    var gos = root.querySelectorAll('[data-cs-go]');
    var addon = root.querySelector('[data-cs-addon]');

    function link() {
      if (!base || base === '#') return;
      var speed = root.querySelector('[data-cs-speed]:checked');
      var q = [];
      if (speed) q.push('speed=' + encodeURIComponent(speed.value));
      if (addon && addon.checked) q.push('addon=' + encodeURIComponent(addon.value || '1'));
      if (name) q.push('name=' + encodeURIComponent(name));
      var url = base;
      if (q.length) url += (base.indexOf('?') > -1 ? '&' : '?') + q.join('&');
      for (var g = 0; g < gos.length; g++) gos[g].setAttribute('href', url);
    }

    var inputs = root.querySelectorAll('[data-cs-speed], [data-cs-addon]');
    for (var n = 0; n < inputs.length; n++) inputs[n].addEventListener('change', link);
    link();



    var promo = root.querySelector('[data-cs-offer-promo]');
    var offerInterval = null, offerDeadline = 0, offerKey = '', offerPreview = '';
    var offerCopy = promo ? JSON.parse(promo.querySelector('[data-cs-offer-copy]').textContent) : {};
    function storedDeadline(key) {
      try { var local = Number(localStorage.getItem(key)); if (local) return local; } catch (_) {}
      try { return Number(sessionStorage.getItem(key)) || 0; } catch (_) {}
      return 0;
    }
    function saveDeadline(key, value) {
      try { localStorage.setItem(key, String(value)); } catch (_) {}
      try { sessionStorage.setItem(key, String(value)); } catch (_) {}
    }
    function offerTick() {
      if (!promo || !offerDeadline) return;
      var seconds = Math.max(0, Math.ceil((offerDeadline - Date.now()) / 1000));
      var clock = promo.querySelector('[data-cs-offer-clock]');
      clock.textContent = Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
      var ended = seconds === 0;
      clock.hidden = ended;
      promo.querySelector('[data-cs-offer-timer]').classList.toggle('is-ended', ended);
      promo.querySelector('[data-cs-offer-heading]').textContent = ended ? offerCopy.expired_heading : offerCopy.timer_heading;
      promo.querySelector('[data-cs-offer-note]').textContent = ended ? offerCopy.expired_note : offerCopy.timer_note;
      if (ended) { clearInterval(offerInterval); offerInterval = null; }
    }
    function startOffer(id) {
      if (!promo || !/^[a-f0-9]{64}$/.test(id || '')) return;
      var minutes = Math.max(5, Math.min(60, Number(root.dataset.offerMinutes) || 30));
      var draft = window.Shopify && Shopify.theme && Shopify.theme.role !== 'main';
      var nextKey = (draft ? 'csSongOfferTestV1:' : 'csSongOfferV1:') + id;
      if (offerPreview !== id) {
        clearInterval(offerInterval); offerInterval = null;
        offerKey = nextKey; offerPreview = id;
        offerDeadline = storedDeadline(offerKey) || Date.now() + minutes * 60000;
        saveDeadline(offerKey, offerDeadline);
      }
      promo.hidden = false;
      offerTick();
      if (!offerInterval && offerDeadline > Date.now()) offerInterval = setInterval(offerTick, 1000);
    }
    function offerRevealed(e) { if (e.detail && e.detail.status === 'ready') startOffer(e.detail.id); }
    function offerStorage(e) {
      if (e.key !== offerKey || !Number(e.newValue)) return;
      offerDeadline = Math.min(offerDeadline, Number(e.newValue)); offerTick();
    }
    function resumeOffer() { if (offerPreview) startOffer(offerPreview); }
    function pauseOffer() { clearInterval(offerInterval); offerInterval = null; }
    document.addEventListener('craftstory:preview-revealed', offerRevealed);
    window.addEventListener('storage', offerStorage);
    window.addEventListener('pageshow', resumeOffer);
    window.addEventListener('pagehide', pauseOffer);
    var opened = document.querySelector('[data-couples-preview][data-view="result"][data-preview-state="ready"]');
    if (opened) startOffer(opened.dataset.previewId);
    if (promo && window.Shopify && Shopify.designMode) promo.hidden = false;

    var errEl=root.querySelector('[data-cs-cart-err]');
    function kept(key){try{return JSON.parse(window.sessionStorage.getItem(key)||'null')||{};}catch(_){return {};}}
    function properties(){
      var a=kept('csDuoFlow'),preview=kept('csCouplesPreview'),out={};
      [['For','their_name'],['From','your_name'],['Occasion','occasion'],['Song language','language'],['Genre','genre'],['Voice','voice']].forEach(function(pair){if(a[pair[1]])out[pair[0]]=String(a[pair[1]]).slice(0,250);});
      if(/^[a-f0-9]{64}$/.test(preview.id||'')){
        out['_Preview ID']=preview.id;
        if(/^[a-f0-9]{64}$/.test(preview.token||''))out['_Preview token']=preview.token;
        if(/^[a-f0-9]{64}$/.test(preview.token||''))out['_Preview link']=window.location.origin+'/pages/couples-preview#preview='+preview.id+'.'+preview.token;
      }
      var funnel=window.CraftStoryFunnel&&window.CraftStoryFunnel.sessionId();if(funnel)out['_Funnel session']=funnel;
      return out;
    }
    function checkout(e){
      var speed=root.querySelector('[data-cs-speed]:checked'),vid=speed?(speed.getAttribute('data-variant')||'').replace(/\D+/g,''):'';
      if(!vid)return;
      e.preventDefault();if(root.csPvoBusy)return;root.csPvoBusy=true;if(errEl)errEl.hidden=true;
      for(var g=0;g<gos.length;g++){gos[g].setAttribute('aria-busy','true');gos[g].setAttribute('aria-disabled','true');}
      var props=properties(),items=[{id:Number(vid),quantity:1,properties:props}];
      var aid=addon&&addon.checked?(addon.getAttribute('data-variant')||'').replace(/\D+/g,''):'';
      if(aid)items.push({id:Number(aid),quantity:1,properties:props['_Preview ID']?{'_Preview ID':props['_Preview ID']}:{}});
      var cartRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      fetch(cartRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:items})}).then(function(r){
        if(!r.ok)throw new Error('HTTP '+r.status);if(window.CraftStoryFunnel)window.CraftStoryFunnel.track('checkout_clicked',props['_Preview ID']);window.location.href=cartRoot+'checkout';
      }).catch(function(){root.csPvoBusy=false;for(var h=0;h<gos.length;h++){gos[h].removeAttribute('aria-busy');gos[h].removeAttribute('aria-disabled');}if(errEl)errEl.hidden=false;});
    }
    for(var c=0;c<gos.length;c++)gos[c].addEventListener('click',checkout);

    // La barre du bas n'apparait qu'une fois le bouton principal passe : sinon
    // elle double un bouton deja visible a l'ecran.
    var bar = root.querySelector('[data-cs-bar]');
    var main = root.querySelector('.cs-pvo-cta');
    var observer;
    if (bar && main && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (es) {
        bar.hidden = es[0].isIntersecting || es[0].boundingClientRect.top > 0;
      }, { threshold: 0 });
      observer.observe(main);
    }
    root.csPvoCleanup = function () {
      pauseOffer();
      document.removeEventListener('craftstory:preview-revealed', offerRevealed);
      window.removeEventListener('storage', offerStorage);
      window.removeEventListener('pageshow', resumeOffer);
      window.removeEventListener('pagehide', pauseOffer);
      for (var n = 0; n < inputs.length; n++) inputs[n].removeEventListener('change', link);
      for (var c = 0; c < gos.length; c++) gos[c].removeEventListener('click', checkout);
      if (observer) observer.disconnect();
    };
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var all = host.querySelectorAll('[data-cs-pvo]');
    for (var i = 0; i < all.length; i++) setup(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-pv-song"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORE = 'csDuoFlow';      // les reponses du tunnel, dans l'onglet
  var DEAL = 'csDuoDeadline';   // l'echeance du tarif
  var OPEN = 'csDuoOpenAt';     // l'echeance de l'ouverture

  function two(n) { return (n < 10 ? '0' : '') + n; }
  function mmss(s) { s = Math.max(0, Math.round(s)); return two(Math.floor(s / 60)) + ':' + two(s % 60); }

  // Ce que le tunnel a mis de cote, plus ?name= qui survit a un partage de lien.
  function answers() {
    var a = {};
    try { a = JSON.parse(window.sessionStorage.getItem(STORE) || '{}') || {}; } catch (e) {}
    var out = {
      name: a.their_name || '', you: a.your_name || '', rel: a.relationship || '',
      occasion: a.occasion_other || a.occasion || '', genre: a.genre || '', voice: a.voice || ''
    };
    try {
      var q = new URLSearchParams(window.location.search).get('name');
      if (q && !out.name) out.name = q.trim();
    } catch (e) {}
    return out;
  }

  // Un gabarit, une reponse. Mis en commun parce que les paroles des plans en
  // ont besoin exactement comme les titres : « Still choosing you, {name} »
  // doit devenir « Still choosing you, Marie », et ne rien laisser derriere
  // quand la reponse manque.
  function fillTpl(tpl, map) {
    var out = tpl, missing = false;
    for (var k in map) {
      if (out.indexOf('{' + k + '}') < 0) continue;
      if (map[k]) { out = out.split('{' + k + '}').join(map[k]); } else { missing = true; }
    }
    // Une reponse manquante : on retire le gabarit et ce qui l'entoure
    // plutot que de laisser « ('s song » ou une parenthese vide.
    if (missing) {
      out = out.replace(/\s*\([^()]*\{\w+\}[^()]*\)/g, '')
               .replace(/\{\w+\}'s\s*/g, '')
               .replace(/\{\w+\}\s*/g, '')
               .replace(/\s*,\s*,/g, ',')
               .replace(/\s{2,}/g, ' ')
               .replace(/^[\s,·]+|[\s,·]+$/g, '');
    }
    return out;
  }

  function personalise(root, map) {
    var els = root.querySelectorAll('[data-cs-tpl]');
    for (var i = 0; i < els.length; i++) {
      var tpl = els[i].getAttribute('data-cs-orig') || els[i].textContent;
      els[i].setAttribute('data-cs-orig', tpl);
      var out = fillTpl(tpl, map);
      els[i].textContent = out;
      if (!out) els[i].hidden = true;
    }
  }

  // L'attente et l'ouverture. L'echeance est posee une fois et gardee : ni un
  // rechargement ni un aller-retour ne la font repartir.
  function unlock(root) {
    var mins = parseFloat(root.getAttribute('data-bar') || '5') || 5;
    var locking = root.getAttribute('data-lock') === '1';
    var fill = root.querySelector('[data-cs-fill]');
    var pct = root.querySelector('[data-cs-pct]');
    var label = root.querySelector('[data-cs-stage]');
    var clock = root.querySelector('[data-cs-clock]');
    var ready = root.querySelector('[data-cs-ready]');
    var notice = root.querySelector('.cs-pvs-notice');

    var stages = [];
    var raw = (root.getAttribute('data-stages') || '').split('|');
    for (var i = 0; i < raw.length; i++) { if (raw[i].trim()) stages.push(raw[i].trim()); }

    var end = 0;
    try {
      end = parseInt(window.localStorage.getItem(OPEN) || '0', 10);
      if (!end || isNaN(end)) {
        end = Date.now() + mins * 60000;
        window.localStorage.setItem(OPEN, String(end));
      }
    } catch (e) { end = Date.now() + mins * 60000; }

    function open() {
      document.documentElement.setAttribute('data-cs-lock', '0');
      if (notice) notice.hidden = true;
      if (ready) ready.hidden = false;
    }

    function paint() {
      var left = Math.max(0, (end - Date.now()) / 1000);
      var p = Math.max(0, Math.min(100, (1 - left / (mins * 60)) * 100));
      if (fill) fill.style.width = p + '%';
      if (pct) pct.textContent = Math.round(p) + '%';
      if (clock) clock.textContent = mmss(left);
      if (label && stages.length) {
        var n = Math.min(stages.length - 1, Math.floor(p / (100 / stages.length)));
        if (label.textContent !== stages[n]) label.textContent = stages[n];
      }
      if (left > 0) return;
      clearInterval(id);
      open();
    }

    // Verrou eteint : l'attente a deja eu lieu sur la page du tunnel. Relancer
    // une barre a zero ici ferait croire a la personne qu'elle doit attendre
    // une seconde fois. On ouvre donc tout de suite et on retire la barre.
    if (!locking) {
      open();
      var panel2 = root.querySelector('.cs-pvs-prog');
      if (panel2) panel2.hidden = true;
      if (clock) clock.hidden = true;
      return;
    }

    document.documentElement.setAttribute('data-cs-lock', '1');
    paint();
    var id = setInterval(paint, 500);
  }

  function deal(root) {
    var mins = parseInt(root.getAttribute('data-timer') || '0', 10);
    if (!mins) return;
    var panel = root.querySelector('[data-cs-timer]');
    var big = root.querySelector('[data-cs-big]');
    var end = 0;
    try {
      end = parseInt(window.localStorage.getItem(DEAL) || '0', 10);
      if (!end || isNaN(end)) {
        end = Date.now() + mins * 60000;
        window.localStorage.setItem(DEAL, String(end));
      }
    } catch (e) { end = Date.now() + mins * 60000; }

    function tick() {
      var left = Math.max(0, (end - Date.now()) / 1000);
      if (big) big.textContent = mmss(left);
      if (left > 0) return;
      clearInterval(id);
      if (panel) {
        panel.classList.add('is-over');
        if (big) big.textContent = root.getAttribute('data-timer-end') || '';
      }
    }
    tick();
    var id = setInterval(tick, 1000);
  }

  function sound(root) {
    var v = root.querySelector('.cs-pvs-v');
    var btn = root.querySelector('[data-cs-sound]');
    var stage = root.querySelector('.cs-pvs-stage');
    if (!v) return;
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        v.muted = false;
        v.play();
        btn.hidden = true;
      });
    }
    // Sans commandes natives, le doigt sur l'image doit au moins mettre en pause.
    if (stage && btn) {
      stage.addEventListener('click', function () {
        if (v.paused) { v.play(); } else { v.pause(); }
      });
    }
  }

  // ========================================================================
  // LES TRENTE SECONDES
  //
  // Un montage, pas un fichier. La chanson donne l'heure et les plans se
  // relaient dessus : a chaque instant de coupe, le plan suivant passe devant
  // et sa parole s'inscrit. C'est la chanson qui est la source de temps, pas
  // un minuteur a cote — sinon les deux derivent et la coupe tombe a cote du
  // temps fort, ce qui se voit tout de suite.
  //
  // La duree annoncee est un PLAFOND. Le montage dure la somme de ses plans,
  // rognee a ce plafond : jamais une image figee au bout pour tenir trente
  // secondes, jamais un depassement.
  // ========================================================================
  // La table de montage livree par la generation, si elle est arrivee. Elle
  // remplace celle de l'editeur en ecrivant LES MEMES divs avec LES MEMES
  // data- : un seul chemin de code, donc ce que le marchand voit dans
  // l'editeur est exactement ce que le client verra.
  function delivered() {
    try {
      if (window.CS_DUO_TAKE && window.CS_DUO_TAKE.beats) return window.CS_DUO_TAKE;
      var kept = window.sessionStorage.getItem('csDuoTake');
      var got = kept ? JSON.parse(kept) : null;
      return (got && got.beats && got.beats.length) ? got : null;
    } catch (e) { return null; }
  }

  function take(root, map) {
    var stage = root.querySelector('[data-cs-take]');
    if (!stage) return;

    var live = delivered();
    if (live) {
      var host = stage.querySelector('[data-cs-shots]');
      host.textContent = '';
      if (live.song) stage.setAttribute('data-audio', live.song);
      if (live.seconds) stage.setAttribute('data-seconds', String(live.seconds));
      for (var d = 0; d < live.beats.length; d++) {
        var lb = live.beats[d];
        var el = document.createElement('div');
        el.className = 'cs-pvs-shot';
        el.setAttribute('data-cs-shot', '');
        el.setAttribute('data-n', String(d + 1));
        el.setAttribute('data-clip', lb.clip || '');
        el.setAttribute('data-dur', String(lb.dur || 5));
        el.setAttribute('data-drift', lb.drift || 'in');
        el.setAttribute('data-line', lb.line || '');
        if (lb.poster) el.setAttribute('data-poster', lb.poster);
        host.appendChild(el);
      }
      stage.setAttribute('data-cs-live', '1');
    }

    var raw = stage.querySelectorAll('[data-cs-shot]');
    if (!raw.length) return;

    var cover = stage.querySelector('[data-cs-tap]');
    var lyric = stage.querySelector('[data-cs-lyric]');
    var cd = stage.querySelector('[data-cs-cd]');
    var end = stage.querySelector('[data-cs-end]');
    var again = stage.querySelector('[data-cs-again]');
    var audioEl = stage.querySelector('[data-cs-audio]');
    var fill = root.querySelector('[data-cs-tlfill]');
    var marks = root.querySelector('[data-cs-marks]');
    var curEl = root.querySelector('[data-cs-cur]');
    var durEl = root.querySelector('[data-cs-dur]');

    var cut = parseFloat(stage.getAttribute('data-cut'));
    if (isNaN(cut)) cut = 360;
    stage.style.setProperty('--cs-cut', cut + 'ms');
    var cap = parseFloat(stage.getAttribute('data-seconds')) || 30;

    var beats = [];
    var at = 0;
    for (var i = 0; i < raw.length; i++) {
      if (at >= cap - 0.1) break;
      var d = parseFloat(raw[i].getAttribute('data-dur')) || 5;
      if (at + d > cap) d = cap - at;
      beats.push({ el: raw[i], at: at, dur: d, line: raw[i].getAttribute('data-line') || '' });
      at += d;
      // Les plans qui ne rentrent pas ne sont pas laisses dans le DOM a
      // charger pour rien.
      raw[i].dataset.csIn = '1';
    }
    var total = at;
    for (var z = 0; z < raw.length; z++) {
      if (!raw[z].dataset.csIn) raw[z].parentNode.removeChild(raw[z]);
    }
    if (!beats.length) return;

    // Les plans sont muets : le son vient de la piste, une fois, sinon deux
    // sources se battent et le montage sonne faux.
    for (var n = 0; n < beats.length; n++) {
      var b = beats[n];
      var src = b.el.getAttribute('data-clip');
      var ps = b.el.getAttribute('data-poster');
      var v;
      if (src) {
        v = document.createElement('video');
        v.muted = true;
        v.defaultMuted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.playsInline = true;
        v.preload = n < 2 ? 'auto' : 'none';
        if (ps) v.poster = ps;
        v.src = src;
      } else {
        // Un clip manquant tombe sur son image plutot que sur cinq secondes
        // de noir au milieu du montage. On lui donne les memes methodes que
        // la video pour que l'ordonnanceur n'ait pas a savoir la difference.
        v = document.createElement('img');
        v.alt = '';
        v.src = ps || '';
        v.muted = true;
        v.paused = true;
        v.currentTime = 0;
        v.play = function () { return null; };
        v.pause = function () {};
        v.load = function () {};
        v.preload = 'auto';
      }
      b.el.appendChild(v);
      b.v = v;
      b.el.style.setProperty('--cs-dur', b.dur + 's');
      b.line = fillTpl(b.line, map);
      if (n > 0 && marks) {
        var mk = document.createElement('b');
        mk.style.left = (b.at / total * 100) + '%';
        marks.appendChild(mk);
      }
    }

    var asrc = (stage.getAttribute('data-audio') || '').trim();
    if (audioEl && asrc) { audioEl.src = asrc; } else { audioEl = null; }

    // L'horloge. La chanson quand elle est la ; sinon celle de la page, pour
    // que le montage reste visible avant que le son existe.
    var clk = audioEl ? {
      t: function () { return audioEl.currentTime; },
      go: function () { var p = audioEl.play(); if (p && p.catch) p.catch(function () {}); },
      hold: function () { audioEl.pause(); },
      zero: function () { try { audioEl.currentTime = 0; } catch (e) {} }
    } : (function () {
      var t0 = 0, acc = 0, on = false;
      var c = {
        t: function () { return on ? acc + (Date.now() - t0) / 1000 : acc; },
        go: function () { t0 = Date.now(); on = true; },
        hold: function () { acc = c.t(); on = false; },
        zero: function () { acc = 0; t0 = Date.now(); }
      };
      return c;
    })();

    var cur = -1, playing = false, raf = 0;

    function mmssShort(sec) {
      sec = Math.max(0, Math.round(sec || 0));
      return Math.floor(sec / 60) + ':' + two(sec % 60);
    }
    if (durEl) durEl.textContent = mmssShort(total);

    // Mot a mot, dans le temps du plan : une phrase qui apparait d'un bloc ne
    // se lit pas, elle se subit.
    function say(text) {
      if (!lyric) return;
      lyric.textContent = '';
      if (!text) return;
      var words = text.split(/\s+/);
      var step = Math.min(0.1, 1.1 / Math.max(1, words.length));
      for (var w = 0; w < words.length; w++) {
        var sp = document.createElement('span');
        sp.textContent = words[w];
        sp.style.animationDelay = (w * step).toFixed(3) + 's';
        lyric.appendChild(sp);
        if (w < words.length - 1) lyric.appendChild(document.createTextNode(' '));
      }
    }

    function enter(n) {
      if (n === cur || !beats[n]) return;
      if (cur > -1 && beats[cur]) {
        beats[cur].el.classList.remove('on');
        beats[cur].v.pause();
      }
      cur = n;
      var b = beats[n];
      b.el.classList.add('on');
      try { b.v.currentTime = 0; } catch (e) {}
      var p = b.v.play();
      if (p && p.catch) p.catch(function () {});
      say(b.line);
      // Les deux suivants sont mis en route d'avance : une coupe qui attend un
      // telechargement se voit immediatement.
      for (var k = n + 1; k <= n + 2 && k < beats.length; k++) {
        if (beats[k].v.preload !== 'auto') { beats[k].v.preload = 'auto'; beats[k].v.load(); }
      }
    }

    function frame() {
      if (!playing) return;
      var t = clk.t();
      if (t >= total - 0.02) { finish(); return; }
      var n = beats.length - 1;
      for (var i = 0; i < beats.length; i++) {
        if (t < beats[i].at + beats[i].dur) { n = i; break; }
      }
      if (n !== cur) enter(n);
      if (fill) fill.style.width = (t / total * 100) + '%';
      if (cd) cd.textContent = mmssShort(total - t);
      if (curEl) curEl.textContent = mmssShort(t);
      raf = window.requestAnimationFrame(frame);
    }

    function start() {
      if (playing) return;
      playing = true;
      if (cover) cover.hidden = true;
      if (end) end.hidden = true;
      stage.classList.add('cs-on');
      stage.classList.remove('cs-hold');
      clk.go();
      // Reprendre, ce n'est pas seulement relancer la chanson : le plan en
      // cours a ete mis en pause avec elle, et enter() ne le relance pas
      // puisque son numero n'a pas change. Sans ces deux lignes, un appui pour
      // reprendre remettait le son en marche devant une image figee.
      if (cur < 0) { enter(0); } else if (beats[cur]) {
        var p = beats[cur].v.play();
        if (p && p.catch) p.catch(function () {});
      }
      raf = window.requestAnimationFrame(frame);
    }

    function hold() {
      if (!playing) return;
      playing = false;
      window.cancelAnimationFrame(raf);
      clk.hold();
      if (beats[cur]) beats[cur].v.pause();
      stage.classList.add('cs-hold');
    }

    function finish() {
      playing = false;
      window.cancelAnimationFrame(raf);
      clk.hold();
      if (beats[cur]) beats[cur].v.pause();
      stage.classList.remove('cs-hold');
      if (fill) fill.style.width = '100%';
      if (cd) cd.textContent = '0:00';
      if (curEl) curEl.textContent = mmssShort(total);
      if (lyric) lyric.textContent = '';
      // La derniere image reste : la proposition arrive dessus, pas sur du noir.
      if (end) end.hidden = false;
    }

    function replay() {
      clk.zero();
      for (var i = 0; i < beats.length; i++) {
        beats[i].el.classList.remove('on');
        beats[i].v.pause();
        try { beats[i].v.currentTime = 0; } catch (e) {}
      }
      cur = -1;
      if (fill) fill.style.width = '0%';
      playing = false;
      start();
    }

    if (cover) cover.addEventListener('click', start);
    if (again) again.addEventListener('click', replay);

    // Un appui sur l'image met en pause et reprend. On ne touche pas aux clics
    // de la carte de fin : son bouton doit partir vers l'offre.
    stage.addEventListener('click', function (e) {
      if (e.target.closest('[data-cs-end]') || e.target.closest('[data-cs-tap]')) return;
      if (playing) { hold(); } else if (end && !end.hidden) { replay(); } else { start(); }
    });

    // Onglet quitte : on met en pause. Sans ca l'horloge de la chanson
    // continue, les images non, et on revient sur un montage decale.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) hold();
    });
  }

  function setup(root) {
    if (root.dataset.csPvsReady) return;
    root.dataset.csPvsReady = '1';
    var map = answers();
    personalise(root, map);
    sound(root);
    take(root, map);
    unlock(root);
    deal(root);
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var all = host.querySelectorAll('[data-cs-pvs]');
    for (var i = 0; i < all.length; i++) setup(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Un seul clip a le son sur toute la page.
  var loud = null;

  function quiet() {
    if (!loud) return;
    loud.video.muted = true;
    loud.card.classList.remove('cs-reel-loud');
    loud = null;
  }

  function setup(rail) {
    if (rail.dataset.csReelReady) return;
    rail.dataset.csReelReady = '1';

    var cards = rail.querySelectorAll('[data-cs-reel-card]');
    if (!cards.length) return;

    // Cinquante-six MP4 charges d'un coup mettraient la page a genoux. La
    // source n'est posee que quand le clip approche de l'ecran, et retiree
    // quand il s'en eloigne pour rendre la memoire.
    var near = null;
    if ('IntersectionObserver' in window) {
      near = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var card = entries[i].target;
          var v = card.querySelector('.cs-reel-v');
          if (!v) continue;
          if (entries[i].isIntersecting) {
            if (!v.src) {
              var src = v.getAttribute('data-cs-reel-src');
              if (src) v.src = src;
            }
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
            if (loud && loud.video === v) quiet();
          }
        }
      }, { root: rail, rootMargin: '200px 0px' });
      for (var i = 0; i < cards.length; i++) near.observe(cards[i]);
    } else {
      for (var j = 0; j < cards.length; j++) {
        var v = cards[j].querySelector('.cs-reel-v');
        if (v) v.src = v.getAttribute('data-cs-reel-src') || '';
      }
    }

    // Un clic coupe ou remet le son. Le glissement ne compte pas comme un clic.
    var moved = 0;
    for (var k = 0; k < cards.length; k++) {
      (function (card) {
        var hit = card.querySelector('[data-cs-reel-hit]');
        var video = card.querySelector('.cs-reel-v');
        if (!hit || !video) return;
        hit.addEventListener('click', function (e) {
          e.preventDefault();
          if (moved > 6) return;
          if (loud && loud.video === video) { quiet(); return; }
          quiet();
          if (!video.src) {
            var src = video.getAttribute('data-cs-reel-src');
            if (src) video.src = src;
          }
          video.muted = false;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
          card.classList.add('cs-reel-loud');
          loud = { video: video, card: card };
        });
      })(cards[k]);
    }

    // Les bulles disent ou on en est. Passe une douzaine de clips elles
    // s'enroulent sur trois rangees de points minuscules : au-dela, un
    // compteur « 3 / 56 » dit la meme chose et se lit.
    var dots = rail.parentNode.querySelector('[data-cs-reel-dots]');
    var counter = null;
    if (dots && cards.length > 12) {
      dots.hidden = false;
      dots.innerHTML = '';
      dots.classList.add('cs-reel-dots--count');
      counter = document.createElement('span');
      dots.appendChild(counter);
    } else if (dots && cards.length > 1) {
      dots.hidden = false;
      dots.innerHTML = '';
      for (var d = 0; d < cards.length; d++) {
        (function (n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Video ' + (n + 1));
          b.addEventListener('click', function () {
            var c = cards[n];
            rail.scrollTo({ left: c.offsetLeft - (rail.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
          });
          dots.appendChild(b);
        })(d);
      }
    }

    function mark() {
      if (!dots || !dots.children.length) return;
      var middle = rail.scrollLeft + rail.clientWidth / 2;
      var best = 0, closest = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var gap = Math.abs(cards[i].offsetLeft + cards[i].offsetWidth / 2 - middle);
        if (gap < closest) { closest = gap; best = i; }
      }
      if (counter) {
        counter.textContent = (best + 1) + ' / ' + cards.length;
        return;
      }
      for (var j = 0; j < dots.children.length; j++) {
        dots.children[j].setAttribute('aria-current', j === best ? 'true' : 'false');
      }
    }

    // Au doigt overflow-x suffit. A la souris, rien ne bouge sans ceci.
    var down = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; captured = false; moved = 0;
      startX = e.clientX; startLeft = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      // On ne capture le pointeur qu'une fois le glissement engage. Capturer
      // des le pointerdown detourne le pointerup vers le rail : le clic n'est
      // jamais emis, et tout bouton pose sur une carte devient mort.
      if (!captured && moved > 6) {
        captured = true;
        try { rail.setPointerCapture(e.pointerId); } catch (err) {}
        rail.classList.add('cs-reel-drag');
      }
      if (captured) rail.scrollLeft = startLeft - dx;
    });
    function release() {
      if (!down) return;
      down = false; captured = false;
      rail.classList.remove('cs-reel-drag');
      window.setTimeout(function () { moved = 0; }, 0);
    }
    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('pointerleave', release);

    var timer;
    rail.addEventListener('scroll', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(mark, 60);
    }, { passive: true });
    mark();
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var rails = host.querySelectorAll('[data-cs-reel]');
    for (var i = 0; i < rails.length; i++) setup(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', quiet);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(track) {
    // En liste, il n'y a ni glissement ni bulles a gerer : le rail n'existe pas.
    var host = track.closest('.cs-duo-rev');
    if (host && host.getAttribute('data-layout') === 'list') return;
    // Ce drapeau ne doit JAMAIS reprendre le nom d'attribut des bulles :
    // track.dataset.csRevDots poserait data-cs-rev-dots sur le rail, le
    // querySelector ci-dessous trouverait le rail avant les bulles, et
    // dots.innerHTML = '' effacerait les quatre avis a chaque chargement.
    if (track.dataset.csRevReady) return;
    track.dataset.csRevReady = '1';

    var dots = track.parentNode.querySelector('[data-cs-rev-dots]');
    var cards = track.querySelectorAll('.cs-rev-card');
    if (!dots || cards.length < 2) return;

    dots.hidden = false;
    dots.innerHTML = '';

    // scrollIntoView ferait aussi defiler la page verticalement. On calcule la
    // position dans le rail pour ne bouger que lui.
    function go(n) {
      var card = cards[n];
      track.scrollTo({
        left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2,
        behavior: 'smooth'
      });
    }

    for (var i = 0; i < cards.length; i++) {
      (function (n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Review ' + (n + 1));
        b.addEventListener('click', function () { go(n); });
        dots.appendChild(b);
      })(i);
    }

    function mark() {
      var middle = track.scrollLeft + track.clientWidth / 2;
      var best = 0, closest = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var gap = Math.abs(cards[i].offsetLeft + cards[i].offsetWidth / 2 - middle);
        if (gap < closest) { closest = gap; best = i; }
      }
      for (var j = 0; j < dots.children.length; j++) {
        dots.children[j].setAttribute('aria-current', j === best ? 'true' : 'false');
      }
    }

    // Au doigt, overflow-x fait deja le travail. A la souris — donc dans
    // l'apercu de l'editeur — rien ne bouge sans ce glisser-deposer.
    var down = false, captured = false, startX = 0, startLeft = 0, moved = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; captured = false; moved = 0;
      startX = e.clientX; startLeft = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      // On ne capture le pointeur qu'une fois le glissement engage. Capturer
      // des le pointerdown detourne le pointerup vers le rail : le clic n'est
      // jamais emis, et tout bouton pose sur une carte devient mort.
      if (!captured && moved > 6) {
        captured = true;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.classList.add('cs-rev-drag');
      }
      if (captured) track.scrollLeft = startLeft - dx;
    });
    function release() {
      if (!down) return;
      down = false; captured = false;
      track.classList.remove('cs-rev-drag');
    }
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('pointerleave', release);
    // Un glissement ne doit pas se terminer en clic sur ce qu'il y a dessous.
    track.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    var timer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(mark, 60);
    }, { passive: true });
    mark();
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var rails = host.querySelectorAll('[data-cs-rev]');
    for (var i = 0; i < rails.length; i++) setup(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-totop"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.csDuoTotopBound) return;
  window.csDuoTotopBound = true;

  var GAP = 10; // breathing room between this button and any bottom-docked bar

  function reduced() {
    try {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) { return false; }
  }

  function buttons() { return document.querySelectorAll('[data-cs-tt]'); }

  function scrollTop() {
    return Math.max(0, window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
  }

  // Height of whatever CraftStory element is currently docked at the bottom of the viewport.
  function dockedHeight() {
    var h = 0;
    try {
      var bar = document.querySelector('[data-cs-dbar]');
      if (bar && bar.classList.contains('cs-dbar-on')) h = Math.max(h, bar.offsetHeight || 0);
      var sticky = document.querySelector('.cs-dct-stickywrap.cs-dct-on');
      if (sticky) h = Math.max(h, (sticky.offsetHeight || 0) + 20); // its own bottom offset
    } catch (e) {}
    return h;
  }

  function place(el, h) {
    try {
      if (h > 0) el.style.setProperty('--cs-duo-tt-lift', (h + GAP) + 'px');
      else el.style.removeProperty('--cs-duo-tt-lift'); // falls back to the safe-area inset
    } catch (e) {}
  }

  function sync() {
    var y = scrollTop();
    var h = dockedHeight();
    Array.prototype.forEach.call(buttons(), function (el) {
      var after = parseInt(el.getAttribute('data-cs-tt-after'), 10);
      if (isNaN(after)) after = 200;
      var on = el.getAttribute('data-cs-tt-force') === '1' || y > after;
      if (on) el.classList.add('cs-dtt-on');
      else el.classList.remove('cs-dtt-on');
      place(el, h);
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    var raf = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };
    raf(function () { ticking = false; sync(); });
  }

  function focusTop() {
    try {
      var target = document.querySelector('#MainContent, main, [role="main"], [data-cs-head], body');
      if (!target) return;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    } catch (e) {}
  }

  function toTop() {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: reduced() ? 'auto' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
    focusTop();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cs-tt-btn]') : null;
    if (!btn) return;
    e.preventDefault();
    toTop();
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('orientationchange', onScroll);

  // The bottom bar and the sticky button toggle a class on themselves; follow those.
  function watchDocked() {
    if (!('MutationObserver' in window)) return;
    var targets = document.querySelectorAll('[data-cs-dbar], .cs-dct-stickywrap');
    if (!targets.length) return;
    var mo = new MutationObserver(function () { sync(); });
    Array.prototype.forEach.call(targets, function (t) {
      mo.observe(t, { attributes: true, attributeFilter: ['class', 'style'] });
    });
  }

  function init() { sync(); watchDocked(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { sync(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-duo-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.csIbReady) return;
    root.dataset.csIbReady = '1';

    var track = root.querySelector('[data-cs-ib-track]');
    var dots = root.querySelector('[data-cs-ib-dots]');

    if ('IntersectionObserver' in window) {
      root.classList.add('cs-ib-anim');
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            root.classList.add('cs-ib-in');
            io.disconnect();
            return;
          }
        }
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      io.observe(root);
      // Safety net: never leave the cards hidden if the observer never fires.
      setTimeout(function () { root.classList.add('cs-ib-in'); }, 2500);
    }

    if (!track) return;
    var btns = dots ? Array.prototype.slice.call(dots.querySelectorAll('[data-cs-ib-page]')) : [];
    var prev = root.querySelector('[data-cs-ib-prev]');
    var next = root.querySelector('[data-cs-ib-next]');
    if (!btns.length && !prev && !next) return;

    var slides = Array.prototype.slice.call(track.children);
    var perPage = 2; /* matches the two-up mobile track */
    var pages = btns.length ? btns.length : Math.ceil(slides.length / perPage);
    if (pages < 2) return;

    function maxScroll() { return track.scrollWidth - track.clientWidth; }

    function edgeInset() {
      var v = parseFloat(window.getComputedStyle(track).paddingLeft);
      return v > 0 ? v : 0;
    }

    /* Scroll offset of the first card of page p — a real snap position, not a
       fraction of the maximum scroll. */
    function pageStart(p) {
      var el = slides[p * perPage];
      if (!el) return 0;
      var x = track.scrollLeft +
        (el.getBoundingClientRect().left - track.getBoundingClientRect().left) -
        edgeInset();
      return Math.max(0, Math.min(Math.round(x), maxScroll()));
    }

    function currentPage() {
      if (maxScroll() <= 4) return 0;
      var x = track.scrollLeft, best = 0, bestGap = Infinity;
      for (var p = 0; p < pages; p++) {
        var gap = Math.abs(pageStart(p) - x);
        if (gap < bestGap) { bestGap = gap; best = p; }
      }
      return best;
    }

    function sync() {
      var page = currentPage();
      var off = maxScroll() <= 4;
      for (var i = 0; i < btns.length; i++) {
        var on = i === page;
        btns[i].classList.toggle('is-active', on);
        btns[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      if (prev) prev.disabled = off || page <= 0;
      if (next) next.disabled = off || page >= pages - 1;
    }

    function go(p) {
      if (maxScroll() <= 0) return;
      if (p < 0) p = 0;
      if (p > pages - 1) p = pages - 1;
      track.scrollLeft = pageStart(p);
    }

    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () { go(i); });
    });
    if (prev) prev.addEventListener('click', function () { go(currentPage() - 1); });
    if (next) next.addEventListener('click', function () { go(currentPage() + 1); });

    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(sync, 70);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(sync, 150);
    });

    sync();
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-cs-ib]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-hero"] && !Shopify.designMode) return;
  try {
    

(function () {
  function init(root) {
    if (!root || root.dataset.csKvInit) { return; }
    root.dataset.csKvInit = '1';

    var stage = root.querySelector('[data-cs-kv-stage]');
    if (!stage) { return; }
    var vid = stage.querySelector('video');
    if (!vid) { return; }

    var cover = stage.querySelector('[data-cs-kv-trigger]');
    var banner = stage.querySelector('[data-cs-kv-unmute]');
    var controls = stage.querySelector('[data-cs-kv-controls]');
    var playBtn = stage.querySelector('[data-cs-kv-playbtn]');
    var playIcon = stage.querySelector('[data-cs-kv-playicon]');
    var pauseIcon = stage.querySelector('[data-cs-kv-pauseicon]');
    var muteBtn = stage.querySelector('[data-cs-kv-mutebtn]');
    var mutedIcon = stage.querySelector('[data-cs-kv-mutedicon]');
    var unmutedIcon = stage.querySelector('[data-cs-kv-unmutedicon]');
    var progress = stage.querySelector('[data-cs-kv-progress]');
    var progressFill = stage.querySelector('[data-cs-kv-progressfill]');
    var auto = stage.hasAttribute('data-cs-kv-auto');

    function inside(node, target) {
      return !!node && (node === target || node.contains(target));
    }

    
    function play() {
      var p = vid.play();
      if (p && p.catch) {
        p.catch(function () {
          setTimeout(function () {
            var again = vid.play();
            if (again && again.catch) { again.catch(function () {}); }
          }, 60);
        });
      }
    }

    function syncPlay() {
      if (playIcon) { playIcon.style.display = vid.paused ? 'block' : 'none'; }
      if (pauseIcon) { pauseIcon.style.display = vid.paused ? 'none' : 'block'; }
      if (playBtn) { playBtn.setAttribute('aria-label', vid.paused ? root.dataset.playLabel : root.dataset.pauseLabel); }
    }

    function syncMute() {
      if (mutedIcon) { mutedIcon.style.display = vid.muted ? 'block' : 'none'; }
      if (unmutedIcon) { unmutedIcon.style.display = vid.muted ? 'none' : 'block'; }
      if (muteBtn) { muteBtn.setAttribute('aria-label', vid.muted ? root.dataset.unmuteLabel : root.dataset.muteLabel); }
      
      if (banner) { banner.classList.toggle('cs-kv-hidden', !vid.muted); }
    }

    function unmuteTap(e) {
      e.preventDefault();
      e.stopPropagation();
      vid.muted = false;
      syncMute();
      play();
    }

    if (banner) {
      banner.addEventListener('pointerdown', unmuteTap);
      banner.addEventListener('click', unmuteTap);
    }

    
    if (cover) {
      cover.addEventListener('click', function () {
        stage.classList.add('cs-kv-playing');
        try { vid.setAttribute('controls', ''); } catch (err) {}
        play();
        try { vid.focus(); } catch (err) {}
      });
    }

    if (!auto) {
      syncPlay();
      return;
    }

    try {
      vid.setAttribute('disableremoteplayback', '');
      vid.setAttribute('controlslist', 'noremoteplayback');
      vid.setAttribute('x-webkit-airplay', 'deny');
    } catch (err) {}

    function togglePlay() {
      if (vid.paused) {
        play();
      } else {
        vid.volume = 0; 
        vid.pause();
        vid.volume = 1; 
      }
    }

    
    var lastPointer = 0;
    stage.addEventListener('pointerdown', function (e) {
      var t = e.target;
      lastPointer = Date.now();

      if (inside(banner, t)) { e.preventDefault(); return; }

      if (inside(muteBtn, t)) {
        vid.muted = !vid.muted;
        syncMute();
        e.preventDefault();
        return;
      }

      if (inside(progress, t)) {
        var rect = progress.getBoundingClientRect();
        if (vid.duration && rect.width) {
          var ratio = (e.clientX - rect.left) / rect.width;
          if (ratio < 0) { ratio = 0; }
          if (ratio > 1) { ratio = 1; }
          vid.currentTime = ratio * vid.duration;
        }
        e.preventDefault();
        return;
      }

      
      togglePlay();
      e.preventDefault();
    });

    
    function keyboardOnly(fn) {
      return function (e) {
        if (Date.now() - lastPointer < 500) { return; }
        fn();
        e.preventDefault();
      };
    }
    if (playBtn) { playBtn.addEventListener('click', keyboardOnly(togglePlay)); }
    if (muteBtn) {
      muteBtn.addEventListener('click', keyboardOnly(function () {
        vid.muted = !vid.muted;
        syncMute();
      }));
    }

    vid.addEventListener('play', syncPlay);
    vid.addEventListener('pause', syncPlay);
    vid.addEventListener('timeupdate', function () {
      if (progressFill && vid.duration) {
        progressFill.style.width = (vid.currentTime / vid.duration) * 100 + '%';
      }
    });

    
    if (controls) {
      controls.classList.add('cs-kv-visible');
      setTimeout(function () { controls.classList.remove('cs-kv-visible'); }, 3000);
    }

    syncPlay();
    syncMute();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cs-kv-root]');
    Array.prototype.forEach.call(roots, init);
    if (scope && scope.hasAttribute && scope.hasAttribute('data-cs-kv-root')) { init(scope); }
  }

  initAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-kids-portal"] && !Shopify.designMode) return;
  try {
    
(() => {
  window.createCraftStoryDemo = function (initialLibrary, config) {
    let library,
      scenario = "family";
    let generationTimer;
    const scenarios = {
      family: "Family library",
      login: "Signed out",
      empty: "No purchases",
      processing: "Film preparing",
      failed: "Production delayed",
      error: "API unavailable",
      playback_error: "Playback error",
      checkout_error: "Checkout error",
      coming_soon: "Not for sale yet",
      long_names: "Long names",
      pending: "Queued production",
    };
    const fail = (status, code) =>
      Object.assign(new Error(code), { status, code });
    const reset = (name) => {
      clearTimeout(generationTimer);
      scenario = Object.hasOwn(scenarios, name) ? name : "family";
      library = structuredClone(initialLibrary);
      library.csrfToken = "DEMO-ONLY-NOT-A-REAL-TOKEN";
      for (const child of library.children)
        for (const a of child.adventures)
          for (const e of a.episodes) {
            if (e.status === "locked")
              e.offer = {
                enabled: scenario !== "coming_soon",
                price: { amount: "29.00", currencyCode: "USD" },
                deliveryLabel: "Illustrative demo offer — no real charge",
              };
          }
      const first = library.children[0]?.adventures[0]?.episodes[0];
      if (first && ["processing", "failed", "pending"].includes(scenario))
        first.status = scenario === "pending" ? "queued" : scenario;
      if (scenario === "empty") library.children = [];
      if (scenario === "long_names") {
        library.children[0].name = "Gabriel Alexander";
        library.children[0].adventures[0].title =
          "The Extraordinary Dinosaur Adventure";
      }
    };
    reset(new URL(location.href).searchParams.get("scenario") || "family");
    return {
      scenarios,
      get scenario() {
        return scenario;
      },
      reset,
      async request(endpoint, init = {}) {
        await new Promise((resolve) => setTimeout(resolve, 150));
        if (scenario === "login") throw fail(401, "authentication_required");
        if (scenario === "error") throw fail(503, "unavailable");
        const url = new URL(endpoint, "https://demo.invalid");
        if (url.pathname === "/library") return structuredClone(library);
        if (url.pathname === "/playback") {
          if (scenario === "playback_error")
            throw fail(503, "media_unavailable");
          const child = library.children.find(
            (c) => c.id === url.searchParams.get("childId"),
          );
          const episode = child?.adventures
            .flatMap((a) => a.episodes)
            .find((e) => e.id === url.searchParams.get("episodeId"));
          if (!episode) throw fail(404, "not_found");
          if (episode.status !== "ready") throw fail(409, "movie_not_ready");
          return {
            streamUrl: config.demoMediaUrl,
            downloadUrl: config.demoMediaUrl,
            expiresAt: new Date(Date.now() + 600000).toISOString(),
          };
        }
        if (url.pathname === "/checkout") {
          if (scenario === "checkout_error")
            throw fail(503, "checkout_unavailable");
          const body = JSON.parse(init.body);
          const child = library.children.find((c) => c.id === body.childId);
          const a = child?.adventures.find((a) => a.id === body.adventureId);
          const e = a?.episodes.find((e) => e.id === body.episodeId);
          if (!e) throw fail(404, "not_found");
          if (e.status !== "locked" || !e.offer?.enabled)
            throw fail(409, "offer_unavailable");
          return { demoCheckout: true, selection: body };
        }
        throw fail(404, "not_found");
      },
      confirmPurchase(selection, onChange) {
        const child = library.children.find((c) => c.id === selection.childId);
        const e = child?.adventures
          .find((a) => a.id === selection.adventureId)
          ?.episodes.find((e) => e.id === selection.episodeId);
        if (!e || e.status !== "locked") return;
        e.status = "processing";
        delete e.offer;
        onChange();
        generationTimer = setTimeout(() => {
          e.status = "ready";
          onChange();
        }, 6000);
      },
    };
  };
})();

(() => {
  "use strict";
  const root = document.querySelector("[data-craftstory-portal]");
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = "true";
  root.classList.add("cp-root");
  const config = JSON.parse(root.querySelector("[data-config]").textContent);
  const demo =
    config.demo && window.createCraftStoryDemo
      ? window.createCraftStoryDemo(
          JSON.parse(root.querySelector("[data-demo-library]").textContent),
          config,
        )
      : null;
  const entities = {
    "&#39;": "'",
    "&quot;": '"',
    "&lt;": "<",
    "&gt;": ">",
    "&amp;": "&",
  };
  const labels = Object.fromEntries(
    Object.entries(config.labels).map(([k, v]) => [
      k,
      String(v).replace(/&#39;|&quot;|&lt;|&gt;|&amp;/g, (m) => entities[m]),
    ]),
  );
  const t = (key, values = {}) =>
    Object.entries(values).reduce(
      (s, [k, v]) => s.replaceAll(`{${k}}`, String(v)),
      labels[key] || key,
    );
  const svgPaths = {
    star: '<path d="m12 2 3 6.4 7 .9-5 4.9 1.2 6.8-6.2-3.3L5.8 21 7 14.2 2 9.3l7-.9Z"/>',
    play: '<path d="m8 4 12 8-12 8Z"/>',
    lock: '<rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3m-4 5v2"/>',
    check: '<path d="m5 12 4 4 10-10"/>',
    download: '<path d="M12 3v12m-5-5 5 5 5-5M4 15v5h16v-5"/>',
    user: '<circle cx="12" cy="7" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2Z"/>',
    help: '<circle cx="12" cy="12" r="9"/><path d="M9 9a3 3 0 0 1 6 0c0 2-3 2-3 4m0 4h.01"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    close: '<path d="m6 6 12 12M6 18 18 6"/>',
    clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    dinosaur:
      '<path d="M3 15 1 12l5 1 3-4h5l2-6 5 1v5h-3l-1 6-3 2v4h-3v-4H7v4H4v-6Z"/><path d="M19 6h.01"/>',
    superhero:
      '<path d="m12 2 9 4v6c0 5-9 10-9 10S3 17 3 12V6Z"/><path d="m8 12 3 3 5-6"/>',
    princess: '<path d="m2 7 5 4 5-7 5 7 5-4-3 13H5Z"/>',
    gift: '<rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8v13M3 12h18M12 8S10 3 7.5 4 9 8 12 8Zm0 0s2-5 4.5-4S15 8 12 8Z"/>',
    music: '<path d="M9 18V5l11-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="17" cy="16" r="3"/>',
    palette: '<path d="M12 3a9 9 0 0 0 0 18c1.7 0 2-1.3 1.3-2.3-.8-1-.2-2.7 1.3-2.7H17a4 4 0 0 0 4-4c0-5-4-9-9-9Z"/><circle cx="7.5" cy="11" r="1.2"/><circle cx="10" cy="7" r="1.2"/><circle cx="15" cy="7.5" r="1.2"/>',
    tv: '<rect x="3" y="5" width="18" height="12" rx="2"/><path d="M8 21h8M12 17v4"/>',
    copy: '<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V6a2 2 0 0 1 2-2h8"/>',
    tag: '<path d="M3 12V4h8l10 10-8 8Z"/><circle cx="7.5" cy="8.5" r="1.3"/>',
    share: '<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4"/>',
    whatsapp: '<path d="M3.5 20.5 5 16a8.5 8.5 0 1 1 3.2 3.1Z"/><path d="M9 8.5c0 3.5 2.6 6.5 6.4 6.6l1.1-1.6-2-1-1 .9a5 5 0 0 1-2.6-2.6l.9-1-1-2Z"/>',
    mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6.5 8.5 7 8.5-7"/>',
    link: '<path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1 1"/><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1-1"/>',
  };
  const icon = (name) => {
    const n = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    n.setAttribute("viewBox", "0 0 24 24");
    n.setAttribute("aria-hidden", "true");
    n.innerHTML = svgPaths[name] || svgPaths.star;
    return n;
  };
  const el = (tag, className, text) => {
    const n = document.createElement(tag);
    if (className) n.className = className;
    if (text !== undefined) n.textContent = text;
    return n;
  };
  const link = (text, href, className, glyph) => {
    const n = el("a", className);
    n.href = href;
    if (glyph) n.append(icon(glyph));
    n.append(document.createTextNode(text));
    return n;
  };
  const button = (text, className, action, glyph) => {
    const n = el("button", className);
    n.type = "button";
    if (glyph) n.append(icon(glyph));
    n.append(document.createTextNode(text));
    if (action) n.addEventListener("click", action);
    return n;
  };
  const https = (value) => {
    try {
      const u = new URL(value);
      return u.protocol === "https:" && !u.username && !u.password
        ? u.href
        : null;
    } catch {
      return null;
    }
  };
  const mediaURL = (value) => {
    if (demo && value === config.demoMediaUrl)
      return new URL(value, location.href).href;
    return https(value);
  };
  const appPath = (value) =>
    typeof value === "string" &&
    /^\/apps\/[a-zA-Z0-9_-]+(?:\/[a-zA-Z0-9_-]+)*$/.test(value)
      ? value
      : null;
  const base = appPath(config.proxyBase);
  // Portal key (#k=pk_… in the email link): opens this customer's portal without
  // the Shopify sign-in. Read once, kept on this device, removed from the address bar;
  // sent only when nobody is signed in (a signed-in customer always wins).
  // A Studio link adds keep=0: the key is used for this visit only and never saved,
  // so a team member's "My orders" does not open that family's movies later.
  const KEY_STORE = "craftstory-portal-key";
  const KEY_RE = /^pk_[A-Za-z0-9_-]{30,64}$/;
  let portalKey = null;
  let keySaved = false;
  try {
    const hash = new URLSearchParams(location.hash.slice(1));
    const k = hash.get("k");
    const visitOnly = hash.get("keep") === "0";
    if (k && KEY_RE.test(k) && visitOnly) portalKey = k;
    else if (k && KEY_RE.test(k)) localStorage.setItem(KEY_STORE, k);
    if (hash.has("k") || hash.has("keep")) {
      hash.delete("k");
      hash.delete("keep");
      const rest = hash.toString();
      history.replaceState(null, "", location.pathname + location.search + (rest ? "#" + rest : ""));
    }
    if (!portalKey) {
      const saved = localStorage.getItem(KEY_STORE);
      portalKey = saved && KEY_RE.test(saved) ? saved : null;
      keySaved = !!portalKey;
    }
  } catch {}
  const checkoutURL = (value) => {
    const safe = https(value);
    if (!safe) return null;
    const u = new URL(safe);
    return config.checkoutHosts.includes(u.hostname) ? safe : null;
  };
  const image = (url, alt, className) => {
    const img = el("img", className);
    img.alt = alt;
    img.decoding = "async";
    const safe = https(url);
    if (safe) img.src = safe;
    else img.hidden = true;
    img.addEventListener("error", () => {
      img.hidden = true;
    });
    return img;
  };
  const state = {
    library: null,
    childId: null,
    adventureId: null,
    episodeId: null,
    sequence: 0,
    timer: null,
    media: null,
    dialog: null,
    mediaLoading: false,
  };
  const main = el("main", "cp-main");
  main.id = "cp-main";
  main.tabIndex = -1;
  const sidebar = el("aside", "cp-sidebar");
  sidebar.setAttribute("aria-label", t("family_navigation"));
  const brand = link("CraftStory", "/", "cp-brand", "star");
  sidebar.append(brand);
  const navLabel = el("div", "cp-eyebrow cp-nav-label", t("my_children"));
  sidebar.append(navLabel);
  const nav = el("nav", "cp-children");
  nav.setAttribute("aria-label", t("children_and_adventures"));
  sidebar.append(nav);
  const sidebarBottom = el("div", "cp-sidebar-bottom");
  sidebarBottom.append(
    link(t("add_child"), config.createUrl, "cp-subtle-link", "plus"),
    link(t("need_help"), config.helpUrl, "cp-subtle-link", "help"),
  );
  sidebar.append(sidebarBottom);
  if (demo) {
    const tools = el("details", "cp-demo-tools");
    tools.append(el("summary", null, "Demo controls"));
    tools.append(
      el(
        "p",
        null,
        "Synthetic profiles only. Playback uses a test clip. Purchases are simulated.",
      ),
    );
    const list = el("div", "cp-demo-scenarios");
    for (const [value, label] of Object.entries(demo.scenarios))
      list.append(
        button(label, "cp-demo-option", () => {
          demo.reset(value);
          const u = new URL(location.href);
          u.searchParams.set("scenario", value);
          for (const k of ["child", "adventure", "episode"])
            u.searchParams.delete(k);
          history.replaceState(null, "", u);
          loadLibrary();
        }),
      );
    tools.append(list);
    sidebarBottom.prepend(tools);
    for (const a of [brand, ...sidebarBottom.querySelectorAll("a")])
      a.addEventListener("click", (e) => {
        e.preventDefault();
        demoDialog();
      });
  }
  root.append(link(t("skip_content"), "#cp-main", "cp-skip"), sidebar, main);
  const setNotice = (message) => {
    main.querySelector(".cp-notice")?.remove();
    if (!message) return;
    const n = el("div", "cp-notice", message);
    n.setAttribute("role", "alert");
    main.prepend(n);
  };
  const api = async (path, init = {}) => {
    if (demo) return demo.request(path, init);
    if (!base) throw new Error("unavailable");
    const keyed = !config.authenticated && portalKey;
    let url = `${base}${path}`;
    if (keyed) url += (url.includes("?") ? "&" : "?") + "key=" + encodeURIComponent(portalKey);
    const response = await fetch(url, {
      ...init,
      credentials: "same-origin",
      cache: "no-store",
      redirect: "error",
      referrerPolicy: "same-origin",
      headers: {
        Accept: "application/json",
        ...(init.body ? { "Content-Type": "application/json" } : {}),
        ...init.headers,
      },
      signal: AbortSignal.timeout(15000),
    });
    if (!response.ok) {
      let payload = {};
      try {
        payload = await response.json();
      } catch {}
      const error = new Error(payload.error || "unavailable");
      error.status = response.status;
      error.code = payload.error;
      if (keyed && response.status === 401) {
        // a revoked or expired key: forget it (if it is the saved one), the normal sign-in shows
        try { if (keySaved) localStorage.removeItem(KEY_STORE); } catch {}
        portalKey = null;
        keySaved = false;
      }
      throw error;
    }
    if (!response.headers.get("content-type")?.includes("application/json"))
      throw new Error("invalid_response");
    return response.json();
  };
  function current() {
    const child = state.library?.children.find((c) => c.id === state.childId);
    const adventure = child?.adventures.find((a) => a.id === state.adventureId);
    const episode = adventure?.episodes.find((e) => e.id === state.episodeId);
    return { child, adventure, episode };
  }
  function stopMedia() {
    state.sequence++;
    state.mediaLoading = false;
    if (state.media) {
      state.media.pause();
      state.media.removeAttribute("src");
      state.media.load();
      state.media = null;
    }
    state.dialog?.close();
  }
  function showState(type) {
    stopMedia();
    clearTimeout(state.timer);
    main.replaceChildren();
    if (config.demo) renderDemoBanner();
    const box = el("section", "cp-state");
    const content = el("div", "cp-state-content");
    const glyph = el("div", "cp-state-icon");
    glyph.append(
      icon(type === "login" ? "lock" : type === "loading" ? "star" : "play"),
    );
    content.append(glyph);
    content.append(
      el("h1", null, t(`${type}_title`)),
      el("p", null, t(`${type}_body`)),
    );
    if (type === "loading") {
      const loader = el("div", "cp-loading-bar");
      loader.setAttribute("role", "status");
      loader.setAttribute("aria-label", t("loading_title"));
      content.append(loader);
    }
    if (type === "login") {
      const signIn = demo
        ? button(
            t("sign_in"),
            "cp-btn",
            () => {
              demo.reset("family");
              loadLibrary();
            },
            "user",
          )
        : link(t("sign_in"), config.loginUrl, "cp-btn", "user");
      signIn.addEventListener("click", () => {
        try {
          const p = new URL(location.href).searchParams;
          sessionStorage.setItem(
            "craftstory-portal-return",
            JSON.stringify({
              child: p.get("child"),
              adventure: p.get("adventure"),
              episode: p.get("episode"),
            }),
          );
        } catch {}
      });
      // "My orders" without the email: order number + checkout email open the portal
      // (the backend answers the same key as the email link's #k=).
      if (!demo && base) {
        const form = el("form", "cp-find");
        form.noValidate = true;
        const field = (label, name, type, hint, auto) => {
          const wrap = el("label", null, label);
          const input = el("input");
          input.name = name;
          input.type = type;
          input.required = true;
          input.autocomplete = auto;
          if (name === "order") input.inputMode = "numeric";
          wrap.append(input);
          if (hint) wrap.append(el("small", null, hint));
          return [wrap, input];
        };
        const [orderWrap, orderInput] = field(t("order_number"), "order", "text", t("order_number_hint"), "off");
        const [emailWrap, emailInput] = field(t("email"), "email", "email", "", "email");
        const error = el("p", "cp-find-error");
        error.setAttribute("role", "alert");
        const submit = el("button", "cp-btn", t("find_button"));
        submit.type = "submit";
        form.append(el("h2", null, t("find_title")), el("p", null, t("find_body")), orderWrap, emailWrap, error, submit);
        form.addEventListener("submit", async (event) => {
          event.preventDefault();
          error.textContent = "";
          const orderNumber = orderInput.value.trim();
          const email = emailInput.value.trim();
          if (!orderNumber || !email) {
            error.textContent = t("find_not_found");
            return;
          }
          submit.disabled = true;
          try {
            const response = await fetch(`${base}/find`, {
              method: "POST",
              credentials: "same-origin",
              cache: "no-store",
              redirect: "error",
              headers: { Accept: "application/json", "Content-Type": "application/json" },
              body: JSON.stringify({ orderNumber, email }),
              signal: AbortSignal.timeout(15000),
            });
            const payload = await response.json().catch(() => ({}));
            if (!response.ok || !KEY_RE.test(payload.key || "")) {
              error.textContent = t(response.status === 404 ? "find_not_found"
                : response.status === 429 ? "find_too_many" : "find_error");
              submit.disabled = false;
              return;
            }
            try { localStorage.setItem(KEY_STORE, payload.key); keySaved = true; } catch {}
            portalKey = payload.key;
            loadLibrary();
          } catch {
            error.textContent = t("find_error");
            submit.disabled = false;
          }
        });
        content.append(form, el("p", "cp-find-or", t("or_sign_in")));
        signIn.classList.add("cp-btn-outline");
      }
      content.append(signIn);
    }
    if (type === "error")
      content.append(button(t("try_again"), "cp-btn", loadLibrary));
    if (type === "empty")
      content.append(
        link(t("create_adventure"), config.createUrl, "cp-btn", "star"),
      );
    if (type !== "loading")
      content.append(
        link(t("need_help"), config.helpUrl, "cp-subtle-link", "help"),
      );
    box.append(content);
    main.append(box);
  }
  function renderNav() {
    nav.replaceChildren();
    state.library.children.forEach((child) => {
      const group = el("section", "cp-child");
      const heading = el("h2", "cp-child-heading");
      const avatar = el("span", "cp-avatar");
      if (https(child.avatarUrl)) avatar.append(image(child.avatarUrl, ""));
      else avatar.textContent = child.name.slice(0, 1).toUpperCase();
      heading.append(avatar, document.createTextNode(child.name));
      group.append(heading);
      child.adventures.forEach((adventure) => {
        const selected =
          child.id === state.childId && adventure.id === state.adventureId;
        const b = button(
          adventure.title,
          "cp-nav-link",
          () => select(child.id, adventure.id),
          adventure.theme,
        );
        b.setAttribute("aria-current", selected ? "true" : "false");
        b.setAttribute("aria-label", `${child.name}: ${adventure.title}`);
        group.append(b);
      });
      if (!child.adventures.length)
        group.append(
          link(t("create_adventure"), config.createUrl, "cp-nav-link", "plus"),
        );
      nav.append(group);
    });
  }
  function select(childId, adventureId, episodeId, updateURL = true) {
    stopMedia();
    state.childId = childId;
    state.adventureId = adventureId;
    const adventure = state.library.children
      .find((c) => c.id === childId)
      ?.adventures.find((a) => a.id === adventureId);
    state.episodeId =
      adventure?.episodes.find((e) => e.id === episodeId)?.id ||
      adventure?.episodes.find((e) => e.status === "ready")?.id ||
      adventure?.episodes.find((e) =>
        ["queued", "processing", "failed"].includes(e.status),
      )?.id ||
      adventure?.episodes[0]?.id;
    if (updateURL) {
      const url = new URL(location.href);
      url.searchParams.set("child", childId);
      url.searchParams.set("adventure", adventureId);
      if (state.episodeId) url.searchParams.set("episode", state.episodeId);
      history.replaceState(null, "", url);
    }
    renderNav();
    renderContent();
    scheduleRefresh();
  }
  function openDialog(title, paragraph) {
    state.dialog?.remove();
    const dialog = el("dialog", "cp-dialog");
    dialog.setAttribute("aria-labelledby", "cp-dialog-title");
    const close = button("", "cp-dialog-close", () => dialog.close(), "close");
    close.setAttribute("aria-label", t("close"));
    const heading = el("h2", null, title);
    heading.id = "cp-dialog-title";
    dialog.append(close, heading, el("p", null, paragraph));
    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) {
        const b = dialog.getBoundingClientRect();
        if (
          e.clientX < b.left ||
          e.clientX > b.right ||
          e.clientY < b.top ||
          e.clientY > b.bottom
        )
          dialog.close();
      }
    });
    root.append(dialog);
    state.dialog = dialog;
    dialog.showModal();
    return dialog;
  }
  // Share the movie (WhatsApp, email, copy link, the phone's share sheet): the link opens a page
  // on craftstory.co where anyone with it can watch and download this one movie.
  function shareDialog(child, episode) {
    const d = openDialog(t("share_title", { name: child.name }), t("share_body"));
    d.classList.add("cp-share");
    const box = el("div", "cp-share-box");
    d.append(box);
    const ids = { childId: child.id, episodeId: episode.id };
    const call = (extra = {}) =>
      api("/share", {
        method: "POST",
        body: JSON.stringify({ ...ids, ...extra, csrfToken: state.library.csrfToken }),
      });
    const failed = async (error, retry) => {
      if (error.status === 401) {
        d.close();
        nav.replaceChildren();
        state.library = null;
        showState("login");
        return;
      }
      if (error.code === "invalid_csrf") await refreshLibrary();
      const p = el("p", "cp-notice", t(error.status === 429 ? "rate_limited" : "share_error"));
      p.setAttribute("role", "alert");
      box.replaceChildren(p, button(t("share_retry"), "cp-btn", retry, "share"));
    };
    const stopped = () => {
      const p = el("p", "cp-share-note", t("share_stopped"));
      p.setAttribute("role", "status");
      box.replaceChildren(p, button(t("share_again"), "cp-btn", load, "share"));
    };
    const show = (data) => {
      const url = https(data.url);
      if (!url) throw Object.assign(new Error("invalid_response"), { status: 0 });
      const message = `${data.text || data.title} ${url}`;
      const field = el("input", "cp-share-url");
      field.type = "text";
      field.readOnly = true;
      field.value = url;
      field.setAttribute("aria-label", t("share_link_label", { name: child.name }));
      field.addEventListener("focus", () => field.select());
      const copy = button(t("share_copy"), "cp-share-opt", async () => {
        let ok = false;
        try {
          await navigator.clipboard.writeText(url);
          ok = true;
        } catch {
          field.focus();
          field.setSelectionRange(0, url.length);
          try { ok = document.execCommand("copy"); } catch {}
        }
        if (ok) {
          copy.lastChild.textContent = t("share_copied");
          copy.classList.add("cp-done");
          setTimeout(() => {
            copy.lastChild.textContent = t("share_copy");
            copy.classList.remove("cp-done");
          }, 2500);
        }
      }, "link");
      const wa = link(t("share_whatsapp"), "https://wa.me/?text=" + encodeURIComponent(message),
        "cp-share-opt cp-share-wa", "whatsapp");
      wa.target = "_blank";
      wa.rel = "noopener";
      const mail = link(t("share_email"), "mailto:?subject=" + encodeURIComponent(data.title) +
        "&body=" + encodeURIComponent(`${data.text || data.title}\n\n${url}\n`), "cp-share-opt", "mail");
      const opts = el("div", "cp-share-opts");
      opts.append(wa, mail, copy);
      if (navigator.share) {
        const more = button(t("share_more"), "cp-share-opt", async () => {
          try { await navigator.share({ title: data.title, text: data.text || data.title, url }); } catch {}
        }, "share");
        opts.append(more);
      } else opts.classList.add("cp-share-three");
      const row = el("div", "cp-share-row");
      row.append(field);
      const stop = button(t("share_stop"), "cp-share-stop", async () => {
        if (!confirm(t("share_stop_confirm"))) return;
        stop.disabled = true;
        try {
          await call({ stop: true });
          stopped();
        } catch (error) {
          stop.disabled = false;
          await failed(error, load);
        }
      });
      const foot = el("p", "cp-share-note", t("share_note") + " ");
      foot.append(stop);
      box.replaceChildren(opts, row, foot);
    };
    async function load() {
      const wait = el("p", "cp-share-wait", t("share_making"));
      wait.setAttribute("role", "status");
      box.replaceChildren(wait);
      try {
        show(await call());
      } catch (error) {
        await failed(error, load);
      }
    }
    load();
  }
  function demoDialog() {
    const d = openDialog(t("demo_title"), t("demo_body"));
    d.append(button(t("continue_browsing"), "cp-btn", () => d.close()));
  }
  function renderDemoBanner() {
    const bar = el("div", "cp-preview-bar");
    bar.append(
      el("strong", null, t("preview")),
      el("span", null, t("preview_body")),
    );
    main.append(bar);
  }
  function demoPayment(selection) {
    const d = openDialog(t("demo_payment_title"), t("demo_payment_body"));
    d.append(
      button(
        t("simulate_payment"),
        "cp-btn",
        () => {
          d.close();
          demo.confirmPurchase(selection, async () => {
            await refreshLibrary();
            if (state.library)
              select(
                selection.childId,
                selection.adventureId,
                selection.episodeId,
              );
          });
        },
        "check",
      ),
    );
  }
  function unlock(episode) {
    const { child, adventure } = current();
    if (!episode.offer?.enabled) {
      setNotice(t("not_available"));
      return;
    }
    const d = openDialog(
      t("unlock_title", { number: episode.number }),
      t("saved_profile", { name: child.name }),
    );
    const summary = el("div", "cp-dialog-summary");
    summary.append(
      el("strong", null, episode.title),
      el("span", null, `${child.name} · ${adventure.title}`),
    );
    if (episode.offer.price?.amount) {
      const price = el("div", "cp-price");
      try {
        price.textContent = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: episode.offer.price.currencyCode,
        }).format(Number(episode.offer.price.amount));
      } catch {
        price.textContent = "";
      }
      summary.append(price);
    }
    if (episode.offer.deliveryLabel)
      summary.append(el("span", null, episode.offer.deliveryLabel));
    d.append(summary);
    const key = crypto.randomUUID();
    const purchase = button(
      t("continue_checkout"),
      "cp-btn",
      async () => {
        purchase.disabled = true;
        d.querySelector("[role=alert]")?.remove();
        try {
          const result = await api("/checkout", {
            method: "POST",
            body: JSON.stringify({
              childId: child.id,
              adventureId: adventure.id,
              episodeId: episode.id,
              csrfToken: state.library.csrfToken,
              idempotencyKey: key,
            }),
          });
          if (demo && result.demoCheckout) {
            d.close();
            demoPayment(result.selection);
            return;
          }
          const url = checkoutURL(result.checkoutUrl);
          if (!url) throw new Error("invalid_checkout");
          location.assign(url);
        } catch (error) {
          if (error.status === 401) {
            d.close();
            nav.replaceChildren();
            state.library = null;
            showState("login");
            return;
          }
          if (error.code === "invalid_csrf") await refreshLibrary();
          if (error.status === 409) await refreshLibrary();
          const message = el(
            "p",
            "cp-notice",
            t(
              error.status === 409
                ? "offer_changed"
                : error.status === 429
                  ? "rate_limited"
                  : "checkout_error",
            ),
          );
          message.setAttribute("role", "alert");
          d.append(message);
          purchase.disabled = false;
        }
      },
      "lock",
    );
    d.append(purchase);
  }
  async function media(action, resumeTime = 0, renewed = false) {
    if (demo && !config.demoMediaUrl) {
      demoDialog();
      return;
    }
    const { child, episode } = current();
    if (!episode || episode.status !== "ready" || state.mediaLoading) return;
    const seq = state.sequence;
    setNotice(null);
    state.mediaLoading = true;
    const controls = Array.from(main.querySelectorAll("[data-media-action]"));
    controls.forEach((b) => (b.disabled = true));
    try {
      const result = await api(
        `/playback?childId=${encodeURIComponent(child.id)}&episodeId=${encodeURIComponent(episode.id)}`,
      );
      if (seq !== state.sequence) return;
      if (action === "download") {
        const url = mediaURL(result.downloadUrl);
        if (!url) throw new Error("invalid_download");
        // Same page: the link answers "attachment", so the browser saves the file and
        // the portal stays open (a new tab sat blank until the download started).
        const a = link("", url, "");
        a.rel = "noopener noreferrer";
        a.download = "";
        a.click();
      } else {
        const url = mediaURL(result.streamUrl);
        if (!url) throw new Error("invalid_media");
        const screen = main.querySelector(".cp-screen");
        const video = el("video");
        video.controls = false;                       // our YouTube-style bar (playerBar) instead
        video.playsInline = true;
        video.preload = "metadata";
        video.setAttribute("aria-label", episode.title);
        video.src = url;
        video.addEventListener(
          "loadedmetadata",
          () => {
            if (resumeTime > 0 && Number.isFinite(video.duration))
              video.currentTime = Math.min(
                resumeTime,
                Math.max(0, video.duration - 0.1),
              );
          },
          { once: true },
        );
        video.addEventListener(
          "error",
          () => {
            if (seq !== state.sequence) return;
            if (renewed) {
              setNotice(t("playback_error"));
              return;
            }
            const at = video.currentTime || resumeTime;
            setTimeout(() => {
              if (seq === state.sequence) media("play", at, true);
            }, 0);
          },
          { once: true },
        );
        // Subtitles: one file per film from our own address (the CC choice is kept), and our own controls
        const subs = (Array.isArray(result.captions) ? result.captions : [])
          .filter((c) => typeof c?.url === "string" && c.url.startsWith("/apps/craftstory-kids/captions/"));
        if (state.media) state.media.pause();
        screen.replaceChildren(playerBar(video, subs));
        state.media = video;
        video.focus();
        await video.play().catch(() => {});
      }
    } catch (error) {
      if (seq !== state.sequence) return;
      if (error.status === 401) {
        state.library = null;
        nav.replaceChildren();
        showState("login");
      } else if (error.status === 409) {
        await refreshLibrary();
        setNotice(t("not_ready"));
      } else setNotice(t("playback_error"));
    } finally {
      if (seq === state.sequence) {
        state.mediaLoading = false;
        controls.forEach((b) => (b.disabled = false));
      }
    }
  }
  function renderContent() {
    const { child, adventure, episode } = current();
    if (!child || !adventure || !episode) {
      showState("empty");
      return;
    }
    main.replaceChildren();
    if (config.demo) renderDemoBanner();
    const top = el("header", "cp-top");
    const intro = el("div");
    intro.append(
      el("h1", null, t("greeting", { name: child.name })),
      el("p", null, adventure.title),
    );
    top.append(
      intro,
      link(
        t("my_account"),
        config.accountUrl,
        "cp-subtle-link cp-account",
        "user",
      ),
    );
    main.append(top);
    if (demo)
      top.querySelector("a").addEventListener("click", (e) => {
        e.preventDefault();
        demoDialog();
      });
    const feature = el("section", "cp-feature");
    feature.setAttribute("aria-label", t("selected_movie"));
    const screen = el("div", "cp-screen");
    screen.append(image(episode.posterUrl, episode.title));
    const details = el("div", "cp-details");
    details.append(
      el("div", "cp-episode-label", t("episode", { number: episode.number })),
      el("h2", null, episode.title),
    );
    if (episode.status === "ready") {
      const badge = el("span", "cp-ready-tag");
      badge.append(icon("play"), document.createTextNode(t("ready")));
      const play = button("", "cp-main-play", () => media("play"), "play");
      play.setAttribute(
        "aria-label",
        t("watch_title", { title: episode.title }),
      );
      play.dataset.mediaAction = "play";
      screen.append(badge, play);
      if (episode.quality)
        screen.append(el("span", "cp-quality", episode.quality));
      if (episode.durationSeconds) {
        const s = Math.round(episode.durationSeconds);
        screen.append(
          el(
            "span",
            "cp-duration",
            `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`,
          ),
        );
      }
      const owned = el("div", "cp-owned");
      owned.append(icon("check"), document.createTextNode(t("in_library")));
      details.append(
        owned,
        el(
          "p",
          null,
          episode.description || t("personalized_movie", { name: child.name }),
        ),
      );
      const watch = button(
        t("watch_movie"),
        "cp-btn",
        () => media("play"),
        "play",
      );
      watch.dataset.mediaAction = "play";
      const download = button(
        t("download_movie"),
        "cp-btn-quiet",
        () => media("download"),
        "download",
      );
      download.dataset.mediaAction = "download";
      details.append(watch);
      if (!demo)
        details.append(
          button(t("share_movie"), "cp-btn cp-btn-outline cp-share-btn",
            () => shareDialog(child, episode), "share"),
        );
      details.append(download);
    } else {
      const status =
        episode.status === "locked"
          ? "locked"
          : episode.status === "failed"
            ? "delayed"
            : "preparing";
      const overlay = el("div", "cp-screen-status");
      overlay.append(
        icon(status === "locked" ? "lock" : "clock"),
        el("strong", null, t(`${status}_title`)),
        el("p", null, t(`${status}_body`)),
      );
      screen.append(overlay);
      details.append(
        el(
          "p",
          null,
          episode.description || t("personalized_movie", { name: child.name }),
        ),
      );
      if (episode.status === "locked") {
        const b = button(
          episode.offer?.enabled ? t("unlock_episode") : t("coming_soon"),
          "cp-btn",
          () => unlock(episode),
          "lock",
        );
        if (!episode.offer?.enabled) b.disabled = true;
        details.append(b);
      } else
        details.append(
          link(t("need_help"), config.helpUrl, "cp-subtle-link", "help"),
        );
    }
    feature.append(screen, details);
    main.append(feature);
    if (episode.status === "ready" && !demo) renderGifts(child, episode);
    if (!demo) renderNext(child);
    const other = adventure.episodes.filter((e) => e.id !== episode.id);
    if (other.length) {
      const section = el("section", "cp-next");
      section.append(
        el("h2", null, t("next_adventures")),
        el(
          "p",
          null,
          t("continue_story", { name: child.name, adventure: adventure.title }),
        ),
      );
      const grid = el("div", "cp-grid");
      other.forEach((e) => {
        const card = el("article", "cp-card");
        card.dataset.status = e.status;
        const poster = el("div", "cp-card-poster");
        const img = image(e.posterUrl, e.title);
        img.loading = "lazy";
        poster.append(img);
        const badge = el("div", "cp-card-badge");
        const disc = el("span");
        disc.append(
          icon(
            e.status === "locked"
              ? "lock"
              : e.status === "ready"
                ? "play"
                : "clock",
          ),
        );
        badge.append(disc);
        poster.append(badge);
        const body = el("div", "cp-card-body");
        body.append(
          el("div", "cp-episode-label", t("episode", { number: e.number })),
          el("h3", null, e.title),
        );
        let label =
          e.status === "ready"
            ? t("watch_movie")
            : e.status === "locked"
              ? t("unlock_episode")
              : t("view_status");
        if (e.status === "locked" && !e.offer?.enabled)
          label = t("coming_soon");
        const b = button(
          label,
          "cp-btn cp-btn-outline",
          () => {
            if (e.status === "locked") unlock(e);
            else {
              select(child.id, adventure.id, e.id);
              main.focus({ preventScroll: true });
            }
          },
          e.status === "locked"
            ? "lock"
            : e.status === "ready"
              ? "play"
              : "clock",
        );
        if (e.status === "locked" && !e.offer?.enabled) b.disabled = true;
        body.append(b);
        if (["queued", "processing", "failed"].includes(e.status))
          body.append(
            el(
              "p",
              "cp-card-status",
              t(e.status === "failed" ? "delayed_title" : "preparing_title"),
            ),
          );
        card.append(poster, body);
        grid.append(card);
      });
      section.append(
        grid,
        el("p", "cp-footnote", t("saved_profile", { name: child.name })),
      );
      main.append(section);
    }
    if (episode.status === "ready") main.append(tvGuide());
  }
  // Free gifts (song + 5 coloring pages, a discount): unlocked by the parent's stars.
  // 1-3 stars: a short form for the team; 4-5: Trustpilot opens in a new tab.
  let giftsTimer = null;
  function renderGifts(child, episode) {
    clearTimeout(giftsTimer);
    const box = el("section", "cp-gifts");
    box.hidden = true;
    main.querySelector(".cp-feature")?.after(box);
    const ids = `childId=${encodeURIComponent(child.id)}&episodeId=${encodeURIComponent(episode.id)}`;
    const still = () => box.isConnected && state.childId === child.id && state.episodeId === episode.id;
    const name = child.name;
    async function load() {
      try {
        const g = await api(`/gifts?${ids}`);
        if (still()) draw(g);
      } catch {
        if (still()) box.hidden = true;
      }
    }
    function draw(g) {
      if (!g || !g.available) {
        box.hidden = true;
        return;
      }
      box.hidden = false;
      box.classList.toggle("is-locked", !g.unlocked);
      box.replaceChildren(...(g.unlocked ? unlocked(g) : locked(g)));
      clearTimeout(giftsTimer);
      if (g.unlocked && (g.coloring.status === "preparing" || g.song.status === "preparing"))
        giftsTimer = setTimeout(() => still() && load(), 10000);
    }
    async function send(stars, text, channel, control, error, submissionId) {
      control.disabled = true;
      if (error) error.textContent = "";
      try {
        const g = await api("/feedback", {
          method: "POST",
          body: JSON.stringify({ childId: child.id, episodeId: episode.id, stars, text,
            channel, submissionId, csrfToken: state.library?.csrfToken }),
        });
        if (still()) {
          draw(g);
          if (channel === "trustpilot") {
            const note = el("p", "cp-gift-note", t("gifts_trustpilot_note"));
            const again = el("a", "cp-btn-quiet", t("gifts_trustpilot_again"));
            again.href = https(g.trustpilotUrl) || "https://www.trustpilot.com/evaluate/craftstory.co";
            again.target = "_blank";
            again.rel = "noopener";
            box.prepend(note, again);
          }
          box.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      } catch {
        control.disabled = false;
        if (error) error.textContent = t("gifts_error");
        else setNotice(t("gifts_error"));
      }
    }
    // 1-3 stars: Nico's Tally form in a popup (its script loaded once, on demand)
    let tallyScript = null;
    function loadTally() {
      if (window.Tally) return Promise.resolve(window.Tally);
      tallyScript = tallyScript || new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = "https://tally.so/widgets/embed.js";
        s.async = true;
        s.onload = () => (window.Tally ? resolve(window.Tally) : reject(new Error("tally")));
        s.onerror = () => reject(new Error("tally"));
        document.head.append(s);
      });
      return tallyScript;
    }
    function locked(g) {
      const head = el("div", "cp-gift-head");
      const badge = el("span", "cp-gift-icon");
      badge.append(icon("gift"));
      const words = el("div");
      words.append(el("h2", null, t("gifts_unlock_title", { name })), el("p", null, t("gifts_unlock_body")));
      head.append(badge, words);
      const stars = el("div", "cp-stars");
      stars.setAttribute("role", "group");
      stars.setAttribute("aria-label", t("gifts_unlock_title", { name }));
      const form = el("div", "cp-gift-form");
      form.hidden = true;
      for (let n = 1; n <= 5; n++) {
        const b = button("", "cp-star", () => pick(n, b), "star");
        b.setAttribute("aria-label", t("gifts_star", { n }));
        b.addEventListener("mouseenter", () => glow(n));
        b.addEventListener("mouseleave", () => glow(0));
        stars.append(b);
      }
      function glow(n) {
        stars.querySelectorAll(".cp-star").forEach((s, i) => s.classList.toggle("on", i < (n || chosen)));
      }
      let chosen = 0;
      function pick(n, b) {
        chosen = n;
        glow(n);
        if (n >= 4) {
          // opened in the click itself, so pop-up blockers allow it
          window.open(config.trustpilotUrl || "https://www.trustpilot.com/evaluate/craftstory.co", "_blank", "noopener");
          send(n, "", "trustpilot", b);
          return;
        }
        if (g?.tally?.formId) {
          b.disabled = true;
          loadTally().then((Tally) => {
            b.disabled = false;
            Tally.openPopup(g.tally.formId, {
              layout: "modal", width: 650, overlay: true, autoClose: 2500,
              hiddenFields: g.tally.hidden || {},
              onSubmit: (payload) => send(n, "", "tally", b, error, payload && payload.id),
            });
          }).catch(() => {
            b.disabled = false;
            form.hidden = false;                  // Tally unreachable: our own short form
            form.querySelector("textarea")?.focus();
          });
          return;
        }
        form.hidden = false;
        form.querySelector("textarea")?.focus();
      }
      const area = el("textarea");
      area.rows = 4;
      area.maxLength = 2000;
      area.placeholder = t("gifts_low_placeholder");
      area.setAttribute("aria-label", t("gifts_low_body"));
      const error = el("p", "cp-gift-error");
      error.setAttribute("role", "alert");
      const submit = button(t("gifts_send"), "cp-btn", () => send(chosen, area.value, "form", submit, error), "gift");
      form.append(el("strong", null, t("gifts_low_title")), el("p", null, t("gifts_low_body")), area, error, submit);
      const tiles = el("div", "cp-gift-tiles");
      for (const [glyph, label] of [["palette", t("gifts_coloring_locked", { count: g?.coloring?.count || 3, name })], ["music", t("gifts_song_locked", { name })]]) {
        const tile = el("div", "cp-gift-tile");
        const lockMark = el("span", "cp-gift-lock");
        lockMark.append(icon("lock"));
        const art = el("img", "cp-gift-art");
        art.src = config.giftImages[glyph];
        art.alt = "";
        art.width = 600;
        art.height = 600;
        art.loading = "lazy";
        const bow = el("span", "cp-gift-bow", "🎀");
        bow.setAttribute("aria-hidden", "true");
        lockMark.append(el("span", null, t("gifts_locked_label")));
        tile.append(bow, art, el("span", "cp-gift-free", t("gifts_free_label")), el("h3", "cp-gift-card-title", label), lockMark);
        tiles.append(tile);
      }
      return [head, stars, el("p", "cp-gift-hint", t("gifts_tap_star")), form, tiles];
    }
    function wrapping(g) {
      const total = (g.coloring.count || 3) + (g.song.count || 2);
      const done = Math.min(total, g.coloring.pages.length + g.song.tracks.length);
      const box = el("div", "cp-wrapping");
      box.setAttribute("role", "status");
      const art = el("div", "cp-wrap-art");
      art.append(icon("gift"));
      for (let i = 0; i < 4; i++) art.append(el("i", "cp-spark"));
      const words = el("div", "cp-wrap-words");
      const bar = el("div", "cp-wrap-bar");
      const fill = el("span");
      fill.style.width = `${Math.max(6, Math.round((done * 100) / total))}%`;
      bar.append(fill);
      words.append(el("strong", null, t("gifts_wrapping", { name })), el("p", null, t("gifts_wrapping_body")),
        bar, el("small", null, t("gifts_wrapping_count", { done, total })));
      box.append(art, words);
      return box;
    }
    function skeletonPage() {
      const card = el("figure", "cp-page cp-skel");
      card.setAttribute("aria-hidden", "true");
      card.append(el("div", "cp-skel-img"), el("div", "cp-skel-line"));
      return card;
    }
    function skeletonTrack() {
      const row = el("div", "cp-track cp-skel");
      row.setAttribute("aria-hidden", "true");
      const body = el("div", "cp-track-body");
      body.append(el("div", "cp-skel-line"), el("div", "cp-skel-line cp-skel-wide"));
      row.append(el("div", "cp-skel-cover"), body);
      return row;
    }
    function waitingNote(status) {
      return el("p", "cp-gift-note", t(status === "failed" ? "gifts_failed" : "gifts_preparing", { name }));
    }
    function unlocked(g) {
      const out = [];
      const thanks = el("div", "cp-gift-thanks");
      thanks.append(icon("gift"), el("strong", null, t("gifts_thanks", { name })));
      out.push(thanks);
      const making = g.coloring.status === "preparing" || g.song.status === "preparing";
      if (making) out.push(wrapping(g));
      // coloring pages
      const color = el("article", "cp-gift");
      const ch = el("div", "cp-gift-title");
      ch.append(icon("palette"), el("h3", null, t("gifts_coloring_title", { name, count: g.coloring.count || 3 })));
      color.append(ch, el("p", null, t("gifts_coloring_body")));
      if (g.coloring.pages.length || g.coloring.status === "preparing") {
        const grid = el("div", "cp-pages");
        grid.style.setProperty("--n", String(Math.max(1, g.coloring.count || 3)));   // one row: as many columns as pages
        for (const p of g.coloring.pages) {
          const card = el("figure", "cp-page");
          const img = image(p.imageUrl, p.title);
          img.loading = "lazy";
          const dl = el("a", "cp-page-dl");
          if (https(p.downloadUrl)) dl.href = https(p.downloadUrl);
          dl.setAttribute("download", "");
          dl.append(icon("download"), document.createTextNode(t("gifts_download_page")));
          card.append(img, el("figcaption", null, p.title), dl);
          grid.append(card);
        }
        if (g.coloring.status === "preparing")
          for (let i = g.coloring.pages.length; i < (g.coloring.count || 3); i++) grid.append(skeletonPage());
        color.append(grid);
      }
      if (g.coloring.status === "failed") color.append(waitingNote("failed"));
      if (https(g.coloring.pdfUrl)) color.append(link(t("gifts_download_all"), https(g.coloring.pdfUrl), "cp-btn", "download"));
      out.push(color);
      // the song
      const song = el("article", "cp-gift");
      const sh = el("div", "cp-gift-title");
      sh.append(icon("music"), el("h3", null, t("gifts_song_title", { name })));
      song.append(sh, el("p", null, t("gifts_song_body", { name })));
      g.song.tracks.forEach((tr, i) => {
        const row = el("div", "cp-track");
        if (https(tr.coverUrl)) {
          const cover = image(tr.coverUrl, "");
          cover.className = "cp-track-cover";
          row.append(cover);
        }
        const body = el("div", "cp-track-body");
        body.append(el("strong", null, `${tr.title} · ${tr.style || t("gifts_version", { n: i + 1 })}`));
        const audio = el("audio");
        audio.controls = true;
        audio.preload = "none";
        if (https(tr.streamUrl)) audio.src = https(tr.streamUrl);
        body.append(audio);
        if (https(tr.downloadUrl)) body.append(link(t("gifts_download_song"), https(tr.downloadUrl), "cp-btn-quiet cp-track-dl", "download"));
        row.append(body);
        song.append(row);
      });
      if (g.song.status === "preparing")
        for (let i = g.song.tracks.length; i < (g.song.count || 2); i++) song.append(skeletonTrack());
      if (g.song.status === "failed") song.append(waitingNote("failed"));
      out.push(song);
      // the discount
      if (g.discount?.code && !main.querySelector(".cp-nextadv:not([hidden])")) {
        const offer = el("article", "cp-gift cp-offer");
        const oh = el("div", "cp-gift-title");
        oh.append(icon("tag"), el("h3", null, t("gifts_discount_title", { percent: g.discount.percent })));
        const code = el("code", "cp-code", g.discount.code);
        const copy = button(t("gifts_copy"), "cp-btn cp-btn-outline", async () => {
          try {
            await navigator.clipboard.writeText(g.discount.code);
            copy.lastChild.textContent = t("gifts_copied");
          } catch {}
        }, "copy");
        const row = el("div", "cp-code-row");
        row.append(code, copy);
        offer.append(oh, el("p", null, t("gifts_discount_body", { name })), row);
        if (https(g.discount.url)) offer.append(link(t("gifts_choose_next"), https(g.discount.url), "cp-btn"));
        out.push(offer);
      }
      return out;
    }
    load();
  }
  function tvGuide() {
    const section = el("section", "cp-tv");
    const head = el("div", "cp-gift-title");
    head.append(icon("tv"), el("h2", null, t("tv_title")));
    section.append(head, el("p", "cp-tv-lead", t("tv_body")));
    const grid = el("div", "cp-tv-grid");
    for (const key of ["airplay", "cast", "usb", "hdmi"]) {
      const card = el("article", "cp-tv-card");
      const src = https(config.tvImages?.[key] ? new URL(config.tvImages[key], location.href).href : "");
      if (src) {
        const img = image(src, t(`tv_${key}_title`));
        img.loading = "lazy";
        card.append(img);
      }
      const body = el("div", "cp-tv-body");
      body.append(el("h3", null, t(`tv_${key}_title`)), el("p", "cp-tv-sub", t(`tv_${key}_sub`)));
      const steps = el("ol");
      t(`tv_${key}_steps`).split("|").forEach((s) => steps.append(el("li", null, s)));
      body.append(steps);
      card.append(body);
      grid.append(card);
    }
    section.append(grid, el("p", "cp-footnote", t("tv_help")));
    return section;
  }
  // YouTube-style controls over the movie (Sohail/Nico, 29 Oct: "controls in front like YouTube, not behind
  // a button"): play, seek, time, sound, CC, full screen; hidden while the movie plays, back on touch/mouse.
  function svgI(d) {
    const s = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    s.setAttribute("viewBox", "0 0 24 24"); s.setAttribute("aria-hidden", "true");
    const p = document.createElementNS("http://www.w3.org/2000/svg", "path"); p.setAttribute("d", d); s.append(p);
    return s;
  }
  const PI = {
    play: "M8 5v14l11-7z", pause: "M6 5h4v14H6zM14 5h4v14h-4z",
    vol: "M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0014 8v8a4.5 4.5 0 002.5-4zM14 3.2v2.1a7 7 0 010 13.4v2.1a9 9 0 000-17.6z",
    mute: "M3 9v6h4l5 5V4L7 9H3zm18.4 1.4-1.4-1.4-2.6 2.6-2.6-2.6-1.4 1.4 2.6 2.6-2.6 2.6 1.4 1.4 2.6-2.6 2.6 2.6 1.4-1.4-2.6-2.6z",
    full: "M4 4h6v2H6v4H4zm10 0h6v6h-2V6h-4zM4 14h2v4h4v2H4zm14 0h2v6h-6v-2h4z",
    exit: "M8 4h2v6H4V8h4zm6 0h2v4h4v2h-6zM4 14h6v6H8v-4H4zm10 0h6v2h-4v4h-2z",
    gear: "M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.64-.07-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.49.49 0 00-.59-.22l-2.39.96a7 7 0 00-1.62-.94l-.36-2.54a.48.48 0 00-.48-.41h-3.84a.48.48 0 00-.47.41l-.36 2.54a7 7 0 00-1.62.94l-2.39-.96a.48.48 0 00-.59.22L2.74 8.87a.47.47 0 00.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54a7 7 0 001.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32a.48.48 0 00-.12-.61zM12 15.6A3.6 3.6 0 1112 8.4a3.6 3.6 0 010 7.2z",
    pip: "M19 7h-8v6h8V7zm2-4H3a2 2 0 00-2 2v14a2 2 0 002 2h18a2 2 0 002-2V5a2 2 0 00-2-2zm0 16H3V5h18v14z",
    down: "M12 16l-5-5 1.4-1.4 2.6 2.6V4h2v8.2l2.6-2.6L17 11zM5 18h14v2H5z",
  };
  function playerBar(video, subs) {
    const wrap = el("div", "cp-player");
    wrap.tabIndex = -1;
    let on = false;
    try { on = localStorage.getItem("cs.subtitles") === "on"; } catch { /* private mode */ }
    for (const c of subs) {
      const tr = document.createElement("track");
      tr.kind = "subtitles"; tr.srclang = c.lang || "en"; tr.label = c.label || "English"; tr.src = c.url;
      video.append(tr);
    }
    const btn = (cls, label) => { const b = el("button", "cp-pb " + cls); b.type = "button"; b.setAttribute("aria-label", label); return b; };
    const big = btn("cp-pb-big", t("pl_play")); big.append(svgI(PI.play));
    const play = btn("cp-pb-play", t("pl_play"));
    const vol = btn("cp-pb-vol", t("pl_mute"));
    const time = el("span", "cp-pb-time", "0:00 / 0:00");
    const cc = subs.length ? btn("cp-pb-cc", t("subs_label")) : null;
    if (cc) cc.append(el("span", "cp-pb-ccbox", "CC"));
    const full = btn("cp-pb-full", t("pl_full"));
    // Settings (what the browser's ⋮ menu had): speed, picture in picture, download
    const gear = btn("cp-pb-gear", t("pl_settings")); gear.append(svgI(PI.gear));
    gear.setAttribute("aria-haspopup", "menu"); gear.setAttribute("aria-expanded", "false");
    const menu = el("div", "cp-pmenu"); menu.hidden = true; menu.setAttribute("role", "menu");
    const speeds = el("div", "cp-pm-speeds");
    const speedBtns = [0.5, 0.75, 1, 1.25, 1.5, 2].map((r) => {
      const b = el("button", "cp-pm-speed", r === 1 ? "1×" : `${r}×`);
      if (r === 1) b.setAttribute("aria-label", t("pl_normal"));
      b.type = "button"; b.dataset.rate = String(r);
      b.addEventListener("click", () => { video.playbackRate = r; markSpeed(); closeMenu(); });
      return b;
    });
    speeds.append(...speedBtns);
    const markSpeed = () => speedBtns.forEach((b) => b.setAttribute("aria-pressed", String(Number(b.dataset.rate) === video.playbackRate)));
    const item = (icon, label, fn) => { const b = el("button", "cp-pm-item"); b.type = "button"; b.setAttribute("role", "menuitem");
      b.append(svgI(icon), el("span", null, label)); b.addEventListener("click", () => { closeMenu(); fn(); }); return b; };
    menu.append(el("div", "cp-pm-h", t("pl_speed")), speeds);
    if (document.pictureInPictureEnabled && !video.disablePictureInPicture)
      menu.append(item(PI.pip, t("pl_pip"), () => (document.pictureInPictureElement ? document.exitPictureInPicture() : video.requestPictureInPicture()).catch(() => {})));
    menu.append(item(PI.down, t("pl_download"), () => media("download")));
    const closeMenu = () => { menu.hidden = true; gear.setAttribute("aria-expanded", "false"); };
    gear.addEventListener("click", (e) => {
      e.stopPropagation(); menu.hidden = !menu.hidden; gear.setAttribute("aria-expanded", String(!menu.hidden)); markSpeed(); showBar();
    });
    document.addEventListener("click", (e) => { if (!menu.hidden && !menu.contains(e.target)) closeMenu(); });
    menu.addEventListener("keydown", (e) => { if (e.key === "Escape") { closeMenu(); gear.focus(); } });
    const seek = el("input", "cp-pb-seek");
    seek.type = "range"; seek.min = "0"; seek.max = "1000"; seek.step = "1"; seek.value = "0";
    seek.setAttribute("aria-label", t("pl_seek"));
    const bar = el("div", "cp-pbar");
    const row = el("div", "cp-pb-row");
    row.append(...[play, vol, time, el("span", "cp-pb-gap"), cc, gear, full].filter(Boolean));
    bar.append(seek, row);
    const fmt = (x) => { x = Math.max(0, Math.floor(x || 0)); return `${Math.floor(x / 60)}:${String(x % 60).padStart(2, "0")}`; };
    let dragging = false, idleTimer = null;
    const isFull = () => document.fullscreenElement === wrap || document.webkitFullscreenElement === wrap;
    // Subtitles drawn by us (sized to the player, always above the bar); the browser only reads the file
    const cap = el("div", "cp-cap");
    cap.setAttribute("aria-live", "off");
    let nativeFull = false;                            // iPhone's own full-screen player shows its own subtitles
    const trackMode = () => { for (const tt of video.textTracks) tt.mode = !on ? "disabled" : nativeFull ? "showing" : "hidden"; };
    const showCue = () => {
      const lines = [];
      for (const tt of video.textTracks) for (const cue of Array.from(tt.activeCues || [])) lines.push(cue.text);
      cap.textContent = on && !nativeFull ? lines.join("\n") : "";
      cap.hidden = !cap.textContent;
    };
    wrap.append(video, cap, big, bar, menu);
    const paint = () => {
      const paused = video.paused || video.ended;
      play.replaceChildren(svgI(paused ? PI.play : PI.pause));
      play.setAttribute("aria-label", t(paused ? "pl_play" : "pl_pause"));
      big.hidden = !paused;
      vol.replaceChildren(svgI(video.muted || video.volume === 0 ? PI.mute : PI.vol));
      vol.setAttribute("aria-label", t(video.muted ? "pl_unmute" : "pl_mute"));
      full.replaceChildren(svgI(isFull() ? PI.exit : PI.full));
      full.setAttribute("aria-label", t(isFull() ? "pl_exit_full" : "pl_full"));
      if (cc) { cc.setAttribute("aria-pressed", String(on)); trackMode(); showCue(); }
      const d = video.duration;
      time.textContent = `${fmt(video.currentTime)} / ${fmt(Number.isFinite(d) ? d : 0)}`;
      if (!dragging && Number.isFinite(d) && d > 0) seek.value = String(Math.round(1000 * video.currentTime / d));
      seek.style.setProperty("--pct", `${seek.value / 10}%`);
    };
    const showBar = () => {
      wrap.classList.remove("is-idle"); clearTimeout(idleTimer);
      if (!video.paused) idleTimer = setTimeout(() => { if (menu.hidden) wrap.classList.add("is-idle"); else showBar(); }, 2600);
    };
    const toggle = () => { if (video.paused || video.ended) video.play().catch(() => {}); else video.pause(); };
    const goFull = () => {
      if (isFull()) { (document.exitFullscreen || document.webkitExitFullscreen)?.call(document); return; }
      if (wrap.requestFullscreen) wrap.requestFullscreen().catch(() => video.webkitEnterFullscreen?.());
      else if (wrap.webkitRequestFullscreen) wrap.webkitRequestFullscreen();
      else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();   // iPhone: the phone's own player
    };
    big.addEventListener("click", () => { toggle(); showBar(); });
    play.addEventListener("click", () => { toggle(); showBar(); });
    vol.addEventListener("click", () => { video.muted = !video.muted; paint(); showBar(); });
    full.addEventListener("click", () => { goFull(); showBar(); });
    if (cc) cc.addEventListener("click", () => {
      on = !on;
      try { localStorage.setItem("cs.subtitles", on ? "on" : "off"); } catch { /* private mode */ }
      paint(); showBar();
    });
    video.addEventListener("pointerup", (e) => {      // a touch first shows the bar, a click plays/pauses
      if (e.pointerType === "touch" && wrap.classList.contains("is-idle")) { showBar(); return; }
      toggle(); showBar();
    });
    seek.addEventListener("input", () => {
      dragging = true;
      const d = video.duration;
      if (Number.isFinite(d)) time.textContent = `${fmt(d * seek.value / 1000)} / ${fmt(d)}`;
      seek.style.setProperty("--pct", `${seek.value / 10}%`); showBar();
    });
    seek.addEventListener("change", () => {
      const d = video.duration;
      if (Number.isFinite(d)) video.currentTime = d * seek.value / 1000;
      dragging = false; paint();
    });
    wrap.addEventListener("pointermove", showBar);
    wrap.addEventListener("keydown", (e) => {
      if (e.target === seek && (e.key === "ArrowLeft" || e.key === "ArrowRight")) return;
      const k = e.key.toLowerCase();
      if (k === " " || k === "k") { if (e.target.tagName === "BUTTON") return; toggle(); }
      else if (k === "f") goFull();
      else if (k === "m") video.muted = !video.muted;
      else if (k === "c" && cc) cc.click();
      else if (k === "arrowright") video.currentTime = Math.min(video.duration || 0, video.currentTime + 5);
      else if (k === "arrowleft") video.currentTime = Math.max(0, video.currentTime - 5);
      else return;
      e.preventDefault(); paint(); showBar();
    });
    for (const ev of ["play", "pause", "ended", "timeupdate", "durationchange", "loadedmetadata", "volumechange"])
      video.addEventListener(ev, paint);
    for (const tt of video.textTracks) tt.addEventListener("cuechange", showCue);
    for (const tr of video.querySelectorAll("track")) tr.addEventListener("load", showCue);
    video.addEventListener("webkitbeginfullscreen", () => { nativeFull = true; trackMode(); showCue(); });
    video.addEventListener("webkitendfullscreen", () => { nativeFull = false; trackMode(); showCue(); });
    video.addEventListener("play", showBar);
    video.addEventListener("pause", showBar);
    document.addEventListener("fullscreenchange", paint);
    document.addEventListener("webkitfullscreenchange", paint);
    paint();
    return wrap;
  }
  // Next adventures (Nico, 15 Oct): the adventures this child does not have, -30% applied,
  // HD or Standard; for the same child one click (name + stored photo), for another child
  // a first name and a photo (checked by the backend); then cart and checkout with the code.
  function renderNext(child) {
    const box = el("section", "cp-nextadv");
    box.hidden = true;
    (main.querySelector(".cp-gifts") || main.querySelector(".cp-feature"))?.after(box);
    const money = (v) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(v);
    api(`/next-adventures?childId=${encodeURIComponent(child.id)}`).then((o) => {
      if (!box.isConnected || !o?.adventures?.length) return;
      const head = el("div", "cp-nextadv-head");
      const words = el("div");
      words.append(el("h2", null, t("next_title", { name: o.childName || child.name })),
        el("p", null, t("next_body", { name: o.childName || child.name })));
      head.append(words);
      let banner = null;
      if (o.discount) {
        banner = el("div", "cp-nextadv-banner");
        const big = el("div", "cp-nextadv-big", t("next_banner_big", { percent: o.discount.percent }));
        const txt = el("div", "cp-nextadv-btxt");
        const bolt = el("span", "cp-nextadv-bolt", "⚡ " + t("next_banner_express"));
        txt.append(el("strong", null, t("next_banner_title", { percent: o.discount.percent, name: o.childName || child.name })),
          bolt, el("span", null, t("next_banner_body", { code: o.discount.code })));
        const gift = el("span", "cp-nextadv-gift");
        gift.append(icon("gift"));
        banner.append(gift, big, txt);
      }
      const grid = el("div", "cp-nextadv-grid");
      grid.dataset.n = String(Math.min(4, o.adventures.length));
      for (const a of o.adventures) {
        const card = el("article", "cp-nextadv-card");
        const pic = el("div", "cp-nextadv-pic");
        const poster = config.posters?.[a.handle] ? new URL(config.posters[a.handle], location.href).href : null;
        if (https(poster || a.image)) {
          const img = image(https(poster || a.image), a.title);
          img.loading = "lazy";
          pic.append(img);
        }
        if (o.discount) pic.append(el("span", "cp-nextadv-badge", t("next_badge", { percent: o.discount.percent })));
        const body = el("div", "cp-nextadv-body");
        body.append(el("h3", null, a.title), el("p", "cp-nextadv-express", "⚡ " + t("next_express")));
        for (const opt of a.options) {
          const b = el("button", "cp-btn cp-nextadv-buy");
          b.type = "button";
          const label = el("span", "cp-nextadv-q", t("next_buy"));
          const price = el("span", "cp-nextadv-price");
          if (opt.discounted < opt.price) price.append(el("s", null, money(opt.price)), document.createTextNode(" "));
          price.append(el("strong", null, money(opt.discounted)));
          b.append(label, price);
          b.addEventListener("click", () => chooseChild(o, a, opt, child));
          body.append(b);
        }
        card.append(pic, body);
        grid.append(card);
      }
      box.replaceChildren(...[head, banner, grid].filter(Boolean));
      box.hidden = false;
      main.querySelector(".cp-gifts .cp-offer")?.remove();
      if (o.discount) stickyOffer(box, o.discount.percent, o.childName || child.name);
    }).catch(() => {});
  }
  // Sticky -30% bar (Nico, 27 Oct): while the movie choice is off screen, a bar at the bottom
  // offers the discount; a tap scrolls to the choice. One bar per page (another child replaces it).
  let stickyWatch = null;
  function stickyOffer(box, percent, name) {
    document.querySelector(".cp-sticky30")?.remove();
    stickyWatch?.disconnect();
    const bar = el("div", "cp-sticky30");
    const btn = el("button", "cp-sticky30-btn");
    btn.type = "button";
    const txt = el("span", "cp-sticky30-txt");
    txt.append(el("strong", null, t("sticky_title", { percent, name })), el("span", null, t("sticky_sub")));
    const cta = el("span", "cp-sticky30-cta", t("sticky_cta"));
    cta.append(el("span", "cp-sticky30-arrow", "→"));
    btn.append(el("span", "cp-sticky30-pct", "-" + percent + "%"), txt, cta);
    btn.addEventListener("click", () => {
      const still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      box.scrollIntoView({ behavior: still ? "auto" : "smooth", block: "start" });
    });
    bar.append(btn);
    document.body.append(bar);
    if (!("IntersectionObserver" in window)) { bar.classList.add("is-on"); return; }
    // The chat button (Qstomy, bottom right) moves up above the bar while both would overlap;
    // an open chat window is left where it is.
    const sized = new WeakSet();
    const chatFix = () => {
      const on = bar.isConnected && bar.classList.contains("is-on");
      const b = btn.getBoundingClientRect();
      document.querySelectorAll("iframe.qstomy-iframe").forEach((f) => {
        if (!sized.has(f) && "ResizeObserver" in window) { sized.add(f); new ResizeObserver(chatFix).observe(f); }
        const r = f.getBoundingClientRect();
        const small = f.offsetHeight > 0 && f.offsetHeight <= 120;
        if (on && small && r.left < b.right && r.right > b.left) {
          f.style.setProperty("bottom", Math.round(window.innerHeight - b.top + 6) + "px", "important");
        } else if (!on || !small) {
          f.style.removeProperty("bottom");
        }
      });
    };
    window.addEventListener("resize", chatFix);
    setTimeout(chatFix, 3000);                         // the chat button arrives after the page
    // hidden only while the movie cards fill the upper part of the screen (peeking at the bottom: shown)
    stickyWatch = new IntersectionObserver(([e]) => {
      if (!box.isConnected) { bar.remove(); stickyWatch.disconnect(); chatFix(); return; }
      bar.classList.toggle("is-on", !e.isIntersecting);
      setTimeout(chatFix, 300);                        // after the bar has slid in or out
    }, { rootMargin: "0px 0px -40% 0px" });
    stickyWatch.observe(box.querySelector(".cp-nextadv-grid") || box);
  }
  function photoData(file) {
    // the photo as a JPEG data URL, at most 1600 px (what the backend checks and keeps)
    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.onload = () => {
        const k = Math.min(1, 1600 / Math.max(img.width, img.height));
        const c = document.createElement("canvas");
        c.width = Math.round(img.width * k);
        c.height = Math.round(img.height * k);
        c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        resolve(c.toDataURL("image/jpeg", 0.9));
      };
      img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("photo")); };
      img.src = url;
    });
  }
  function chooseChild(o, adventure, opt, child) {
    const name = o.childName || child.name;
    const dialog = openDialog(t("who_title"), t("who_body", { adventure: adventure.title }));
    const form = el("form", "cp-who");
    const choice = (value, text, checked, disabled) => {
      const row = el("label", "cp-who-choice");
      const r = el("input");
      r.type = "radio"; r.name = "cp-who"; r.value = value; r.checked = checked; r.disabled = !!disabled;
      row.append(r, el("span", null, text));
      return row;
    };
    const same = !!o.photoUrl;
    const other = el("div", "cp-who-other");
    other.hidden = same;
    const nameIn = el("input");
    nameIn.type = "text"; nameIn.maxLength = 40; nameIn.autocomplete = "off";
    const fileIn = el("input");
    fileIn.type = "file"; fileIn.accept = "image/jpeg,image/png,image/webp,image/heic";
    const consent = el("input");
    consent.type = "checkbox";
    const lab = (text, input) => { const l = el("label", "cp-who-field"); l.append(el("span", null, text), input); return l; };
    const consentRow = el("label", "cp-who-consent");
    consentRow.append(consent, el("span", null, t("other_consent")));
    // the product page's upload box: a dashed square that shows the chosen photo
    const upload = el("label", "cp-up");
    const upTitle = el("span", "cp-up-t", t("other_photo_title") + " ");
    upTitle.append(el("span", "cp-req", "*"));
    fileIn.className = "cp-up-input";
    const drop = el("span", "cp-up-drop");
    const upIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    upIcon.setAttribute("viewBox", "0 0 24 24");
    upIcon.setAttribute("aria-hidden", "true");
    upIcon.innerHTML = '<path d="M12 16V4M8 8l4-4 4 4" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2"/>';
    const upLabel = el("b", null, t("other_add_photo"));
    const thumb = el("img", "cp-up-thumb");
    thumb.alt = "";
    thumb.hidden = true;
    drop.append(upIcon, upLabel, thumb);
    upload.append(upTitle, fileIn, drop, el("small", "cp-up-hint", t("other_photo_hint")));
    fileIn.addEventListener("change", () => {
      const f = fileIn.files?.[0];
      if (thumb.src) URL.revokeObjectURL(thumb.src);
      if (f) {
        thumb.src = URL.createObjectURL(f);
        thumb.hidden = false;
        upIcon.style.display = "none";
        upLabel.textContent = t("other_change_photo");
        drop.classList.add("has-photo");
      } else {
        thumb.hidden = true;
        upIcon.style.display = "";
        upLabel.textContent = t("other_add_photo");
        drop.classList.remove("has-photo");
      }
    });
    other.append(lab(t("other_name"), nameIn), upload, consentRow);
    const error = el("p", "cp-gift-error");
    error.setAttribute("role", "alert");
    const go = el("button", "cp-btn");
    go.type = "submit";
    go.textContent = t("next_continue");
    form.append(choice("same", t("who_same", { name }), same, !same), choice("other", t("who_other"), !same), other, error, go);
    form.addEventListener("change", () => { other.hidden = form.elements["cp-who"].value !== "other"; });
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      error.textContent = "";
      const forOther = form.elements["cp-who"].value === "other";
      let childName = name, photo = o.photoUrl;
      if (forOther) {
        childName = nameIn.value.trim();
        if (!childName) { error.textContent = t("next_need_name"); return; }
        if (!fileIn.files?.[0]) { error.textContent = t("next_need_photo"); return; }
        if (!consent.checked) { error.textContent = t("next_need_consent"); return; }
      }
      go.disabled = true;
      try {
        if (forOther) {
          go.textContent = t("next_checking");
          const r = await api("/child-photo", { method: "POST",
            body: JSON.stringify({ image: await photoData(fileIn.files[0]), csrfToken: state.library?.csrfToken }) });
          photo = r.photoUrl;
        }
        go.textContent = t("next_opening");
        const props = { "Child's first name": childName, "Photo 1": photo, "Photo consent": "Yes",
          "Language": "English", "_cs_kids_resolution": opt.quality, "_Source": "portal next adventure",
          "_Express delivery": "Free - 30 minutes (portal offer)" };
        const added = await fetch("/cart/add.js", { method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(opt.variantId), quantity: 1, properties: props }] }) });
        if (!added.ok) throw new Error("cart");
        location.href = o.discount ? `/discount/${encodeURIComponent(o.discount.code)}?redirect=/checkout` : "/checkout";
      } catch (ex) {
        go.disabled = false;
        go.textContent = t("next_continue");
        error.textContent = ex && (ex.status === 422 || ex.status === 400) ? t("next_bad_photo") : t("next_error");
      }
    });
    dialog.append(form);
  }
  function normalize(data) {
    if (data?.version !== 1 || !Array.isArray(data.children))
      throw new Error("invalid_library");
    const id = (value) =>
      typeof value === "string" && value.length > 0 && value.length <= 160;
    for (const c of data.children) {
      if (
        !id(c.id) ||
        typeof c.name !== "string" ||
        !Array.isArray(c.adventures)
      )
        throw new Error("invalid_child");
      for (const a of c.adventures) {
        if (
          !id(a.id) ||
          typeof a.title !== "string" ||
          !Array.isArray(a.episodes)
        )
          throw new Error("invalid_adventure");
        for (const e of a.episodes) {
          if (
            !id(e.id) ||
            typeof e.title !== "string" ||
            !["ready", "locked", "queued", "processing", "failed"].includes(
              e.status,
            ) ||
            !Number.isInteger(e.number)
          )
            throw new Error("invalid_episode");
        }
      }
    }
    return data;
  }
  function scheduleRefresh() {
    clearTimeout(state.timer);
    if (demo || document.hidden || !state.library) return;
    if (
      !state.library.children.some((c) =>
        c.adventures.some((a) =>
          a.episodes.some((e) => ["queued", "processing"].includes(e.status)),
        ),
      )
    )
      return;
    state.timer = setTimeout(refreshLibrary, 20000);
  }
  async function refreshLibrary() {
    if (document.hidden) return;
    try {
      const data = normalize(await api("/library"));
      if (!state.library) return;
      if (
        JSON.stringify(data.children) !== JSON.stringify(state.library.children)
      ) {
        const active = current();
        state.library = data;
        const child =
          data.children.find((c) => c.id === active.child?.id) ||
          data.children.find((c) => c.adventures.length);
        const adventure =
          child?.adventures.find((a) => a.id === active.adventure?.id) ||
          child?.adventures[0];
        const episode = adventure?.episodes.find(
          (e) => e.id === active.episode?.id,
        );
        if (!child || !adventure) {
          nav.replaceChildren();
          showState("empty");
          return;
        }
        if (
          state.media &&
          !state.media.paused &&
          child.id === active.child?.id &&
          adventure.id === active.adventure?.id &&
          episode?.status === "ready"
        ) {
          renderNav();
        } else select(child.id, adventure.id, episode?.id, false);
      } else state.library.csrfToken = data.csrfToken;
    } catch (error) {
      if (error.status === 401) {
        state.library = null;
        nav.replaceChildren();
        showState("login");
        return;
      }
    }
    scheduleRefresh();
  }
  async function loadLibrary() {
    showState("loading");
    nav.replaceChildren();
    if (!config.demo && !config.authenticated && !portalKey) {
      showState("login");
      return;
    }
    try {
      state.library = normalize(await api("/library"));
      if (!state.library.children.length) {
        showState("empty");
        return;
      }
      const params = new URL(location.href).searchParams;
      try {
        const saved = JSON.parse(
          sessionStorage.getItem("craftstory-portal-return") || "null",
        );
        if (saved && !params.has("child"))
          for (const k of ["child", "adventure", "episode"])
            if (saved[k]) params.set(k, saved[k]);
        sessionStorage.removeItem("craftstory-portal-return");
      } catch {}
      const child =
        state.library.children.find((c) => c.id === params.get("child")) ||
        state.library.children.find((c) => c.adventures.length) ||
        state.library.children[0];
      const adventure =
        child.adventures.find((a) => a.id === params.get("adventure")) ||
        child.adventures[0];
      if (!adventure) {
        renderNav();
        showState("empty");
        return;
      }
      select(child.id, adventure.id, params.get("episode"), false);
      if (
        (params.get("child") && params.get("child") !== child.id) ||
        (params.get("adventure") && params.get("adventure") !== adventure.id) ||
        (params.get("episode") && params.get("episode") !== state.episodeId)
      )
        setNotice(t("missing_selection"));
      scheduleRefresh();
    } catch (error) {
      showState(error.status === 401 ? "login" : "error");
    }
  }
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) clearTimeout(state.timer);
    else if (state.library) refreshLibrary();
  });
  window.addEventListener("pagehide", () => {
    clearTimeout(state.timer);
    stopMedia();
  });
  loadLibrary();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs-review-carousel')) {
  customElements.define('cs-review-carousel', class extends HTMLElement {
    static selectedBlocks = new Map();
    connectedCallback() {
      this.editorController?.abort();
      this.editorController = new AbortController();
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', event => {
          const sectionId = event.detail?.sectionId;
          if (sectionId && sectionId !== this.dataset.reviewSectionId) return;
          const card = event.target.closest?.('[data-review-card]');
          if (!sectionId && (!card || !this.contains(card))) return;
          const blockId = card?.dataset.reviewBlockId || event.detail?.blockId;
          if (!blockId) return;
          this.constructor.selectedBlocks.set(this.dataset.reviewSectionId, String(blockId));
          this.showSelectedBlock();
        }, { capture: true, signal: this.editorController.signal });
      }
      this.frame = requestAnimationFrame(() => this.setup());
    }
    showSelectedBlock() {
      if (!window.Shopify?.designMode) return;
      const selectedId = this.constructor.selectedBlocks.get(this.dataset.reviewSectionId);
      if (!selectedId) return;
      const track = this.querySelector('[data-review-track]');
      const card = [...this.querySelectorAll('[data-review-card]')].find(item => {
        const id = item.dataset.reviewBlockId;
        return id && (selectedId === id || selectedId.endsWith('__' + id));
      });
      if (track && card) track.scrollTo({ left: Math.max(0, card.offsetLeft - 2), behavior: 'instant' });
    }
    setup() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('[data-review-track]');
      const cards = [...this.querySelectorAll('[data-review-card]')];
      const controls = this.querySelector('[data-review-controls]');
      const previous = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      const page = this.querySelector('[data-review-page]');
      if (!track || !cards.length) return;
      let index = 0;
      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        index = cards.reduce((best, card, i) => Math.abs(Math.min(Math.max(0, card.offsetLeft - 2), maxScroll) - track.scrollLeft) < Math.abs(Math.min(Math.max(0, cards[best].offsetLeft - 2), maxScroll) - track.scrollLeft) ? i : best, 0);
        controls.hidden = cards.length < 2 || track.scrollWidth <= track.clientWidth + 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        page.textContent = `${index + 1} / ${cards.length}`;
      };
      const go = i => track.scrollTo({ left: cards[Math.max(0, Math.min(cards.length - 1, i))].offsetLeft - 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      previous.addEventListener('click', () => go(index - 1), options);
      next.addEventListener('click', () => go(index + 1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      let drag = null;
      track.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || event.button !== 0 || event.target.closest('button,a,input')) return;
        drag = { id: event.pointerId, x: event.clientX, left: track.scrollLeft, target: track.scrollLeft, moved: false };
        track.setPointerCapture(event.pointerId);
        track.focus({ preventScroll: true });
        event.preventDefault();
      }, options);
      track.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        if (Math.abs(event.clientX - drag.x) > 4) drag.moved = true;
        if (!drag.moved) return;
        track.classList.add('is-dragging');
        drag.target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, drag.left + drag.x - event.clientX));
        track.scrollLeft = drag.target;
        event.preventDefault();
      }, options);
      const finishDrag = event => {
        if (!drag || event.pointerId !== drag.id) return;
        const moved = drag.moved;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const destination = cards.reduce((best, card, i) => Math.abs(Math.min(Math.max(0, card.offsetLeft - 2), maxScroll) - drag.target) < Math.abs(Math.min(Math.max(0, cards[best].offsetLeft - 2), maxScroll) - drag.target) ? i : best, 0);
        drag = null;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        if (moved) requestAnimationFrame(() => go(destination));
      };
      track.addEventListener('pointerup', finishDrag, options);
      track.addEventListener('pointercancel', finishDrag, options);
      track.addEventListener('dragstart', event => event.preventDefault(), options);
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); go(index + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(index - 1); }
        if (event.key === 'Home') { event.preventDefault(); go(0); }
        if (event.key === 'End') { event.preventDefault(); go(cards.length - 1); }
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      this.showSelectedBlock();
      update();
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.editorController?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
